<template>
  <focus-trap active tabindex="0">
    <!-- eslint-disable max-len -->
    <div class="progressScreenContents">
      <h1 id="dialog-title" style="position: absolute; opacity: 0">
        Rewards Path
      </h1>

      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1024 768"
        enable-background="new 0 0 1024 768"
        xml:space="preserve"
        style="position: absolute; top: 0; left: 0;  z-index: 2;"
      >
        <g alt="Start" id="start">
          <path
            fill="#3F8334"
            d="M140.9,47.2l-2.2-1.2L98.5,35.2c-13.9-3.7-27-2-39.5,5.2S38.5,58.1,34.8,72c-3.7,13.9-2,27,5.2,39.5
          c7.2,12.4,17.8,20.5,31.6,24.2l39.4,10.5l2.6,0.2c2.2,0,4.2-0.3,6.2-1c6.4-2.2,10.9-7.5,13.4-15.8c7.7-27.6,12.9-47.6,15.9-60.2
          c1.6-7.1,0.4-13.1-3.8-18.1C144.1,49.7,142.6,48.3,140.9,47.2z"
          />
          <path
            fill="#231F20"
            d="M151.7,77.2c0.5-1,0.8-1.7,0.9-2.2l1.2-4.6c0.1-0.6,0.2-1.5,0.1-2.5c-0.1-1.3-0.1-2.1-0.1-2.4
          c0.1-1.6,0.1-3.2-0.1-4.8c-0.1-2.2-0.2-3.8-0.6-4.8c-0.2-0.6-0.6-1.3-1.3-2c-0.8-0.9-1.4-1.6-1.6-1.9c-0.2-0.3-0.6-1.1-1.1-2.2
          c-0.4-0.9-0.8-1.6-1.1-2c-1.3-1.5-2.5-2.6-3.5-3.4c-0.9-0.7-2.3-1.4-4.2-2.3c0,0-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.2-0.2,0.2
          c-0.8-0.2-1.6-0.5-2.4-1c-0.8-0.4-1.6-0.7-2.4-0.9c-0.8-0.2-1.7-0.5-2.5-0.9c-0.8-0.4-1.6-0.7-2.5-0.9c-1.7-0.4-3.4-0.8-5.1-1.2
          c-1.7-0.4-3.4-0.8-5.1-1.3c-0.8-0.2-1.7-0.3-2.6-0.3c-0.9,0-1.8-0.1-2.7-0.3c-0.8-0.2-1.6-0.5-2.5-0.9c-0.8-0.3-1.6-0.6-2.5-0.8
          c-1.7-0.4-3.4-0.8-5.1-1.2c-1.7-0.4-3.4-0.8-5.1-1.3c-0.4-0.1-1.2-0.4-2.5-0.8c-1-0.4-1.8-0.6-2.4-0.7c-0.6-0.1-2.3-0.2-5.2-0.4
          c-0.5,0-1.4-0.2-2.6-0.5c-1.1-0.3-2-0.4-2.6-0.4c-0.6,0-1.4,0.2-2.5,0.5c-1.2,0.3-2.1,0.5-2.6,0.5c-0.4,0.1-1.3,0.1-2.6,0.1
          c-1.1,0-2,0.1-2.6,0.2c-0.7,0.1-1.5,0.4-2.5,0.7c-1.5,0.5-2.3,0.8-2.5,0.9c-2.3,0.5-3.9,1-5,1.4c-0.6,0.2-1.4,0.7-2.3,1.2
          c-1.1,0.7-1.8,1.2-2.2,1.3c-2.4,1.2-3.9,2-4.6,2.5c-0.5,0.3-1.2,0.9-2,1.6c-0.9,0.9-1.6,1.5-1.9,1.8c-1.9,1.4-3.2,2.5-4.1,3.2
          c-0.3,0.3-0.9,0.9-1.9,1.7c-0.8,0.7-1.5,1.2-1.9,1.8c-0.8,0.9-1.8,2.2-3.2,4.1c-0.1,0.2-0.7,0.8-1.7,2c-0.7,0.8-1.2,1.6-1.5,2.2
          c-0.3,0.5-0.7,1.3-1.1,2.3c-0.4,1.3-0.8,2.1-1,2.5c-0.2,0.5-0.6,1.3-1.2,2.3c-0.5,0.9-0.8,1.7-1.1,2.4c-0.2,0.6-0.3,1.4-0.4,2.5
          c-0.1,1.3-0.2,2.2-0.4,2.7c-0.1,0.5-0.5,1.3-1.1,2.4c-0.5,1-0.9,1.8-1,2.4c-0.1,0.6-0.1,1.5-0.1,2.6c0,1.3,0,2.1-0.1,2.6
          c0,0-0.1,0.9-0.2,2.6c-0.1,1.1-0.1,1.9-0.1,2.6c0,2.3,0,4.1,0.1,5.2c0.2,1.9,0.5,3.6,0.8,5.2c0.1,0.6,0.5,1.4,1,2.4
          c0.6,1.1,1,1.9,1.1,2.4c0.1,0.4,0.3,1.2,0.6,2.5c0.2,1.1,0.5,1.9,0.7,2.5c0.9,2.1,1.6,3.7,2.1,4.8c0.5,1,1.4,2.5,2.7,4.4
          c0.3,0.4,0.7,1.2,1.2,2.3c0.5,1,0.9,1.8,1.3,2.2c0.7,0.9,2,2.1,3.7,3.7c1.6,1.7,2.8,2.9,3.7,3.7c0.2,0.2,0.8,0.8,1.9,1.8
          c0.8,0.7,1.4,1.3,2,1.7c0.5,0.4,1.3,0.8,2.3,1.3c1.2,0.5,2,0.9,2.4,1.2c1.8,1.1,3.3,2,4.5,2.6c0.3,0.1,1.9,0.7,4.9,1.8
          c0.3,0.1,1.1,0.5,2.4,1.1c1,0.4,1.8,0.7,2.4,0.9c0.8,0.2,1.7,0.4,2.5,0.5c0.8,0.1,1.7,0.3,2.5,0.5c1.7,0.4,3.3,0.9,5,1.4l4.9,1.3
          c0.8,0.2,1.7,0.4,2.5,0.4c0.9,0.1,1.7,0.2,2.6,0.4c0.8,0.2,1.6,0.5,2.4,0.9c0.8,0.3,1.6,0.6,2.4,0.8c1.6,0.4,3.3,0.9,4.9,1.4
          c0.8,0.2,1.6,0.6,2.4,0.9c0.8,0.4,1.6,0.7,2.4,0.9c0.8,0.2,1.7,0.3,2.6,0.2c0.9-0.1,1.8,0,2.6,0.2c0,0,0,0.1-0.1,0.2
          c0,0.2,0,0.3,0.1,0.3c1.9,0.4,3.6,0.5,5.2,0.4c0.6,0,1.4-0.2,2.4-0.6c0.6-0.2,1.4-0.5,2.6-0.9c0.5-0.2,1.4-0.4,2.5-0.6
          c1-0.2,1.9-0.6,2.5-0.9c1.8-1,3.2-2.1,4.2-3.2c0.8-0.7,1.8-2.1,3.2-4.2c0.6-0.9,1.4-2.4,2.4-4.6c0.3-0.6,0.8-2.2,1.6-5l0.8,0.2
          c0.1-0.2,0.7-2.5,1.9-6.9c0.5-2.3,0.9-4.2,1.2-5.5c0.1-0.6,0.2-1.5,0.4-2.7c0.1-1.3,0.2-2.3,0.4-2.9c0.9-2.3,1.5-4.1,1.8-5.4
          c0.1-0.5,0.3-1.2,0.4-2.3c0.2-1,0.3-1.8,0.5-2.4c0.1-0.5,0.5-1.2,1-2.2c0.5-1,0.9-1.7,1-2.2c0.1-0.5,0.3-1.2,0.4-2.3
          c0.1-1.1,0.3-1.9,0.5-2.4c0.7-2,1.2-3.6,1.4-4.6c0.1-0.5,0.2-1.3,0.3-2.4c0.1-1.1,0.2-1.9,0.3-2.4l1.3-4.6
          C150.9,79,151.2,78.2,151.7,77.2 M132.4,48.1l5,1.4c0.4,0.2,1.7,1.5,3.9,3.9c1.1,1.1,2.1,2.6,2.9,4.4c0.2,0.5,0.6,1.3,1.1,2.4
          c0.4,1,0.7,1.9,0.7,2.8c0.1,1.6-0.1,3.5-0.5,5.5c-0.1,0.5-0.4,1.3-0.8,2.3c-0.5,1.1-0.8,1.9-0.9,2.5c-0.1,0.5-0.1,1.4-0.1,2.5
          c0,1.2,0,2.1-0.2,2.7c-0.1,0.5-0.5,1.3-1,2.3c-0.5,1.1-0.8,1.9-1,2.5c-0.3,1.1-0.7,2.7-1.4,4.9c-0.3,1.1-0.6,2.8-1.1,5
          c-0.1,0.5-0.3,1.4-0.4,2.6c-0.1,1.1-0.2,2-0.4,2.5c-0.2,0.6-0.5,1.4-0.9,2.4c-0.5,1.1-0.8,1.8-0.9,2.3c-0.2,0.6-0.4,1.4-0.9,2.5
          c-0.4,1.1-0.7,1.9-0.8,2.4c-0.3,1.1-0.7,2.8-1.2,5c-0.3,1.2-0.8,2.8-1.3,4.9c-0.2,0.6-0.3,1.6-0.4,2.8c-0.1,1.1-0.2,1.9-0.3,2.4
          c-0.4,1.6-1,3.2-1.6,4.8c-0.1,0.2-0.1,0.4-0.1,0.6c-0.7,2.1-1.2,3.6-1.8,4.7c-0.3,0.7-0.8,1.4-1.4,2.1c-0.4,0.4-0.9,1-1.6,1.8
          c-1.5,1.7-2.7,2.9-3.5,3.4c-0.6,0.4-1.4,0.7-2.4,0.8c-1.1,0.1-1.8,0.2-2.3,0.3c-2.8,0.6-4.4,0.9-4.8,0.8c-0.8-0.2-1.6-0.5-2.4-0.9
          c-0.8-0.4-1.6-0.7-2.4-0.9c-0.8-0.2-1.7-0.4-2.5-0.5c-0.8-0.1-1.7-0.3-2.5-0.5c-0.8-0.2-1.6-0.5-2.4-0.8c-0.8-0.3-1.6-0.6-2.4-0.9
          c-0.8-0.2-1.6-0.3-2.5-0.4c-0.8-0.1-1.7-0.2-2.5-0.5c-1.6-0.5-3.3-1-4.9-1.4c-0.8-0.2-1.6-0.3-2.5-0.4c-0.8,0-1.7-0.2-2.5-0.4
          c-1.6-0.5-3.3-1-4.9-1.4c-0.8-0.2-1.6-0.5-2.4-0.8c-0.8-0.3-1.6-0.6-2.4-0.9c-2-0.5-3.6-1-4.8-1.5c-0.6-0.2-1.4-0.6-2.2-1.1
          c-1.3-0.7-2-1.1-2.2-1.2c-0.4-0.2-1.1-0.5-2.3-0.9c-1-0.4-1.7-0.8-2.2-1.1c-0.6-0.4-1.2-0.9-2-1.5l-1.9-1.7
          c-0.4-0.3-1.1-0.7-2.2-1.3c-0.9-0.5-1.6-1-2-1.4c-0.4-0.4-0.9-1.2-1.4-2.2c-0.5-1.1-1-1.8-1.2-2.2c-1.6-1.6-2.7-2.9-3.3-3.8
          c-0.3-0.4-1-1.9-2.3-4.4c-0.4-0.8-1-2.4-1.9-4.6c-0.6-1.6-1.1-3.1-1.5-4.7c-0.1-0.5-0.5-1.3-1-2.3c-0.5-1-0.8-1.8-0.9-2.4
          c-0.1-0.6-0.1-1.4-0.1-2.5c0.1-1.3,0.1-2.1,0-2.5c0-1.5,0-3.2,0.1-5.1c0.2-2.8,0.3-4.4,0.4-5c0.1-0.6,0.3-1.4,0.7-2.3
          c0.5-1.2,0.7-2,0.8-2.4c0.1-0.4,0.3-1.2,0.5-2.5c0.2-1,0.4-1.8,0.7-2.4c0.5-1.3,1.2-2.8,2-4.5c0.3-0.6,0.8-1.3,1.4-2.1
          c0.8-1.1,1.3-1.8,1.5-2.1c0.2-0.3,0.6-1.1,1.2-2.2c0.5-0.9,0.9-1.7,1.3-2.2c0.8-1,2-2.2,3.4-3.7c1.7-1.7,2.9-2.9,3.6-3.5
          c0.9-0.7,2.3-1.6,4.3-2.6c0.3-0.2,1-0.6,2-1.5c0.8-0.6,1.5-1,2.1-1.3c1.1-0.5,2.6-1.2,4.6-2c1.8-0.7,3.4-1.2,4.8-1.6
          c0.3-0.1,1.1-0.3,2.4-0.8c1-0.4,1.8-0.6,2.4-0.7c1.1-0.2,2.8-0.2,5.1-0.1c1.1-0.1,2.8,0,5,0.1c0.6,0,1.4,0.2,2.4,0.4
          c1.3,0.4,2.1,0.6,2.4,0.7c0.5,0.1,1.3,0.1,2.6,0c1.1-0.1,2-0.1,2.6,0.1c0.7,0.2,1.5,0.4,2.6,0.6c0.8,0.1,1.6,0.3,2.5,0.6
          c0.6,0.2,1.4,0.5,2.4,0.9c0.7,0.3,1.5,0.5,2.4,0.8c0.8,0.2,1.6,0.4,2.6,0.5c0.8,0.1,1.7,0.3,2.5,0.6c0.8,0.2,1.6,0.6,2.4,1
          c0.8,0.5,1.6,0.8,2.4,1c0.9,0.2,1.7,0.4,2.6,0.5c0.9,0.1,1.7,0.3,2.5,0.5c0.9,0.2,1.7,0.5,2.4,0.8c0.9,0.3,1.7,0.6,2.4,0.8
          c0.8,0.2,1.7,0.3,2.6,0.4C130.7,47.7,131.5,47.9,132.4,48.1z"
          />
          <text class="start-text text" x="55" y="97">Start</text>
        </g>
      </svg>
      <div class="weekIcons" id="weeklyMap" role="list">
        <div class="weekIcon weekIcon1" style="top: 88px; left: 150px;">
          <span class="weekIcon1" role="listitem" style="opacity: 0;">{{ getDescription(1) }}</span>
        </div>
        <div class="weekIcon weekIcon2" style="top: 126px; left: 238px;">
          <span class="weekIcon2" role="listitem" style="opacity: 0;">
            {{ getDescription(2) }}
          </span>
        </div>
        <div class="weekIcon weekIcon3" style="top: 210px; left: 231px;">
          <span class="weekIcon3" role="listitem" style="opacity: 0;">
            {{ getDescription(3) }}
          </span>
        </div>
        <div class="weekIcon weekIcon4" style="top: 245px; left: 148px;">
          <span class="weekIcon4" role="listitem" style="opacity: 0;">
            {{ getDescription(4) }}
          </span>
        </div>
        <div class="weekIcon weekIcon5" style="top: 289px; left: 70px;">
          <span class="weekIcon5" role="listitem" style="opacity: 0;">
            {{ getDescription(5) }}
          </span>
        </div>
        <div class="weekIcon weekIcon6" style="top: 374px; left: 90px;">
          <span class="weekIcon6" role="listitem" style="opacity: 0;">
            {{ getDescription(6) }}
          </span>
        </div>
        <div class="weekIcon weekIcon7" style="top: 386px; left: 176px;">
          <span class="weekIcon7" role="listitem" style="opacity: 0;">
            {{ getDescription(7) }}
          </span>
        </div>
        <div class="weekIcon weekIcon8" style="top: 390px; left: 263px;">
          <span class="weekIcon8" role="listitem" style="opacity: 0;">{{ getDescription(8) }}</span>
        </div>
        <div class="weekIcon weekIcon9" style="top: 463px; left: 283px;">
          <span class="weekIcon9" role="listitem" style="opacity: 0;">{{ getDescription(9) }}</span>
        </div>
        <div class="weekIcon weekIcon10" style="top: 542px; left: 267px;">
          <span class="weekIcon10" role="listitem" style="opacity: 0;">{{
            getDescription(10)
          }}</span>
        </div>
        <div class="weekIcon weekIcon11" style="top: 628px; left: 280px;">
          <span class="weekIcon11" role="listitem" style="opacity: 0;">{{
            getDescription(11)
          }}</span>
        </div>
        <div class="weekIcon weekIcon12" style="top: 671px; left: 357px;">
          <span class="weekIcon12" role="listitem" style="opacity: 0;">{{
            getDescription(12)
          }}</span>
        </div>
        <div class="weekIcon weekIcon13" style="top: 670px; left: 447px;">
          <span class="weekIcon13" role="listitem" style="opacity: 0;">{{
            getDescription(13)
          }}</span>
        </div>
        <div class="weekIcon weekIcon14" style="top: 592px; left: 484px;">
          <span class="weekIcon14" role="listitem" style="opacity: 0;">{{
            getDescription(14)
          }}</span>
        </div>
        <div class="weekIcon weekIcon15" style="top: 510px; left: 475px;">
          <span class="weekIcon15" role="listitem" style="opacity: 0;">{{
            getDescription(15)
          }}</span>
        </div>
        <div class="weekIcon weekIcon16" style="top: 424px; left: 457px;">
          <span class="weekIcon16" role="listitem" style="opacity: 0;">{{
            getDescription(16)
          }}</span>
        </div>
        <div class="weekIcon weekIcon17" style="top: 348px; left: 435px;">
          <span class="weekIcon17" role="listitem" style="opacity: 0;">{{
            getDescription(17)
          }}</span>
        </div>
        <div class="weekIcon weekIcon18" style="top: 269px; left: 410px;">
          <span class="weekIcon18" role="listitem" style="opacity: 0;">{{
            getDescription(18)
          }}</span>
        </div>
        <div class="weekIcon weekIcon19" style="top: 188px; left: 395px;">
          <span class="weekIcon19" role="listitem" style="opacity: 0;">{{
            getDescription(19)
          }}</span>
        </div>
        <div class="weekIcon weekIcon20" style="top: 112px; left: 405px;">
          <span class="weekIcon20" role="listitem" style="opacity: 0;">{{
            getDescription(20)
          }}</span>
        </div>
        <div class="weekIcon weekIcon21" style="top: 66px; left: 479px;">
          <span class="weekIcon21" role="listitem" style="opacity: 0;">{{
            getDescription(21)
          }}</span>
        </div>
        <div class="weekIcon weekIcon22" style="top: 62px; left: 560px;">
          <span class="weekIcon22" role="listitem" style="opacity: 0;">{{
            getDescription(22)
          }}</span>
        </div>
        <div class="weekIcon weekIcon23" style="top: 132px; left: 618px;">
          <span class="weekIcon23" role="listitem" style="opacity: 0;">{{
            getDescription(23)
          }}</span>
        </div>
        <div class="weekIcon weekIcon24" style="top: 215px; left: 621px;">
          <span class="weekIcon24" role="listitem" style="opacity: 0;">{{
            getDescription(24)
          }}</span>
        </div>
        <div class="weekIcon weekIcon25" style="top: 305px; left: 608px;">
          <span class="weekIcon25" role="listitem" style="opacity: 0;">{{
            getDescription(25)
          }}</span>
        </div>
        <div class="weekIcon weekIcon26" style="top: 388px; left: 588px;">
          <span class="weekIcon26" role="listitem" style="opacity: 0;">{{
            getDescription(26)
          }}</span>
        </div>
        <div class="weekIcon weekIcon27" style="top: 476px; left: 587px;">
          <span class="weekIcon27" role="listitem" style="opacity: 0;">{{
            getDescription(27)
          }}</span>
        </div>
        <div class="weekIcon weekIcon28" style="top: 568px; left: 624px;">
          <span class="weekIcon28" role="listitem" style="opacity: 0;">{{
            getDescription(28)
          }}</span>
        </div>
        <div class="weekIcon weekIcon29" style="top: 617px; left: 703px;">
          <span class="weekIcon29" role="listitem" style="opacity: 0;">{{
            getDescription(29)
          }}</span>
        </div>
        <div class="weekIcon weekIcon30" style="top: 630px; left: 793px;">
          <span class="weekIcon30" role="listitem" style="opacity: 0;">{{
            getDescription(30)
          }}</span>
        </div>
        <div class="weekIcon weekIcon31" style="top: 600px; left: 882px;">
          <span class="weekIcon31" role="listitem" style="opacity: 0;">{{
            getDescription(31)
          }}</span>
        </div>
        <div class="weekIcon weekIcon32" style="top: 514px; left: 915px;">
          <span class="weekIcon32" role="listitem" style="opacity: 0;">{{
            getDescription(32)
          }}</span>
        </div>
        <div class="weekIcon weekIcon33" style="top: 432px; left: 895px;">
          <span class="weekIcon33" role="listitem" style="opacity: 0;">{{
            getDescription(33)
          }}</span>
        </div>
        <div class="weekIcon weekIcon34" style="top: 357px; left: 852px;">
          <span class="weekIcon34" role="listitem" style="opacity: 0;">{{
            getDescription(34)
          }}</span>
        </div>
        <div class="weekIcon weekIcon35" style="top: 285px; left: 795px;">
          <span class="weekIcon35" role="listitem" style="opacity: 0;">{{
            getDescription(35)
          }}</span>
        </div>
        <div class="weekIcon weekIcon36" style="top: 208px; left: 811px;">
          <span class="weekIcon36" role="listitem" style="opacity: 0;">{{
            getDescription(36)
          }}</span>
        </div>
      </div>
      <svg
        version="1.1"
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1024 768"
        enable-background="new 0 0 1024 768"
        xml:space="preserve"
        style="position: absolute; top: 0; left: 0;"
      >
        <rect id="progressbg" fill="#FFFFFF" width="1024" height="768" />
        <g id="weeks">
          <path
            class="week36"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M822.1,272
          c2.9-9.5,8.8-18.7,19.5-26.9c9.8-7.5,23.9-14.2,37.9-18.3"
          />
          <path
            class="week35"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M850.1,356.4
          c-3.6-4.9-15.2-15.7-23.5-32.5c-7.8-15.8-3.2-38.1-0.8-45.6"
          />
          <path
            class="week34"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M906,422.1
          c-6.8-10.5-37.3-51.3-47.4-64.9"
          />
          <path
            class="week33"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M941.8,503
          c-2.4-9.3-22.7-59.1-32.6-75.1"
          />
          <path
            class="week32"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M941.7,591.6c4-7.8,8.2-22.5,8.1-43.3
          c-0.1-20.8-5.7-31.1-7.9-40"
          />
          <path
            class="week31"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M874.8,653.7
          c7.9-2.6,23.8-9.5,38.1-22.5c14.9-13.7,24.1-30.2,26.6-35"
          />
          <path
            class="week30"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M782,661c17.8,4.4,73.4-1.5,87.8-6.3"
          />
          <path
            class="week29"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M697.3,628.7
          c24.1,19.8,48.2,25.4,79.5,32.4"
          />
          <path
            class="week28"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M633.9,562
          c10.3,19.3,37.1,48.9,57.6,65.7"
          />
          <path
            class="week27"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M614.3,465.7
          c-0.5,15.9,0.4,29.3,2.9,44c3,18,6,32.5,14.4,47.9"
          />
          <path
            class="week26"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M631,381.8c-4,16.1-7.4,25.2-8.9,31.8
          c-4.7,20.1-7.2,34.3-7.6,47.6"
          />
          <path
            class="week25"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M649.5,295.2
          c-3.4,27.4-14.8,65.9-18.6,80.6"
          />
          <path
            class="week24"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M654.6,205.8c2.8,29.6-3,68-5,83.5"
          />
          <path
            class="week23"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M631.2,123.6
          c16.6,18.2,23.2,61.4,24.5,77.3"
          />
          <path
            class="week22"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M551.9,92.2c18.3-1.9,27.1,0.8,39.8,5
          c14.8,4.9,26.3,10.1,36.7,21.8"
          />
          <path
            class="week21"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M468.1,117.8
          c13.9-14.3,60.1-25.9,79.6-27.8"
          />
          <path
            class="week20"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M429.1,182.8
          c2.3-26.6,18.3-48.4,35.6-64.7"
          />
          <path
            class="week19"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M432.8,259.5
          c-3-11.6-5.3-56.3-3.6-75.7"
          />
          <path
            class="week18"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M452.7,340.2
          c-5-15.2-13.7-50.6-20-75.7"
          />
          <path
            class="week17"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M481,419.9
          c-5.2-18.2-7.6-23.8-14.8-44.3c-2.9-8.4-6.8-19.2-11.4-32.4"
          />
          <path
            class="week16"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M500.5,497.3
          c-5.6-27.2-11.2-46.7-19.6-77.4"
          />
          <path
            class="week15"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M514.5,586.5
          c-2.6-27.4-6.9-55.8-13-85.2"
          />
          <path
            class="week14"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M510.9,672.3c7.8-16.1,5-71,3.6-85.8"
          />
          <path
            class="week13"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M429.4,710.3
          c19,1.2,35.1-0.7,48.2-5.8c15.9-6.2,27-16.9,33.3-32.2"
          />
          <path
            class="week12"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M347,690.5c1.4,0.8,13.2,4,35.2,9.8
          c24.3,6.3,40,9.7,47.1,10.1"
          />
          <path
            class="week11"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M300,619.2c4,20,11,53.3,47.1,71.2"
          />
          <path
            class="week10"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M306.4,533.8
          c-7.9,46.5-8.4,74.1-6.4,85.5"
          />
          <path
            class="week9"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M320.4,458.8c4,32.6-12.5,64.2-14,75"
          />
          <path
            class="week8"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M253.5,417.2c0,0,63.4-1,66.9,41.5"
          />
          <path
            class="week7"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M163.8,419.8c7.7,1,88-0.4,88-0.4"
          />
          <path
            class="week6"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M101.2,367.3
          c0.5,7.7,1.7,21.7,16.5,33.2c11.3,9.1,27.8,17.4,46,19.3"
          />
          <path
            class="week5"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M134.1,290.9
          c-12.8,7.3-25.3,18.8-30.2,41.8c-2.5,11.6-3.4,23.1-2.7,34.6"
          />
          <path
            class="week4"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M227.1,271.1c-3,1.2-16.6,4-40.7,8.4
          c-25.3,4.6-39.5,4-52.2,11.4"
          />
          <path
            class="week3"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M279.5,204.8
          c-0.8,6.3-3.2,16.9-7.8,26.4c-9.3,18.8-22.4,30-44.7,40"
          />
          <path
            class="week2"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M226.9,129.6
          c16.4,6.3,29.3,14.4,38.8,24.3c14,14.5,18.1,20.6,13.9,50.9"
          />
          <path
            class="week1"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="90"
            stroke-miterlimit="10"
            d="M140.1,105.2
          c89.6,24.8,49.4,9.4,86.8,24.4"
          />
        </g>
        <path
          id="pathbg"
          ref="pathbg"
          fill="#FFFFFF"
          d="M0,0v768h1024V0H0z M80.3,276.2c1.6-2.2,3.1-4,4.4-5.3c2.6-2.7,6.2-5.7,10.5-9.2
        c0.1-0.1,0.2-0.2,5.4-4.5c2.1-1.8,4-3.2,5.6-4.1c1.4-0.8,3.5-1.6,6.3-2.5c3.4-1,5.7-1.7,6.9-2.3c1.1-0.5,3.1-1.7,6.2-3.6
        c2.5-1.6,4.6-2.6,6.1-3.1c1.7-0.5,3.9-1.1,6.8-1.5c3.6-0.6,5.8-1,6.8-1.3c3.1-0.8,7.6-1.5,13.5-2.2c1.7-0.3,4.1-0.7,7.2-1.2
        c2.6-0.4,4.8-0.7,6.4-0.8c1.8-0.2,4.5-0.5,8-1c2.7-0.4,4.6-0.6,5.7-0.6c1-0.1,3.7-0.1,8.1-0.1c3.2,0,5.8-0.3,7.7-0.7
        c2.5-0.6,5.2-1.5,8-2.8c1.4-0.7,3.7-1.9,6.7-3.6c5.7-3.2,9.8-6.6,12.3-10.3c1.5-2.1,2.6-4.6,3.4-7.6c0.5-2.5,0.8-4,0.9-4.5
        c0.1-0.8,0-1.6-0.1-2.6c-0.1-0.6-0.1-1.3,0-2c0.1-0.7,0.4-1.3,0.8-1.8c0.6-0.9,1-1.7,1.2-2.6c0.5-2,0.7-3.6,0.4-4.8
        c-0.1-0.3-0.2-0.7-1-1.9c-0.8-1.4-2.1-2.9-3.9-4.3c-1.3-1.1-3.3-2.5-5.7-4.1c-2.3-1.6-4-2.8-5.2-3.6c-2.2-1.5-4.1-2.6-5.8-3.3
        c-5.3-2.3-9.4-3.9-12.1-4.6l-0.2,0c-0.4,0-0.7-0.1-1-0.2c-2.4-0.6-4.8-1.2-7.1-1.8c-2.4-0.5-4.8-1.1-7.1-1.8
        c-2.3-0.6-4.6-1.4-6.8-2.3c-2.3-0.9-4.7-1.7-7.1-2.3c-4.7-1.4-9.4-2.7-14.2-4c-2.4-0.6-4.9-1.1-7.4-1.3c-2.4-0.2-4.8-0.6-7.1-1.3
        c-4.7-1.2-9.5-2.5-14.1-3.8c-2.3-0.7-4.6-1.4-6.8-2.4c-2.3-1-4.7-1.9-7.1-2.5c-2.4-0.6-4.8-1.2-7.3-1.6c-2.4-0.4-4.7-0.9-7.1-1.6
        c-2.4-0.6-4.7-1.4-6.9-2.2c-2.4-0.9-4.7-1.7-7.1-2.3c-1.2-0.3-3.9-0.5-8.3-0.4c-1.8,0.1-3.3-1-4.5-3.2c-1.3-2.3-1.4-4.2-0.3-5.9
        c2.4-3.8,3.7-6.3,4.1-7.6c0.7-2.5,1.3-5,1.8-7.5c0.5-2.5,1.1-5,1.7-7.4c0.7-2.5,1.2-5,1.6-7.6c0.4-2.5,0.9-4.9,1.6-7.4
        c0.6-2.4,1.5-4.8,2.6-7c1.2-2.4,2.1-4.9,2.8-7.4c0.7-2.5,1.2-5,1.7-7.6c0.4-2.5,1-4.9,1.7-7.4c0.5-1.6,0.7-3.4,0.6-5.3
        c-0.1-1.8-0.2-3.1-0.2-3.8c0-2.3,1.1-4,3.3-5.4c2.1-1.2,3.9-1.2,5.7,0.1c3.6,2.7,6.2,4.2,7.7,4.6c4.7,1.3,9.4,2.6,14,3.9
        c2.4,0.7,4.9,1.2,7.3,1.5c2.4,0.3,4.7,0.8,7,1.4c2.2,0.6,4.5,1.3,7,2c2.2,0.7,4.6,1.3,7,2c2.2,0.6,4.6,1.3,7,2
        c2.2,0.7,4.6,1.4,7,2.1c2.3,0.7,4.7,1.4,6.9,2.1c2.3,0.8,4.7,1.5,7,2.2c4.7,1.3,9.4,2.7,14,4.1c2.4,0.7,4.9,1.2,7.3,1.5
        c2.4,0.3,4.7,0.8,7,1.4c2.3,0.6,4.6,1.3,6.9,2.1c2.3,0.8,4.7,1.5,7.1,2.2c0.8,0.2,2.6,0.6,5.4,1.1c2.9,0.6,5.6,1.4,8,2.2
        c1.6,0.6,3.6,1.4,6,2.4c1.4,0.6,3.6,1.6,6.7,3.1c1.4,0.6,3.3,1.7,5.7,3.2c3,1.9,5,3.2,6.2,3.8c1.1,0.6,3.2,1.5,6.4,2.7
        c2.7,1,4.8,2,6.2,3c1.4,0.9,3.2,2.3,5.3,4.2c2.9,2.6,4.6,4.1,5.3,4.7c2.7,2.1,6.1,5.2,10.1,9.2c3.4,3.3,6.4,6.7,9.2,10.1
        c2.8,3.6,5.4,7.4,7.6,11.3c0.9,1.5,2.3,3.7,4.2,6.5c1.6,2.5,2.8,4.7,3.5,6.5c1.3,3.2,2.7,8.1,4.1,14.6c1.3,5.9,2.1,10.9,2.3,15
        c0.2,4.7,0.1,9.8-0.3,15.2c-0.2,2.1-0.6,4.5-1.2,7.4c-0.2,0.8-0.7,3.4-1.8,7.6c-0.2,1.3-0.7,3.3-1.4,5.9c-1.2,4.3-2,6.8-2.2,7.5
        c-0.2,0.9-0.6,3.1-1.2,6.7c-0.5,2.8-1,5.2-1.7,6.9c-2.3,5.8-4.1,10.2-5.5,12.8c-2.3,4.2-4.7,8.2-7.3,12c-0.9,1.4-2.5,3.1-4.7,5.1
        c-2.8,2.6-4.6,4.4-5.5,5.4c-0.4,0.4-1.8,2.3-4.5,5.7c-1.8,2.3-3.5,4.2-4.9,5.5c-1.4,1.2-3.3,2.7-5.6,4.3c-1.3,0.9-3.4,2.3-6.2,4.2
        c-1.5,1.1-3.6,2.3-6,3.6c-1.4,0.8-3.6,1.9-6.6,3.5c-1.1,0.6-3.1,1.9-6.1,4.1c-2.5,1.7-4.6,3-6.3,3.7c-3.8,1.6-8.4,3.2-13.8,4.9
        c-1.8,0.6-4.1,1.1-6.9,1.6c-7,1.3-7.3,1.3-7.4,1.4c-5.1,1.1-10,2-14.4,2.5c-3.1,0.5-5.5,0.8-7.1,1c-2.9,0.4-5.3,0.7-7.4,0.8
        c-0.2,0-0.3,0-0.5-0.1l-0.1,0c-0.5-0.2-1-0.3-1.5-0.3h-0.2l-0.2,0.1c-0.4,0.1-0.7,0.2-1.2,0.1c-3.6,0-8.1,0.4-13.5,1.3
        c-2.9,0.4-5.2,0.7-6.7,0.9c-2.8,0.4-5.1,0.9-6.9,1.6c-5.1,1.9-8.3,4-9.8,6.5c-0.6,1-0.9,2.6-1.1,5.2c-0.4,0.1-0.9,0.3-0.9,1
        c-0.1,1.9-0.2,3.8-0.2,5.8c0,1.8,0,3.7-0.2,5.6c-0.1,1.7-0.5,3.5-1.1,5.4c-0.6,1.9-0.9,3.9-1,5.9l0,0.2l0,0.2
        c0.2,0.6,0.7,1.5,1.5,2.6c0.4,0.6,1.2,1.5,2.2,2.6c1.8,2.2,5.3,3.8,10.6,4.9l0,0c0.1,0,1,0.3,5.2,1.4c2.4,0.7,4.5,1,6.4,1
        c0.6,0,1.4-0.1,2.4-0.2c0.6,0,1-0.5,1.2-1.4c2.1,0,4.3,0,6.4,0.1c2.4,0.1,4.8,0.1,7.1,0.1c2.5,0,4.9-0.1,7.2-0.4
        c2.4-0.2,4.7-0.3,7-0.3c2.4,0,4.8,0,7,0.2c2.5,0.2,4.9,0.2,7.2,0.2c2.3,0,4.7,0.1,7,0.2c2.4,0.2,4.8,0.2,7.2,0.2
        c2.4,0,4.8-0.1,7.1-0.2c2.3-0.1,4.7-0.2,7.1-0.2c4.7,0,9.5-0.2,14.2-0.4c1.2-0.1,2.9-0.1,4.8,0c2.9,0.1,4.6,0.2,5.1,0.2
        c1.3,0,3.5-0.1,6.5-0.2c2.7-0.1,5.2,0,7.2,0.2c1.6,0.2,3.7,0.6,6.3,1.4c3.8,1.1,6.1,1.7,7,1.9c1,0.2,3.3,0.5,6.9,0.9
        c2.8,0.3,5,0.7,6.7,1.3c1.5,0.5,3.4,1.6,5.7,3.2c3,2.1,5,3.4,6,4c3.5,1.9,5.5,2.9,6,3.2c2.2,1.3,4.1,2.5,5.7,3.7
        c1.2,0.9,3,2.3,5.4,4c2.1,1.6,3.8,3.2,5.1,4.5c2.7,3,4.2,4.6,4.7,5.1c1.8,2,3.3,4,4.5,5.9c2,3,4.1,7.4,6.4,12.9
        c2.1,5.2,3.6,9.8,4.5,13.6c0.4,1.9,0.8,4.2,1,6.9c0.1,1.4,0.3,3.9,0.5,7.4c0.2,3.6,0.1,8.4-0.4,14.3c-0.4,5.6-0.9,10.2-1.5,13.6
        l-0.5,0l-0.1,0.7c-0.5,2.4-1,4.7-1.6,7.1c-0.6,2.4-1.2,4.8-1.7,7.2c-0.5,2.4-0.8,4.9-1,7.4c-0.2,2.4-0.5,4.8-0.9,7.1
        c-0.5,2.4-0.9,4.9-1.2,7.3c-0.3,2.4-0.7,4.8-1.2,7.1c-0.9,4.8-1.9,9.6-2.9,14.3c-1,4.7-2,9.5-3,14.3c-0.5,2.4-1,4.8-1.7,7
        c-0.7,2.4-1.4,4.8-1.8,7.2c-0.5,2.5-0.9,4.9-1.2,7.2c-0.4,2.5-0.8,4.9-1.2,7.3c-0.2,1.5,0,6.8,0.4,16.1c0.1,1.6,0.2,4.1,0.3,7.7
        c0.2,3.1,0.5,5.9,1,8.4c1,4.5,2.5,9.1,4.5,13.7c1.5,3.4,2.5,5.7,3.1,6.7c1.2,2.4,2.5,4.4,3.9,6c3.5,4.1,7.4,7.2,11.4,9.4l0.1,0
        c0.5,0.2,1.6,0.5,5.9,1.4c3.5,0.8,6.5,1.5,8.9,2.3c0.9,0.3,3.1,1.1,6.7,2.4c3,1.1,5.6,1.9,7.6,2.4c0.5,0.1,4.2,1.1,7.2,2
        c3,0.8,5.6,1.4,7.6,1.8c1.8,0.3,4.3,0.6,7.2,0.7c3.5,0.1,5.7,0.2,6.7,0.3c1.1,0.1,3.5,0.5,7,1.2c2.8,0.5,5.1,0.8,6.8,0.8
        c4.5,0,8.9-0.3,13.1-1c3.3-0.5,6.2-1.3,8.8-2.3c1.7-0.7,3-1.4,4-2.1c2.7-1.9,4.6-6.1,5.7-12.9c0.5-2.8,0.8-4.8,0.9-5.8
        c0.3-2.6,0.4-5.1,0.4-7.5c0-0.6-0.3-1.1-0.9-1.4c0,0,0,0,0,0c0-0.3-0.2-0.6-0.5-0.9l0,0c0.3-3.7,0.3-8.7,0-14.8
        c-0.1-1.1,0-3.3,0.2-6.7c0.2-3.3,0.2-6.1,0-8.2c-0.1-1.6-0.5-4-1.1-7.1c-0.6-3.4-1-5.9-1.2-7.7c-0.7-7.4-1.3-12.4-1.6-14.9
        c-0.7-6.4-1.3-11.4-1.8-14.9c-0.2-1.5-0.7-3.8-1.4-6.8c-0.8-3.1-1.3-5.5-1.6-7c-0.2-1.4-0.5-3.7-0.7-6.8c-0.2-3.1-0.5-5.6-0.8-7.3
        c-0.3-1.4-0.5-3.6-0.8-6.8c-0.3-3.1-0.7-5.5-1-7.2c-1.3-6-2.3-10.6-3-13.8c-0.3-1.5-1-3.8-1.9-6.8c-1-2.9-1.6-5.2-2-6.8
        c-0.3-1.4-0.8-3.6-1.3-6.7c-0.5-3-1-5.4-1.4-7.1c-1.9-7.6-3-12.1-3.4-13.6c-1.4-6-2.5-10.6-3.4-13.7c-0.4-1.6-1.2-3.8-2.4-6.7
        c-1.2-3-2-5.2-2.4-6.6c-0.5-1.6-1.3-3.8-2.4-6.6c-1.2-3-2-5.2-2.5-6.6c-0.4-1.2-1-3.5-1.8-6.7c-0.7-2.9-1.4-5.2-1.9-6.9
        c-0.5-1.4-1-3.6-1.6-6.7c-0.6-3.1-1.2-5.5-1.7-7c-0.8-2.3-2.3-6.8-4.7-13.3c-0.6-1.5-1.6-3.6-3.3-6.4c-1.6-2.7-2.7-4.8-3.2-6.2
        c-0.3-0.8-2.1-5.6-5.1-14.3c-0.5-1.3-1-3.6-1.7-6.8c-0.7-3.5-1.4-6.2-2-8.1c-0.4-1.2-1.2-3.5-2.4-7c-1.1-3-1.9-5.6-2.4-7.5
        c-2.1-6.3-3.6-11.1-4.5-14.6c-1.9-6.4-3.2-11.3-4-14.7c-0.4-1.7-0.8-4.2-1.3-7.4c-0.5-3.6-1-6.2-1.3-7.7c-0.4-1.9-0.8-4.5-1.3-7.5
        c-1.1-7.2-1.2-7.5-1.2-7.6c-0.4-2-0.7-4.5-1.1-7.5c-0.4-3.3-0.7-5.9-0.9-7.5c-0.1-1.2-0.5-3.7-1.1-7.6c-0.5-3.1-0.8-5.5-1-7.4
        c-0.1-1.4-0.4-4-0.9-7.6c-0.4-3.1-0.7-5.6-0.8-7.4c-0.2-3.4-0.3-6-0.4-7.7c-0.2-3-0.2-5.5-0.2-7.5c0-1.9,0.3-4.4,0.7-7.6
        c0.5-3.8,0.9-6.3,1-7.5c0.3-3.6,0.9-8.6,1.8-15c0.7-4.6,1.6-9.5,2.8-14.5c0.7-3,2.1-7.8,4.2-14.1c1.3-4,3.1-8.6,5.4-13.6
        c0.3-0.7,1.2-3,2.8-7c1-2.7,2-4.9,3-6.5c2.2-3.8,5-7.9,8.3-12.2c3-3.8,6.2-7.5,9.8-11c1.3-1.3,3.2-2.9,5.6-4.5
        c5.1-3.6,5.9-4.3,6.1-4.4c0.6-0.4,0.9-1.2,1-2.2c0-0.3,0.1-0.6,0.1-0.6l2-1.3c0.3-0.2,1.3-0.7,4.4-2.2c3.3-1.6,6.1-3.1,8.4-4.3
        c1.3-0.7,3.4-1.6,6-2.8c3.4-1.5,5.7-2.6,7-3.2c1.1-0.5,3.2-1.6,6.2-3.4c2.6-1.5,4.9-2.7,6.6-3.3c1.5-0.6,3.7-1.3,6.6-2
        c3.3-0.9,5.8-1.6,7.2-2.1c1.7-0.6,3.9-1.2,6.7-2c3.8-1,6.1-1.6,7.1-1.9c2.8-0.8,7.5-1.9,13.9-3.4c5.4-1.2,10.1-2.1,14-2.7
        c1.1-0.2,3.5-0.7,7.1-1.6c2.9-0.7,5.2-1.1,7-1.2c1.7-0.1,4.1-0.1,7,0.2c3.6,0.3,6,0.5,7.3,0.5c4.3,0,8.9,0.2,13.5,0.5
        c1.5,0.1,3.9,0.3,6.9,0.5c2.7,0.2,4.9,0.4,6.7,0.7c1.9,0.3,4.2,0.8,6.6,1.5c0.3,0.1,2.5,0.7,6.6,1.8c0.4,0.1,2.6,0.7,7.1,1.8
        c2.8,0.7,5,1.3,6.8,2c1.5,0.6,3.9,1.5,6.9,2.6c2.7,1,4.9,1.9,6.5,2.8c1.5,0.8,3.4,2.2,5.7,4.2c2.8,2.5,4.7,4,5.7,4.7
        c1.1,0.8,3.2,2,6.5,3.7c2.7,1.4,4.7,2.7,6,3.8c1.4,1.2,3.1,2.9,4.9,5.1c2.8,3.2,4.4,5,4.9,5.5c1.1,1.2,2.8,2.9,5.1,5.2
        c1.9,2,3.5,3.8,4.7,5.4c1,1.3,2.5,3.2,4.5,5.7c1.7,2.2,3.1,4.2,4.2,5.9c0.9,1.4,2,3.6,3.1,6.4c1.4,3.4,2.4,5.6,3,6.8
        c0.3,0.6,0.9,1,1.8,1.3c0.4,0.1,0.5,0.2,0.5,0.3c0.1,0.2,0.2,0.5,0.3,0.8c0.1,0.4,0.2,0.9,0.3,1.2c0.1,0.2,0.3,1.2,0.9,4.9
        c0.5,3.3,1.2,6.4,1.9,9.1c1.1,4.2,2.1,8.9,3.1,13.9c0.3,1.4,0.8,3.7,1.4,6.6c0.6,2.8,1,5.2,1.3,7.3c0.2,1.3,0.7,3.5,1.6,6.9
        c0.8,2.9,1.3,5.3,1.4,7.1c0.2,1.6,0.3,3.9,0.3,6.9c0.1,3.6,0.1,6.1,0.2,7.4c0.1,1.5,0,3.9-0.2,6.9c-0.3,3.3-0.4,5.8-0.4,7.4
        c0,1.4,0.2,3.8,0.6,7.1c0.3,3,0.5,5.5,0.4,7.2c0,1.5-0.2,3.9-0.6,6.9c-0.4,3.3-0.7,5.8-0.8,7.4c0,1.5,0.1,3.8,0.5,7.2
        c0.3,3,0.4,5.4,0.3,7.1c-0.1,1.5-0.5,3.9-1.1,6.9c-0.7,3.3-1.1,5.7-1.3,7.3c-0.3,3.6-0.8,8.4-1.5,14.1c-0.8,6.4-1.4,11.1-1.8,14.2
        c-0.2,1.5-0.3,3.9-0.2,7.3c0,3.1-0.1,5.5-0.3,7.1c-0.3,1.5-1,3.7-2.1,6.6c-1.2,3.1-1.9,5.5-2.3,7.1c-0.2,1.3-0.6,3.7-1.2,7
        c-0.5,3-0.9,5.3-1.2,7c-0.7,3.1-1.8,7.7-3.3,13.9c-0.3,1.4-0.8,3.8-1.4,7c-0.6,3-1,5.4-1.4,7c-0.3,1.4-0.8,3.8-1.5,7
        c-0.6,3-1.1,5.3-1.5,6.9c-0.4,1.6-1.1,3.9-2,6.8c-1,3.2-1.7,5.5-2.1,6.9c-0.4,1.4-1,3.8-1.8,6.9c-0.7,3-1.3,5.3-1.8,6.9
        c-0.9,3-2.4,7.6-4.5,13.6l0,0.1c0,0.2-0.2,0.9-1.3,4.4c-0.9,3.2-1.7,6.5-2.2,9.9c-0.2,1.5-0.3,3.8-0.2,7c0.1,3.4,0.1,6-0.1,7.7
        c-0.1,0.8-0.4,3.1-1,7c-0.4,3-0.7,5.5-0.8,7.5c0,0.6-0.2,3-0.4,7.1c-0.2,3-0.3,5.6-0.2,7.6c0.3,6.1,0.6,11,1.1,14.7
        c0.2,2,0.7,4.4,1.3,7.3c0.4,1.6,0.9,4,1.6,7.2c0.4,2,1.1,4.4,2,7.1c0.5,1.5,1.3,3.8,2.4,6.9c0.1,0.4,0.8,2.7,2,7
        c0.8,2.9,1.6,5.3,2.5,7.1c0.8,1.7,2.1,3.8,4,6.3c2.3,2.9,3.8,4.9,4.3,5.8c0.6,1,1.6,3.1,3.2,6.5c1.3,2.9,2.6,5.1,3.8,6.6
        c2.4,3,5.8,6.7,10.1,10.8c3,2.9,6.8,6.1,11.3,9.5c1.6,1.2,3.6,2.6,6.1,4.1c1.4,0.8,3.5,2.1,6.3,3.7c3.9,2.4,8.2,4.8,12.8,7.1
        c2.4,1.2,7,3.2,13.4,5.8c0.7,0.3,2.9,1.3,6.6,2.9c2.8,1.2,5.1,2.1,7,2.8c0.5,0.2,2.8,0.9,6.8,2.3c2.8,1,5.2,1.7,7.1,2.2
        c3.1,0.8,7.9,1.9,14.4,3.2c0.7,0.1,2.1,0.3,4.4,0.7c2.4,0.3,4.8,0.6,7.1,0.7c1.2,0.1,3,0,5.5-0.3c2.7-0.3,4.7-0.4,6-0.4
        c2.3,0,5-0.1,8.2-0.4c1.7-0.2,4.2-0.4,7.5-0.7c1.2-0.1,3.9-0.2,8.2-0.3c3.2-0.1,5.7-0.4,7.6-0.7c2.5-0.4,5.2-1.1,8.2-1.9
        c0.5-0.1,2.7-0.8,7.1-2.2c4.4-1.3,9.3-3.4,14.5-6.2c4.8-2.5,9.1-5.6,12.7-9.2c3.6-3.5,6.7-7.9,9.1-13.2c1.7-3.3,2.8-5.8,3.6-7.4
        c1.3-2.9,2.2-5.5,2.6-7.8c0.4-2.5,0.6-5.3,0.7-8.5c0-1,0-3.7,0-7.9c0-2.9-0.3-6-0.7-9.4c-0.5-3.4-0.8-5.6-0.9-6.7
        c-0.1-0.6,0-1.2,0.2-1.8c0.3-0.9,0.5-1.8,0.5-2.6c0-0.6-0.3-1.2-0.8-1.6c-0.1-0.1-0.2-0.2-0.2-0.2c0-1.6-0.1-3.2-0.2-4.6
        c-0.2-2.9-0.6-5.9-1.3-8.9c-0.3-1.4-1-3.4-2-6c-1.2-3.1-2-5.3-2.5-6.7c-0.8-2.7-1.4-4.7-1.9-6.2c-0.8-2.5-1.5-4.8-2.3-6.7
        c-0.3-0.7-1.1-2.8-2.3-6.4c-1-2.8-2-5.2-2.8-7.1c-0.7-1.5-1.8-3.4-3.5-6.1c-1.8-2.8-3.1-4.9-3.8-6.3c-0.6-1.2-1.5-3.3-2.6-6.3
        c-0.9-2.3-1.7-4.3-2.4-5.8l-0.5-1.1l-0.3,0.2l-2.9-4.6l-0.1-0.1c-0.4-0.4-0.7-0.9-1.2-1.4c-2.1-2.5-3.6-4.4-4.4-5.7
        c-0.7-1.1-1.8-3.2-3.3-6.1c-1.4-2.8-2.7-4.9-3.7-6.5c-0.6-0.9-1.9-2.8-3.8-5.9c-1.6-2.6-3-4.6-4.1-6.2c-1-1.3-2.6-3.2-4.7-5.4
        c-2.2-2.4-3.8-4.2-4.8-5.4c-1.1-1.4-2.6-3.2-4.6-5.4c-2.3-2.7-3.9-4.5-4.7-5.5c-0.8-0.9-2.2-2.8-4.3-5.5c-1.9-2.4-3.4-4.3-4.6-5.7
        l-0.1-0.1c-1.6-1.5-3-2.8-4.2-3.8c-2.2-2-4-4-5.6-5.9c-2.2-2.8-5-6.5-8.3-11.2c-1.1-1.5-3.5-5.5-7.3-11.9c-2.9-5-5.1-9.1-6.6-12.2
        c-0.7-1.5-1.4-3.6-2.2-6.4c-0.9-3.5-1.6-5.7-2-6.9c-0.4-1.2-1.4-3.2-3.1-6.4c-1.3-2.6-2.2-4.7-2.6-6.3c-0.5-1.8-0.9-4.1-1.2-6.7
        c-0.3-3.1-0.6-5.5-0.8-7.1c-0.6-5.8-0.9-10.4-0.8-13.8c0.1-3.4,0.6-8,1.6-13.8c0.7-4,1-6.2,1.1-6.8c0.5-2.6,1.1-4.9,1.7-6.8
        c0.7-2,1.7-4.4,3-7c0.8-1.5,2-3.8,3.7-6.8c1-1.8,2.4-3.9,4.2-6.2c1-1.4,2.6-3.4,4.8-6.1c3.2-4.2,6.6-8.1,10-11.4
        c0.1-0.1,0.8-0.8,5.3-5.6c2.1-2.2,4-3.9,5.6-5.1c1.6-1.1,3.7-2.4,6.4-3.9c4.1-2.1,6.4-3.3,7-3.7c0.7-0.4,2.5-1.6,5.7-3.7l0,0
        c2.2-1.5,4.2-2.7,5.8-3.4c1.8-0.8,6-2.5,12.5-5.1c1.5-0.6,3.7-1.2,6.3-1.9c3.4-0.8,5.6-1.4,6.7-1.8c4.1-1.3,8.5-2.6,13-3.8
        c1.3-0.3,3.4-1.1,6.4-2.3c2.7-1,4.8-1.7,6.4-2.1c1.5-0.3,3.7-0.7,6.6-1c3.3-0.4,5.5-0.7,6.9-1c1.2-0.2,3.4-0.7,6.6-1.5
        c2.7-0.6,5-1.1,6.6-1.4c0.2,0,0.5-0.1,2.5-0.9c0.1,0,0.1,0,0.2,0l0,0c1.1,2.7,1.6,5.1,1.7,7.1c0.2,4.2,0.3,6.8,0.5,7.9
        c0.4,2.5,0.7,5,0.9,7.5c0.2,2.6,0.5,5.2,0.9,7.7c0.4,2.5,0.6,5,0.7,7.5c0.1,2.6,0.3,5.2,0.7,7.8c0.4,2.6,1,5.2,1.8,7.7
        c0.7,2.4,1.3,4.9,1.7,7.3c0.4,2.4,0.6,5,0.6,7.5c0,2.6,0.3,5.2,0.7,7.8c0.2,1.7,0.9,4.2,1.9,7.7c0.6,2,0.8,4.4,0.6,7.2
        c0,0,0,0.1,0,0.1c-2-0.1-2-0.1-2-0.1l-0.1,0c-1.6,0.2-4,0.4-7.3,0.6c-3.1,0.2-5.4,0.4-6.9,0.7c-4.7,0.9-9.4,2-13.9,3.1
        c-4.4,1.1-9,2.5-13.7,4c-4,1.4-8.4,3.3-13.2,5.8c-3.8,2-7,4-9.5,6.2c-1.6,1.7-2.4,2.5-2.4,2.6l-0.2,0.2l-0.1,0.2
        c-0.2,0.7-0.3,1.9,1.2,5.3c0.4,0.9,1.6,3.5,3.7,7.8c0.6,1.2,1.5,3.1,2.6,5.7c1.2,2.4,2.3,4.5,3.4,6.1c2,2.9,3.2,4.6,3.8,5.4
        c1.5,2.1,3,3.8,4.3,5.3c0.3,0.3,0.6,0.5,1.1,0.7c0.1,0,0.2,0.1,0.3,0.2c0.2,0.3,0.5,0.5,0.9,0.6c0,0,0,0,0,0
        c1.1,1.3,2.6,3.2,4.4,5.7c2,2.8,3.5,4.8,4.4,5.9c0.6,0.7,2.2,2.5,4.9,5.6c1.9,2.2,3.5,4.1,4.7,5.5c0.8,1,2.4,2.9,4.8,5.7
        c2,2.3,3.5,4.2,4.6,5.6c0.9,1.2,2.4,3,4.8,5.8c2,2.3,3.6,4.2,4.5,5.6c1.9,2.7,4.7,6.8,8.2,12.2c1,1.5,2.3,3.6,3.9,6.3
        c1.8,3,3,5.1,3.7,6.2c0.9,1.3,2.3,3.3,4.5,6.1c1.9,2.5,3.3,4.4,4.1,5.8c0.9,1.5,1.9,3.8,3.1,6.7c1.3,3.2,2.4,5.4,3,6.7
        c1.6,2.9,3.7,7.4,6.3,13.2c0.7,1.5,2.1,3.7,4,6.5c1.7,2.6,2.9,4.7,3.6,6.1c0.7,1.7,1.6,4,2.5,7c1,3.5,1.7,5.8,2.2,7
        c2.4,5.9,4.1,10.5,5.2,13.6c0.5,1.6,1.5,3.9,2.9,7.1c1.3,2.8,2.1,5,2.5,6.5c0.5,1.9,1,4.4,1.5,7.5c0.6,3.6,1,6,1.2,7
        c0.3,1.4,0.9,4,1.9,7.7c0.7,2.9,1.2,5.1,1.4,6.6c0.3,2.4,0.4,5.2,0.1,8.2c-0.5,5.8-0.5,6.3-0.5,6.5l0,0.1c0.2,2.1,0.4,4.8,0.6,7.7
        l0.3,7.7c0.1,1.6,0.4,4.2,1.1,8c0.6,3.2,0.9,5.7,0.8,7.4c-0.1,1.9-0.4,4.5-1,7.7c-0.7,3.9-1.2,6.4-1.3,7.7c-0.2,1.4-0.3,4-0.4,8
        c-0.1,3.2-0.3,5.7-0.7,7.5c-0.4,1.9-1.2,4.3-2.5,7.3c-1.6,3.6-2.5,6-2.9,7.3c-1.4,4.3-2.9,8.6-4.7,12.9c-0.3,0.7-1.1,2.9-2.4,6.6
        c-0.9,2.6-1.8,4.7-2.7,6.2c-0.1,0.2-0.6,1.1-3.1,6.2c-1.2,2.5-2.4,4.5-3.4,5.9c-1,1.4-2.5,3.1-4.4,5.2c-2.6,2.6-4.2,4.3-4.9,5.1
        c-0.5,0.6-1.9,2.4-4.2,5.5c-1.7,2.2-3.2,4-4.4,5.2c-1.3,1.2-3.1,2.7-5.3,4.3c-3.5,2.5-5.3,3.8-5.7,4.1c-0.2,0.1-0.9,0.7-5.5,4.4
        c-2.1,1.7-4,3.1-5.6,4.1c-2.6,1.7-4.5,2.9-5.8,3.7c-2.3,1.4-4.3,2.6-6,3.5c-1.4,0.8-3.6,1.6-6.4,2.4c-3.4,1-5.6,1.7-6.8,2.2
        c-5.6,2.4-10,4.1-12.9,5.1c-1,0.3-3.1,1.1-6.5,2.5c-2.6,1-4.8,1.8-6.5,2.3c-6.5,1.7-11.1,2.8-13.5,3.3c-1.5,0.3-3.8,0.5-6.8,0.5
        c-3.4,0-5.7,0.1-7.2,0.3c-6,1-10.6,1.7-13.7,1.9c-1.3,0.1-3.2,0.1-5.5,0.1c-2.7-0.1-4.6-0.1-5.7,0c-1.2,0-3.1,0.4-5.8,1
        c-2.4,0.5-4.2,0.8-5.4,0.8c-1.6,0-3.8-0.2-6.5-0.7c-3.1-0.5-5.2-0.8-6.3-0.9c-5.8-0.2-10.1-0.5-12.9-0.7
        c-10.4-0.9-12.5-1.1-12.9-1.2c-0.5-0.1-1.1,0.1-1.8,0.5c-0.2,0.2-0.3,0.2-0.3,0.2c-1.7-0.3-3.9-0.9-6.7-1.8c-3.3-1-5.5-1.7-6.7-2
        c-1.2-0.3-3.6-0.8-6.9-1.4c-2.8-0.6-5.1-1.1-6.7-1.5c-1.6-0.4-3.7-1.3-6.3-2.6c-3-1.5-5.1-2.4-6.5-2.9c-3-0.9-5.2-1.6-6.7-2
        c-2.6-0.8-4.8-1.6-6.5-2.2c-4.8-1.8-9.1-3.5-12.9-5.2c-0.9-0.4-3-1.2-6.5-2.6c-2.6-1-4.7-1.9-6.3-2.7c-5.6-2.6-9.8-4.7-12.5-6.2
        c-1.4-0.8-3.2-2.2-5.5-4.1c-2.6-2.1-4.4-3.6-5.7-4.4c-1.2-0.8-3.3-1.9-6.3-3.4c-2.6-1.3-4.6-2.4-5.9-3.3c-1.3-1-3-2.6-5.1-4.7
        c-2.4-2.4-4-4.1-5.1-4.9c-0.9-0.8-2.8-2.2-5.7-4.3c-2.3-1.7-4.1-3.2-5.3-4.4c-1.3-1.2-2.9-2.9-4.7-5c-2-2.4-3.6-4.1-4.6-5.3
        c-4.4-4.4-7.5-7.8-9.4-10.2c-1-1.3-2.3-3.3-3.8-5.7c-1.8-3-3-5-3.7-6c-0.8-1.1-2.2-2.9-4.5-5.5c-1.9-2.2-3.4-4-4.2-5.5
        c-0.9-1.5-1.9-3.7-2.9-6.6c-1.2-3.4-2-5.8-2.7-7c-1.5-2.9-2.7-5.1-3.4-6.6c-1.3-2.5-2.4-4.7-3.1-6.5c-0.8-1.8-1.7-4.1-2.6-6.9
        c-1-3.1-1.8-5.4-2.3-7c-2.4-6.9-4-11.6-4.6-13.9c-0.4-1.4-1.2-3.7-2.5-7.1c-1.1-2.9-1.9-5.2-2.2-6.9c-0.7-3.2-1.3-5.7-1.7-7.3
        c-0.7-2.8-1.1-5.3-1.4-7.2c-0.3-1.7-0.3-4.1-0.1-7.3c0.2-3.5,0.2-6,0-7.5c-0.1-1.5-0.5-4-1.2-7.5c-0.6-3-0.9-5.4-0.9-7.1
        c-0.3-6-0.4-11-0.4-14.8c-0.2-6.7-0.2-11.6,0-14.8c0.1-1.8,0.4-4.3,1-7.4c0.6-3.6,1-6,1.2-7.2c0.2-2,0.6-4.5,1.1-7.5
        c0.7-3.7,1.1-6,1.3-7c0.4-2.2,0.8-4.8,1.4-7.7c0.7-3.1,1.2-5.4,1.5-6.7c0.6-3.2,1.3-6.6,1.9-10c0.6-3.4,0.8-4.2,0.8-4.3l0-0.1
        c0.2-0.2,0.4-0.5,0.4-0.7c0.5-1.6,1.1-3.9,1.8-6.9c0.7-3,1.3-5.3,1.7-6.7c0.4-1.4,1.2-3.6,2.4-6.6c1.1-2.9,1.9-5.1,2.3-6.6
        c0.5-1.6,1-4,1.5-7c0.6-3.2,1-5.4,1.3-6.8c0.5-1.8,1-4.1,1.7-6.9c0.8-3.8,1.3-6,1.5-6.7c0.3-1.2,0.9-3.5,1.9-6.8
        c0.8-2.8,1.3-5.1,1.7-6.7c1.7-7.5,2.7-12.1,3-13.6c1.4-6.2,2.4-10.8,2.9-13.8c0.3-1.7,0.5-4.1,0.6-7.2c0.1-3.2,0.2-5.4,0.4-6.8
        c0.2-1.5,0.7-3.8,1.5-6.9c0.7-3,1.2-5.3,1.4-6.9c0.2-1.7,0.3-4.2,0.3-7.3c-0.1-3.1,0-5.4,0.1-6.7c0.8-6.3,1.3-11,1.5-14
        c0.6-6.4,0.9-11.1,1-14c0.1-3.3,0.2-5.7,0.3-7.3c0.1-2.7,0.1-5,0.1-6.7c0-4.2-0.2-8.8-0.5-13.7c-0.1-1.9-0.4-4.4-0.9-7.2
        c-0.6-3.3-0.9-5.5-1-6.4c-0.6-6.5-1.1-11.1-1.5-13.7c-0.5-2.8-1.1-5.6-1.9-8.3c-0.7-2.5-1.2-4.1-1.5-4.9l-0.1-0.2
        c-1.4-2.7-2.4-4.6-3.1-5.8c-1.2-2.2-2.3-3.9-3.3-5c-1.4-1.6-3.1-3.1-5.2-4.5c-2.2-1.4-3.9-2.4-4.9-3c-2.5-1.6-4.5-2.9-5.9-3.6
        c-2-1.1-3.7-1.9-5.3-2.3c-3.5-1-9-1.4-16.3-1.4c-3.4-0.1-6-0.1-7.6-0.1c0,0,0,0,0,0c-3.1-0.1-5.7,0.1-7.8,0.4
        c-4.6,0.7-9.7,1.8-15.1,3.2c-1.9,0.5-4.4,1.5-7.4,3c-3.4,1.6-5.6,2.6-6.8,3.1c-1,0.4-3.6,1.2-7.6,2.6c-2.9,1-5.2,1.9-6.8,2.6
        l-14.1,6.4l-0.1,0.1c-3,2.8-5.5,6.7-7.7,11.6c-0.6,1.6-1.1,3.6-1.5,6.4c-0.7,5.1-1,6.6-1,7c-0.1,0.6-0.5,2.1-1.9,6.1
        c-1,2.8-1.5,5.2-1.6,7.1c-0.3,4-0.4,8.6-0.4,13.6c0,1.7,0.2,3.9,0.5,6.6c0.4,3.6,0.6,5.9,0.7,6.8c0.1,0.9,0.1,3.1,0.2,6.6
        c0.1,2.8,0.3,5.1,0.5,6.9c0.2,1.5,0.8,3.7,1.8,6.6c1,2.9,1.6,5,1.8,6.4c0.3,1.5,0.4,4,0.5,7.3c0,3.3,0.2,5.8,0.6,7.5
        c0.4,1.8,1.2,4.1,2.5,7.3c1.2,3.1,2,5.3,2.4,6.7c0.4,1.5,0.8,4,1.1,7.3c0.3,3.3,0.7,5.7,1.2,7.3c0.5,1.9,1.4,4.3,2.6,7.3
        c1.3,3.2,2.2,5.4,2.5,6.5c0.6,2,1.5,4.6,2.6,7.5c1.3,3.4,2,5.5,2.3,6.3c1.9,5.6,3.3,10.3,4,14l0.1,0.2c0.1,0.4,0.4,0.7,0.8,0.8
        c0.6,1.7,1.4,3.9,2.3,6.7c1.1,3.4,1.8,5.7,2.3,6.9c1.1,3.1,2.7,7.7,4.6,13.8c0.5,1.4,1.5,3.7,2.8,6.8c1.3,2.9,2.1,5.1,2.7,6.7
        c1,3.1,2.5,7.8,4.2,13.9c0.4,1.2,1.1,3.5,2.4,7c1,2.8,1.7,5.1,2.2,6.9c0.5,1.6,1.1,4,1.9,7.1c0.8,3.2,1.5,5.6,1.9,7
        c0.9,3.2,2.3,7.8,4,14c0.4,1.6,1.2,3.9,2.4,7.1c1.1,3,1.8,5.2,2.2,6.8c0.4,1.7,0.9,4.1,1.3,7.1c0.5,3.3,0.9,5.8,1.2,7.2
        c0.8,3.2,1.8,8,3,14.3c0.4,1.5,1,3.9,2,7.2c0.9,3,1.5,5.3,1.8,6.9c0.3,1.7,0.7,4.1,1.1,7.2c0.4,3.3,0.8,5.7,1.1,7.2
        c0.3,1.6,0.9,4,1.9,7.2c0.9,3.1,1.4,5.4,1.7,6.9c0.6,3.3,1.4,8.1,2.5,14.4c0.3,1.7,0.4,4.1,0.4,7.2c0,3.4,0.1,5.8,0.3,7.3
        c0.5,3.3,1.2,8.1,2.1,14.4c0.2,1.6,0.6,4.1,1.1,7.4c0.5,3.1,0.8,5.5,0.9,7c0.2,1.6,0.5,4.1,1,7.5c0.5,3.1,0.8,5.4,0.9,6.9
        c0.7,8.4,1.1,13.2,1.2,14.5c0.1,2,0,4.6-0.3,7.7c-0.3,3.4-0.4,5.7-0.4,6.9c0.1,2.9,0.4,6,1,9.4c0.7,4.1,0.7,5,0.7,5.2
        c0.1,6.6,0.1,11.5-0.1,14.5c-0.2,3.7-0.8,8.5-1.8,14.4c-0.7,4.3-1.8,9.1-3.2,14.2c-1.2,4.1-2.8,8.7-4.9,13.6
        c-0.8,1.8-1.9,3.9-3.5,6.4c-0.9,1.4-2.2,3.4-3.9,6.1c-0.4,0.8-1.6,3-3.5,6.7c-1.3,2.6-2.6,4.5-3.6,5.9c-3.2,3.9-6.5,7.5-9.9,10.6
        c-2.7,2.5-6.5,5.5-11.4,8.9c-1.4,1-3.3,2-5.8,3.1c-3.5,1.5-5.5,2.4-6.3,2.8c-3.1,1.6-7.3,3.4-12.2,5.3c-3.3,1.2-7.6,2.5-12.8,3.9
        c-2.9,0.8-5,1.4-6.4,1.7c-2.5,0.7-4.7,1.1-6.5,1.4c-0.9,0.1-3.1,0.6-6.7,1.3c-2.7,0.6-4.9,0.9-6.6,1c-2.3,0.2-6.5,0.3-12.5,0.3v-0.6
        h-1c-1.6,0-6.7-0.3-15.2-0.8c-7.7-0.5-12.8-1-15.1-1.3c-1.4-0.2-3.9-0.4-7.6-0.6c-3.2-0.2-5.8-0.4-7.6-0.8c-2.1-0.4-4.8-1-7.9-1.8
        c-4.7-1.2-7.3-1.9-7.7-2c-2-0.5-4.6-1.3-7.8-2.5c-3.7-1.3-6.2-2.2-7.4-2.6c-1.7-0.5-4.5-1.2-8.3-2.1c-3.2-0.8-5.6-1.4-7.2-1.9
        c-3.6-1.2-7.3-2.4-10.9-3.5c-3.1-0.9-4.1-1.2-4.3-1.3c0-0.1-0.1-0.2-0.1-0.4c-0.2-0.9-0.6-1.4-1.2-1.7c-0.3-0.1-0.7-0.2-1.1-0.3
        l-0.1,0c-0.1,0-0.2,0-0.4-0.1c-3-1.4-5.2-2.4-6.6-3.1c-2.6-1.2-4.7-2.4-6.3-3.4c-3.5-2.2-7.5-5.1-11.8-8.5c-4.7-3.9-5.5-4.5-5.7-4.6
        c-2.1-1.7-3.9-3.4-5.3-4.8c-2.3-2.3-4-4-5.1-5.2c-2-2-3.6-3.8-4.8-5.4c-1.1-1.5-2.4-3.5-3.9-6c-2.1-3.7-3.3-5.9-3.7-6.5
        c-1.8-2.7-3.1-4.7-3.9-6.1c-1.5-2.4-2.7-4.5-3.6-6.3c-0.8-1.6-1.6-3.9-2.4-6.7c-1.2-3.9-1.9-6.2-2.3-7.1c-2.3-6-3.9-10.6-4.7-13.7
        c-0.9-3-1.5-5.4-1.9-6.9c-0.7-2.7-1.3-5-1.7-7.1c0-0.1-0.3-1.3-1.6-7.7c-0.6-3-1-5.5-1.2-7.4c-0.7-6.5-1.1-11.7-1.2-15.4
        c-0.1-2.3,0-5,0.3-8.1c0.6-6.8,0.6-7.2,0.6-7.3c0.2-5.4,0.7-10.6,1.4-15.3l0.4-1.8c0.5-2.4,1.1-4.7,1.8-7c0.8-2.4,1.5-4.9,1.9-7.3
        c0.5-2.5,0.7-5,0.7-7.6c0-2.4,0.2-4.8,0.7-7.2c0.5-2.4,1-4.8,1.6-7.2c0.6-2.4,1.1-4.9,1.6-7.3c0.5-2.5,0.9-5,1.2-7.4
        c0.3-2.5,0.7-4.9,1.1-7.3c1.1-4.8,2.1-9.7,3.1-14.6c0.5-2.4,1.1-4.7,2-7c1-2.4,1.7-4.8,2.2-7.3c0.5-2.5,0.7-5,0.7-7.6
        c0-2.2,0.1-4.5,0.5-6.6c0.4-0.1,0.7-0.3,0.9-0.6l0.6-1.3l-1.4-0.2c-1-0.1-2.3-0.1-3.8,0.1c-1.5,0.2-2.5,0.4-3.2,0.4
        c-0.2,0-0.5,0-0.8-0.2c-0.7-0.4-1.3-0.5-2-0.5c-0.6,0.1-1.1,0.4-1.6,0.9c-0.1,0.1-0.2,0.2-0.2,0.2c-4.8-0.1-9.7-0.1-14.5,0
        c-2.5,0-4.9,0.1-7.2,0.3c-2.5,0.1-4.9,0.2-7.2,0.2c-2.3,0-4.7-0.2-7-0.7c-2.5-0.5-5-0.8-7.4-0.8c-2.4,0-4.9,0.3-7.4,0.7
        c-2.3,0.4-4.7,0.6-7,0.6c-2.5,0-4.9,0.1-7.3,0.3c-2.5,0.1-4.9,0.2-7.2,0.2c-2.4,0-4.7-0.1-7.1-0.3c-2.5-0.3-5-0.4-7.4-0.4
        c-0.5,0-1.3,0.2-2.4,0.4c-1.1,0.3-1.7,0.3-2,0.3c-4.5,0-9.6-0.3-15.3-0.8c-3.5-0.3-6.2-0.5-7.9-0.7c-3-0.3-5.4-0.6-7.4-1
        c-1.9-0.4-4.3-1.3-7.2-2.7c-3.6-1.7-5.9-2.8-7-3.1c-4.8-1.6-9.5-3.6-14-5.8c-3.2-1.6-5.6-2.7-7.1-3.5c-2.6-1.3-4.7-2.5-6.3-3.6
        c-3-2.1-5.3-3.6-6.7-4.5c-2.4-1.7-4.3-3.2-5.6-4.5c-2.9-2.8-5.9-6.1-8.9-9.7c-2-2.6-4.5-6.2-7.3-10.9c-0.9-1.6-1.9-3.5-2.9-5.9
        c-1.1-2.7-1.9-4.7-2.5-6.1c-0.5-1-1.6-3-3.3-6.2c-1.3-2.3-2.2-4.2-2.6-5.7c-0.9-2.9-1.8-7.2-2.8-12.9c-0.5-2.5-0.6-5.2-0.5-8
        c0.2-2.7,0.3-4.4,0.3-5.1c0-0.5-0.2-1.1-0.6-1.7c-0.2-0.2-0.2-0.3-0.2-0.4c0.1-2.3,0.2-4.7,0.3-7.3c0-2.3,0.1-4.7,0.3-7.2
        c0.2-2.3,0.5-4.7,0.9-7.1c0.4-2.4,0.7-4.8,0.9-7.3c0.4-5.9,1-10.6,1.6-13.8c0.4-1.8,1-4.1,2-6.6c1.1-2.9,2-5.1,2.5-6.6
        c1-3,1.7-5.2,2.2-6.7c0.8-2.6,1.7-4.7,2.6-6.3c0.9-1.6,2.1-3.6,3.7-5.7c1.9-2.4,3.4-4.3,4.3-5.6C78.1,279.4,79.4,277.5,80.3,276.2z"
        />
        <path
          id="pathoutlined"
          fill="#231F20"
          d="M840.2,192.4c-1.6,0.8-3.6,1.9-5.9,3.5c-3.1,2-5,3.2-5.7,3.7c-0.6,0.3-2.9,1.6-6.9,3.6
        c-2.8,1.5-5,2.8-6.6,3.9c-1.7,1.3-3.6,3-5.8,5.2c-3.3,3.5-5.1,5.4-5.2,5.6c-3.5,3.4-6.9,7.2-10.1,11.6c-2.2,2.7-3.8,4.7-4.8,6.1
        c-1.8,2.4-3.2,4.5-4.2,6.4c-1.7,3-2.9,5.3-3.7,6.9c-1.4,2.7-2.4,5-3.1,7.1c-0.6,2-1.2,4.3-1.8,6.9c-0.1,0.6-0.5,2.8-1.2,6.8
        c-1,5.8-1.5,10.5-1.6,13.9c-0.1,3.5,0.2,8.1,0.8,14c0.2,1.6,0.5,3.9,0.8,7c0.3,2.7,0.7,5,1.2,6.9c0.4,1.7,1.3,3.9,2.7,6.5
        c1.6,3.1,2.6,5.2,3,6.3c0.4,1.1,1.1,3.4,2,6.8c0.8,2.8,1.5,5,2.2,6.5c1.5,3.2,3.7,7.2,6.6,12.2c3.8,6.4,6.2,10.4,7.3,12
        c3.3,4.7,6.1,8.4,8.3,11.2c1.6,2,3.5,4,5.7,6c1.2,1.1,2.6,2.4,4.2,3.9c1.2,1.4,2.7,3.2,4.6,5.6c2.1,2.8,3.6,4.6,4.3,5.6
        c0.8,1,2.4,2.8,4.8,5.5c2,2.2,3.5,4,4.5,5.4c1,1.2,2.6,3.1,4.9,5.5c2.1,2.3,3.6,4.1,4.6,5.4c1.1,1.5,2.5,3.5,4.1,6.1
        c1.9,3,3.2,5,3.8,5.9c1,1.5,2.2,3.6,3.6,6.4c1.5,3,2.7,5.1,3.4,6.2c0.9,1.4,2.4,3.3,4.5,5.9c0.4,0.5,0.8,1,1.1,1.4l3.5,5.5l0.2-0.1
        c0.7,1.5,1.5,3.3,2.4,5.6c1.1,3.1,2,5.2,2.7,6.5c0.7,1.4,2,3.6,3.8,6.4c1.7,2.6,2.8,4.6,3.5,6c0.9,1.9,1.8,4.2,2.8,7
        c1.2,3.5,2,5.7,2.3,6.4c0.7,1.9,1.5,4.1,2.2,6.6c0.4,1.4,1,3.5,1.8,6.1c0.5,1.4,1.3,3.7,2.5,6.8c1,2.6,1.7,4.6,2,5.9
        c0.6,2.9,1,5.8,1.2,8.7c0.1,1.5,0.2,3,0.2,4.6c0,0.3,0.2,0.6,0.5,0.9c0.4,0.3,0.5,0.6,0.5,0.9c0,0.7-0.1,1.4-0.4,2.2
        c-0.3,0.7-0.4,1.5-0.3,2.2c0.1,1.2,0.5,3.4,1,6.8c0.4,3.4,0.7,6.5,0.7,9.3c0,4.2,0,6.8,0,7.8c-0.1,3.1-0.3,5.9-0.7,8.3
        c-0.4,2.2-1.2,4.7-2.5,7.5c-0.7,1.7-1.9,4.1-3.5,7.4c-2.4,5.2-5.4,9.5-8.9,13c-3.6,3.6-7.8,6.6-12.5,9c-5.1,2.7-9.9,4.8-14.3,6.1
        c-4.3,1.3-6.6,2.1-7.1,2.2c-2.9,0.8-5.6,1.5-8.1,1.9c-1.8,0.3-4.3,0.5-7.4,0.7c-4.3,0.1-7,0.2-8.2,0.3c-3.3,0.3-5.8,0.5-7.5,0.7
        c-3.1,0.3-5.8,0.4-8.1,0.4c-1.4,0-3.4,0.2-6.1,0.5c-2.4,0.2-4.2,0.3-5.3,0.2c-2.3-0.1-4.7-0.4-7.1-0.7c-2.3-0.3-3.7-0.5-4.4-0.6
        c-6.5-1.3-11.2-2.4-14.3-3.2c-1.9-0.5-4.3-1.2-7.1-2.2c-4-1.4-6.3-2.2-6.8-2.3c-1.8-0.6-4.1-1.6-6.9-2.8c-3.7-1.7-5.9-2.7-6.6-3
        c-6.5-2.6-10.9-4.5-13.3-5.8c-4.6-2.3-8.8-4.7-12.8-7.1c-2.8-1.7-5-2.9-6.4-3.8c-2.5-1.5-4.5-2.9-6-4.1c-4.5-3.4-8.2-6.5-11.2-9.4
        c-4.2-4.2-7.6-7.8-10-10.8c-1.1-1.5-2.4-3.6-3.7-6.4c-1.5-3.4-2.6-5.6-3.2-6.6s-2.1-3-4.4-6c-1.9-2.4-3.2-4.5-3.9-6.1
        c-0.8-1.8-1.6-4.1-2.4-7c-1.2-4.3-1.8-6.6-1.9-7c-1.1-3.1-1.9-5.4-2.4-6.9c-0.9-2.7-1.6-5.1-2-7c-0.7-3.2-1.2-5.6-1.6-7.2
        c-0.6-2.8-1-5.2-1.2-7.2c-0.4-3.7-0.8-8.5-1.1-14.6c-0.1-2,0-4.5,0.2-7.5c0.3-4.1,0.4-6.5,0.5-7.1c0.1-2,0.3-4.5,0.8-7.5
        c0.6-3.8,0.9-6.2,1-7c0.2-1.7,0.2-4.4,0.1-7.9c-0.1-3.1,0-5.4,0.2-6.8c0.6-3.3,1.3-6.6,2.2-9.8c0.8-2.6,1.3-4.1,1.3-4.5
        c2.1-6,3.7-10.6,4.6-13.6c0.5-1.6,1.1-3.9,1.8-7c0.8-3.2,1.3-5.5,1.8-6.9c0.4-1.4,1.1-3.7,2.1-6.9c0.9-2.9,1.6-5.2,2-6.8
        c0.4-1.7,1-4,1.6-7c0.7-3.3,1.2-5.6,1.5-7c0.4-1.7,0.9-4,1.4-7c0.6-3.2,1-5.5,1.4-7c1.6-6.2,2.7-10.8,3.3-13.9
        c0.3-1.7,0.7-4.1,1.2-7.1c0.5-3.3,0.9-5.7,1.2-7c0.3-1.6,1-3.9,2.2-6.9c1.2-3,1.9-5.3,2.2-6.8c0.3-1.7,0.4-4.1,0.3-7.2
        c-0.1-3.3,0-5.7,0.2-7.1c0.4-3.1,1-7.8,1.8-14.2c0.7-5.8,1.3-10.5,1.6-14.1c0.2-1.6,0.6-4,1.3-7.2c0.6-3.1,1-5.4,1.1-7
        c0.1-1.7,0-4.1-0.3-7.2c-0.3-3.3-0.5-5.7-0.5-7.1c0.1-1.5,0.3-3.9,0.8-7.2c0.4-3.1,0.6-5.4,0.6-7c0-1.8-0.1-4.2-0.5-7.3
        c-0.4-3.3-0.6-5.6-0.6-7c0-1.6,0.1-4,0.3-7.3c0.3-3.1,0.4-5.4,0.2-7c-0.1-1.4-0.1-3.8-0.2-7.4c-0.1-3-0.2-5.3-0.3-7
        c-0.2-1.9-0.7-4.3-1.5-7.2c-0.9-3.3-1.4-5.6-1.6-6.8c-0.3-2.1-0.7-4.6-1.3-7.4c-0.6-3-1.1-5.2-1.4-6.6c-1-5-2-9.6-3.1-13.9
        c-0.7-2.7-1.4-5.7-1.9-9.1c-0.5-2.9-0.8-4.6-1-5c-0.1-0.3-0.2-0.6-0.3-1c-0.1-0.4-0.2-0.7-0.4-1c-0.2-0.4-0.5-0.6-1.1-0.8
        c-0.6-0.2-1-0.4-1.2-0.8c-0.6-1.2-1.6-3.4-3-6.7c-1.2-2.8-2.3-5-3.2-6.5c-1.1-1.7-2.5-3.7-4.2-6c-2-2.5-3.5-4.4-4.4-5.7
        c-1.3-1.6-2.9-3.5-4.8-5.5c-2.3-2.3-4-4-5-5.2c-0.5-0.5-2.1-2.3-4.8-5.5c-1.9-2.3-3.6-4-5-5.2c-1.4-1.2-3.4-2.5-6.2-3.9
        c-3.2-1.7-5.3-2.9-6.3-3.6c-1-0.7-2.9-2.2-5.7-4.7c-2.3-2.1-4.3-3.5-5.9-4.3c-1.7-0.9-3.9-1.9-6.6-2.9c-3.1-1.1-5.4-2-6.9-2.5
        c-1.8-0.7-4.1-1.4-6.9-2.1c-4.4-1.1-6.7-1.6-7.1-1.8c-4-1.1-6.2-1.7-6.5-1.8c-2.5-0.7-4.7-1.2-6.7-1.5c-1.8-0.3-4-0.5-6.8-0.8
        c-3.1-0.2-5.4-0.3-6.9-0.5c-4.7-0.4-9.2-0.5-13.6-0.5c-1.3,0-3.7-0.2-7.2-0.5c-3-0.3-5.4-0.3-7.2-0.2c-1.8,0.1-4.2,0.5-7.1,1.2
        c-3.6,0.9-6,1.4-7,1.6c-4,0.6-8.7,1.5-14.1,2.7c-6.5,1.5-11.1,2.6-13.9,3.4c-1,0.3-3.4,0.9-7.1,1.9c-2.8,0.8-5.1,1.4-6.8,2
        c-1.4,0.5-3.8,1.2-7.1,2c-3,0.8-5.2,1.4-6.8,2c-1.8,0.7-4,1.8-6.7,3.4c-3,1.8-5,2.9-6.1,3.4c-1.3,0.6-3.6,1.6-7,3.1
        c-2.7,1.2-4.7,2.1-6.1,2.8c-2.3,1.2-5.1,2.6-8.4,4.2c-2.5,1.2-4,2-4.5,2.3l-1.9,1.2c-0.4,0.3-0.6,0.7-0.6,1.4
        c-0.1,0.7-0.3,1.2-0.6,1.5c-0.2,0.2-2.2,1.6-6,4.3c-2.4,1.7-4.3,3.2-5.7,4.7c-3.6,3.6-6.9,7.3-9.9,11.1c-3.3,4.3-6.1,8.4-8.4,12.3
        c-1,1.6-2,3.8-3,6.6c-1.6,4-2.5,6.3-2.8,6.9c-2.3,5.1-4.1,9.7-5.4,13.8c-2.1,6.4-3.5,11.1-4.2,14.2c-1.2,5-2.1,9.9-2.8,14.6
        c-0.9,6.5-1.5,11.5-1.8,15.1c-0.1,1.2-0.4,3.7-0.9,7.4c-0.4,3.2-0.7,5.8-0.7,7.7c0,2,0,4.5,0.2,7.5c0.1,1.7,0.2,4.3,0.4,7.7
        c0.1,1.8,0.4,4.3,0.8,7.5c0.5,3.7,0.8,6.2,0.9,7.6c0.2,1.9,0.5,4.4,1,7.4c0.6,3.9,1,6.4,1.1,7.6c0.2,1.7,0.5,4.2,0.9,7.5
        c0.4,3,0.7,5.5,1.1,7.5c0.1,0.3,0.5,2.8,1.2,7.6c0.5,3,0.9,5.5,1.3,7.5c0.3,1.5,0.7,4,1.2,7.6c0.5,3.2,0.9,5.7,1.4,7.5
        c0.8,3.4,2.1,8.3,4,14.8c0.9,3.4,2.5,8.3,4.5,14.6c0.6,2,1.4,4.5,2.5,7.5c1.2,3.5,2,5.8,2.4,7c0.6,1.9,1.2,4.5,2,8
        c0.7,3.3,1.2,5.6,1.7,6.9c3.1,8.8,4.8,13.6,5.1,14.4c0.5,1.5,1.6,3.6,3.3,6.4c1.6,2.7,2.7,4.8,3.2,6.2c2.4,6.5,3.9,10.9,4.7,13.2
        c0.5,1.5,1.1,3.8,1.7,6.9c0.6,3.1,1.2,5.4,1.6,6.8c0.5,1.6,1.2,3.9,1.9,6.8c0.8,3.2,1.4,5.5,1.8,6.8c0.5,1.4,1.3,3.6,2.5,6.6
        c1.1,2.8,1.9,5,2.4,6.6c0.4,1.4,1.2,3.6,2.4,6.6c1.2,2.8,2,5,2.4,6.5c0.9,3.1,2,7.6,3.4,13.6c0.4,1.5,1.6,6.1,3.5,13.6
        c0.4,1.6,0.9,4,1.4,7c0.6,3.1,1,5.4,1.4,6.8c0.3,1.6,1,3.8,2,6.8c0.9,3,1.6,5.2,1.9,6.7c0.7,3.1,1.6,7.7,3,13.8
        c0.3,1.7,0.6,4,0.9,7.1c0.3,3.2,0.6,5.5,0.9,6.9c0.3,1.7,0.6,4,0.8,7.1c0.2,3.1,0.5,5.4,0.7,6.9c0.3,1.5,0.8,3.9,1.6,7
        c0.7,2.9,1.2,5.2,1.4,6.7c0.5,3.5,1.1,8.4,1.8,14.8c0.3,2.5,0.8,7.5,1.5,14.8c0.2,1.8,0.6,4.4,1.2,7.8c0.6,3.2,0.9,5.5,1,7
        c0.2,2.1,0.2,4.8,0,8.1c-0.2,3.5-0.2,5.8-0.1,6.9c0.3,6.2,0.2,11.2,0,14.9c0,0.2,0.1,0.3,0.2,0.5c0.2,0.2,0.2,0.4,0.2,0.5
        c0,0.2,0.1,0.5,0.4,0.7c0.3,0.2,0.5,0.4,0.5,0.6c0,2.3-0.1,4.8-0.4,7.4c-0.1,1.1-0.4,3-0.9,5.8c-1.1,6.4-2.9,10.5-5.3,12.2
        c-0.9,0.6-2.2,1.3-3.9,1.9c-2.5,1-5.3,1.7-8.5,2.2c-4.1,0.7-8.5,1-13,1c-1.6,0-3.8-0.3-6.6-0.8c-3.6-0.7-5.9-1.1-7-1.2
        c-1-0.1-3.2-0.2-6.8-0.3c-2.9-0.1-5.2-0.3-7-0.7c-2-0.4-4.6-1-7.6-1.8c-4.4-1.2-6.8-1.8-7.1-1.9c-2-0.5-4.5-1.3-7.5-2.4
        c-3.6-1.4-5.9-2.2-6.8-2.5c-2.5-0.8-5.5-1.5-9-2.3c-3.1-0.7-5-1.1-5.7-1.4c-4-2.1-7.7-5.1-11.1-9.1c-1.3-1.5-2.5-3.4-3.8-5.8
        c-0.5-1.1-1.6-3.3-3.1-6.7c-2-4.6-3.4-9.1-4.4-13.5c-0.5-2.4-0.8-5.1-1-8.2c-0.1-3.5-0.2-6.1-0.3-7.7c-0.5-9.1-0.6-14.4-0.5-15.9
        c0.4-2.3,0.8-4.7,1.2-7.2c0.3-2.3,0.7-4.7,1.2-7.2c0.5-2.4,1.1-4.7,1.8-7.1c0.7-2.3,1.3-4.7,1.8-7.1c1-4.8,2-9.5,3-14.3
        c1-4.8,2-9.6,2.9-14.4c0.5-2.4,0.9-4.8,1.2-7.2c0.3-2.4,0.7-4.8,1.2-7.2c0.5-2.4,0.8-4.8,1-7.2c0.2-2.5,0.5-4.9,0.9-7.3
        c0.5-2.4,1-4.7,1.7-7.1c0.6-2.4,1.2-4.8,1.6-7.2c0.4,0,0.5-0.1,0.5-0.1c0.7-3.5,1.2-8.3,1.6-14.4c0.5-6,0.6-10.8,0.4-14.4
        c-0.2-3.5-0.4-6-0.5-7.4c-0.3-2.7-0.6-5-1.1-7c-0.9-3.9-2.4-8.5-4.5-13.8c-2.3-5.6-4.4-10-6.4-13.1c-1.2-1.9-2.7-3.9-4.6-6
        c-0.5-0.5-2-2.2-4.7-5.1c-1.4-1.4-3.1-3-5.2-4.6c-2.4-1.8-4.2-3.2-5.4-4.1c-1.6-1.2-3.5-2.5-5.8-3.8c-0.5-0.3-2.5-1.3-6-3.2
        c-1-0.5-2.9-1.8-5.9-3.9c-2.4-1.6-4.4-2.7-6-3.3c-1.7-0.6-4-1.1-6.9-1.4c-3.6-0.4-5.8-0.6-6.8-0.9c-0.9-0.2-3.2-0.8-6.9-1.9
        c-2.7-0.8-4.9-1.3-6.5-1.5c-2.1-0.2-4.6-0.3-7.4-0.2c-3,0.1-5.1,0.1-6.5,0.1c-0.5,0-2.2,0-5.1-0.1c-2-0.1-3.7-0.1-4.9,0
        c-4.7,0.2-9.4,0.3-14.2,0.4c-2.4,0-4.7,0.1-7.1,0.2c-2.4,0.1-4.7,0.2-7.1,0.2c-2.4,0-4.7,0-7.1-0.2c-2.4-0.2-4.7-0.3-7.1-0.2
        c-2.3,0-4.7,0-7.1-0.2c-2.3-0.2-4.7-0.2-7.1-0.2c-2.3,0-4.7,0.1-7.1,0.4c-2.3,0.2-4.7,0.4-7.1,0.4c-2.4,0-4.7,0-7.1-0.1
        c-2.4-0.1-4.7-0.1-7.1-0.1c-0.1,0-0.2,0.2-0.3,0.7c-0.1,0.4-0.2,0.6-0.3,0.6c-1,0.1-1.8,0.2-2.4,0.2c-1.7,0-3.8-0.3-6.1-0.9
        c-3.5-1-5.2-1.5-5.2-1.5c-5-1-8.4-2.5-10-4.5c-1-1.2-1.7-2-2.2-2.6c-0.8-1-1.2-1.8-1.3-2.2c0.1-1.9,0.4-3.8,1-5.6
        c0.6-1.9,1-3.8,1.1-5.6c0.2-1.9,0.2-3.8,0.2-5.7c0-1.9,0-3.8,0.2-5.7c0,0,0.1-0.1,0.4-0.1c0.3,0,0.4-0.1,0.4-0.1
        c0.2-2.7,0.5-4.5,1.1-5.5c1.3-2.3,4.4-4.3,9.2-6c1.7-0.6,3.9-1.1,6.6-1.5c1.5-0.2,3.8-0.5,6.7-0.9c5.4-0.9,9.9-1.3,13.4-1.3
        c0.5,0,1,0,1.5-0.2c0.4,0,0.8,0.1,1.1,0.2c0.4,0.2,0.7,0.3,1.1,0.2c2.1-0.1,4.6-0.4,7.4-0.8c1.6-0.2,4-0.5,7.1-1
        c4.4-0.6,9.2-1.4,14.4-2.6c0.3-0.1,2.7-0.5,7.4-1.4c2.9-0.5,5.2-1.1,7-1.6c5.4-1.7,10.1-3.3,13.9-4.9c1.8-0.7,3.9-2,6.4-3.8
        c3-2.1,5-3.4,6-4c3-1.5,5.2-2.7,6.6-3.5c2.5-1.4,4.6-2.6,6.1-3.7c2.8-1.9,4.9-3.3,6.2-4.2c2.4-1.7,4.3-3.1,5.7-4.4
        c1.5-1.4,3.2-3.2,5-5.6c2.6-3.3,4.1-5.2,4.5-5.6c0.9-1,2.7-2.8,5.4-5.4c2.2-2.1,3.8-3.9,4.8-5.3c2.6-3.8,5-7.8,7.4-12
        c1.4-2.7,3.3-7.1,5.6-12.9c0.7-1.8,1.3-4.2,1.8-7.2c0.5-3.5,0.9-5.7,1.1-6.6c0.2-0.7,0.9-3.2,2.2-7.5c0.8-2.6,1.2-4.6,1.4-6
        c1-4.2,1.6-6.7,1.8-7.6c0.6-2.8,1-5.3,1.2-7.4c0.5-5.4,0.6-10.5,0.4-15.3c-0.2-4.1-1-9.2-2.4-15.1c-1.5-6.6-2.8-11.5-4.1-14.8
        c-0.7-1.9-1.9-4.1-3.6-6.7c-1.9-2.8-3.3-5-4.2-6.5c-2.3-3.9-4.9-7.7-7.7-11.4c-2.8-3.5-5.9-6.9-9.2-10.2c-4.1-4-7.5-7.1-10.2-9.2
        c-0.7-0.6-2.5-2.1-5.3-4.7c-2.1-1.9-3.9-3.3-5.4-4.2c-1.5-1-3.6-2-6.4-3.1c-3.1-1.2-5.2-2.1-6.3-2.7c-1.2-0.6-3.2-1.8-6.1-3.8
        c-2.4-1.6-4.4-2.7-5.8-3.3c-3.1-1.4-5.3-2.4-6.7-3.1c-2.4-1.1-4.4-1.9-6.1-2.4c-2.5-0.9-5.2-1.6-8.1-2.2c-2.8-0.5-4.6-0.9-5.4-1.1
        c-2.4-0.6-4.7-1.3-7-2.2c-2.4-0.8-4.7-1.5-7-2.1c-2.3-0.6-4.7-1.1-7.1-1.5c-2.4-0.3-4.8-0.8-7.2-1.4c-4.7-1.4-9.4-2.8-14.1-4.1
        c-2.3-0.6-4.6-1.3-6.9-2.2c-2.3-0.8-4.6-1.5-7-2.2c-2.5-0.7-4.8-1.4-7-2c-2.5-0.7-4.8-1.4-7.1-2c-2.5-0.7-4.8-1.3-7-2
        c-2.5-0.8-4.9-1.5-7.1-2.1c-2.3-0.6-4.7-1.1-7.1-1.4c-2.4-0.3-4.8-0.8-7.2-1.5c-4.7-1.4-9.4-2.7-14.1-4c-1.4-0.4-3.9-1.9-7.4-4.5
        c-2.1-1.6-4.4-1.6-6.8-0.2c-2.6,1.5-3.8,3.6-3.8,6.2c0,0.8,0.1,2.1,0.2,3.9c0.1,1.8-0.1,3.4-0.6,5c-0.7,2.5-1.3,5-1.7,7.5
        c-0.4,2.6-1,5.1-1.7,7.5c-0.7,2.4-1.6,4.8-2.7,7.2c-1.1,2.3-2,4.7-2.7,7.2c-0.7,2.5-1.2,5-1.7,7.5c-0.4,2.6-0.9,5.1-1.6,7.5
        c-0.7,2.5-1.2,5-1.8,7.5c-0.5,2.5-1,5-1.8,7.4c-0.3,1.3-1.7,3.7-3.9,7.3c-1.3,2-1.2,4.3,0.2,6.9c1.4,2.5,3.2,3.8,5.4,3.7
        c4.3-0.1,7,0.1,8.1,0.4c2.3,0.6,4.7,1.4,7,2.3c2.3,0.9,4.6,1.6,7,2.2c2.4,0.7,4.8,1.2,7.2,1.6c2.4,0.4,4.8,1,7.2,1.6
        c2.3,0.6,4.7,1.4,7,2.4c2.3,0.9,4.6,1.7,6.9,2.4c4.7,1.3,9.4,2.6,14.1,3.8c2.4,0.7,4.8,1.1,7.2,1.3c2.5,0.2,4.9,0.7,7.2,1.3
        c4.7,1.3,9.4,2.6,14.2,4c2.4,0.6,4.7,1.4,7,2.3c2.3,0.9,4.6,1.7,6.9,2.3c2.4,0.7,4.8,1.3,7.1,1.8c2.4,0.6,4.7,1.2,7.1,1.8
        c0.4,0.1,0.8,0.2,1.2,0.2c2.7,0.7,6.7,2.2,11.9,4.6c1.6,0.7,3.5,1.8,5.6,3.2c1.2,0.8,2.9,2,5.1,3.6c2.5,1.6,4.4,2.9,5.7,4.1
        c1.7,1.4,2.9,2.8,3.6,4.1c0.5,0.8,0.8,1.4,0.9,1.6c0.2,1,0.1,2.5-0.4,4.3c-0.2,0.7-0.6,1.5-1.1,2.2c-0.5,0.7-0.8,1.4-1,2.2
        c-0.1,0.8-0.1,1.6,0,2.3c0.1,0.8,0.2,1.6,0.1,2.3c-0.1,0.4-0.4,1.8-0.9,4.4c-0.7,2.8-1.8,5.2-3.2,7.2c-2.4,3.5-6.4,6.8-11.9,9.9
        c-3,1.7-5.2,2.9-6.6,3.6c-2.7,1.3-5.3,2.2-7.8,2.8c-1.8,0.4-4.3,0.6-7.5,0.7c-4.4,0-7.1,0.1-8.1,0.1c-1.1,0-3,0.2-5.8,0.6
        c-3.5,0.5-6.2,0.8-7.9,1c-1.7,0.1-3.9,0.4-6.5,0.8c-3.1,0.5-5.5,0.9-7.1,1.2c-5.9,0.7-10.5,1.4-13.6,2.2c-1,0.2-3.2,0.6-6.8,1.2
        c-2.9,0.5-5.2,1-6.9,1.5c-1.7,0.6-3.8,1.7-6.4,3.2c-3,1.8-5,3-6.1,3.5c-1.2,0.5-3.4,1.3-6.8,2.2c-2.9,0.8-5,1.7-6.5,2.6
        c-1.6,1-3.6,2.4-5.8,4.2c-3.4,2.9-5.2,4.4-5.3,4.5c-4.4,3.5-7.9,6.5-10.6,9.2c-1.3,1.4-2.8,3.2-4.4,5.5c-0.9,1.3-2.2,3.2-4,5.8
        c-0.9,1.3-2.4,3.1-4.3,5.5c-1.7,2.2-2.9,4.2-3.8,5.9c-0.9,1.7-1.8,3.8-2.7,6.5c-0.5,1.5-1.2,3.7-2.2,6.7c-0.5,1.5-1.3,3.6-2.5,6.5
        c-0.9,2.6-1.6,4.9-2,6.8c-0.7,3.3-1.2,8-1.6,14c-0.2,2.5-0.5,4.9-0.9,7.2c-0.5,2.4-0.8,4.8-1,7.2c-0.2,2.5-0.3,5-0.3,7.3
        c0,2.6-0.1,5-0.2,7.2c0,0.4,0.1,0.7,0.4,1.1c0.3,0.4,0.4,0.7,0.4,1c0,0.7-0.1,2.4-0.3,5c-0.1,2.9,0,5.6,0.5,8.2c1,5.7,2,10.1,2.8,13
        c0.5,1.5,1.4,3.5,2.7,5.9c1.7,3.1,2.8,5.1,3.2,6.1c0.6,1.3,1.4,3.3,2.5,6c1,2.4,2,4.4,3,6c2.9,4.8,5.3,8.5,7.4,11.1
        c3,3.7,6,7,8.9,9.9c1.4,1.3,3.3,2.8,5.8,4.5c1.4,1,3.7,2.5,6.7,4.5c1.6,1.1,3.8,2.4,6.4,3.7c1.5,0.8,3.9,1.9,7.1,3.5
        c4.6,2.3,9.3,4.2,14.1,5.9c1.1,0.4,3.4,1.4,6.9,3.1c3,1.5,5.4,2.4,7.4,2.8c2,0.4,4.5,0.8,7.5,1c1.7,0.2,4.3,0.5,7.9,0.8
        c5.7,0.5,10.9,0.8,15.4,0.8c0.5,0,1.2-0.1,2.2-0.4c1-0.2,1.7-0.3,2.2-0.4c2.4,0,4.8,0.1,7.2,0.4c2.4,0.2,4.8,0.3,7.2,0.3
        c2.3,0,4.7-0.1,7.2-0.2c2.3-0.1,4.8-0.2,7.2-0.2c2.4,0,4.8-0.2,7.2-0.6c2.4-0.4,4.8-0.7,7.2-0.7c2.4,0,4.8,0.3,7.2,0.8
        c2.4,0.5,4.8,0.7,7.2,0.7c2.3,0,4.7-0.1,7.2-0.2c2.3-0.1,4.7-0.2,7.2-0.2c4.8-0.1,9.6,0,14.4,0.1c0.3,0,0.6-0.2,1-0.5
        c0.3-0.3,0.6-0.5,0.9-0.6c0.4,0,0.9,0.1,1.4,0.4c0.5,0.3,0.9,0.4,1.4,0.3c0.7,0,1.8-0.2,3.2-0.4c1.4-0.2,2.6-0.2,3.5-0.1
        c0,0.1-0.3,0.2-0.9,0.3c-0.5,2.4-0.7,4.9-0.6,7.4c0,2.5-0.2,5-0.7,7.4c-0.5,2.4-1.2,4.8-2.1,7.1c-0.9,2.3-1.6,4.7-2.1,7.1
        c-1,4.9-2,9.7-3.1,14.5c-0.5,2.4-0.9,4.8-1.1,7.4c-0.3,2.4-0.6,4.8-1.1,7.3c-0.5,2.4-1,4.8-1.6,7.2c-0.6,2.4-1.2,4.8-1.6,7.2
        c-0.5,2.4-0.8,4.9-0.8,7.4c0,2.6-0.2,5-0.7,7.5c-0.5,2.4-1.1,4.8-1.9,7.2c-0.8,2.3-1.4,4.7-1.8,7.2l-0.4,1.8
        c-0.7,4.8-1.2,10-1.4,15.4c0,0.3-0.2,2.7-0.6,7.2c-0.3,3.2-0.4,6-0.3,8.2c0.1,3.8,0.6,8.9,1.2,15.5c0.2,1.9,0.6,4.4,1.2,7.5
        c1,4.9,1.6,7.5,1.7,7.8c0.4,2.1,1,4.5,1.7,7.2c0.4,1.6,1.1,3.9,2,7c0.8,3.1,2.4,7.7,4.8,13.8c0.3,0.9,1.1,3.2,2.2,7
        c0.9,2.9,1.7,5.1,2.5,6.8c0.9,1.8,2.1,4,3.6,6.4c0.9,1.4,2.2,3.4,3.9,6.1c0.4,0.6,1.6,2.7,3.7,6.4c1.5,2.6,2.8,4.6,4,6.1
        c1.3,1.6,2.9,3.4,4.9,5.5c1.1,1.2,2.8,2.9,5.1,5.2c1.5,1.5,3.3,3.1,5.4,4.9c0.3,0.2,2.2,1.8,5.7,4.6c4.3,3.4,8.3,6.3,11.9,8.5
        c1.6,1,3.8,2.2,6.4,3.5c1.5,0.7,3.7,1.7,6.6,3.1c0.3,0.1,0.5,0.2,0.8,0.2c0.3,0,0.6,0.1,0.8,0.2c0.3,0.1,0.5,0.5,0.6,1
        c0.1,0.6,0.3,0.9,0.6,1.1c0.2,0.1,1.7,0.5,4.5,1.3c3.6,1.1,7.2,2.2,10.9,3.5c1.6,0.5,4,1.2,7.2,2c3.9,0.9,6.6,1.6,8.3,2.1
        c1.2,0.4,3.7,1.2,7.3,2.5c3.2,1.2,5.8,2,7.9,2.5c0.4,0.1,2.9,0.8,7.6,2c3.1,0.8,5.8,1.4,7.9,1.8c1.9,0.4,4.5,0.6,7.8,0.8
        c3.7,0.2,6.2,0.4,7.6,0.5c2.3,0.3,7.4,0.8,15.1,1.3c8.5,0.6,13.6,0.8,15.2,0.8v0.7c6.5,0,11-0.1,13.5-0.3c1.8-0.1,4-0.5,6.8-1
        c3.5-0.7,5.7-1.2,6.6-1.3c1.9-0.3,4.1-0.8,6.6-1.4c1.4-0.4,3.6-1,6.5-1.8c5.2-1.3,9.5-2.6,12.9-3.9c5-1.9,9.1-3.6,12.4-5.3
        c0.8-0.4,2.9-1.3,6.2-2.8c2.6-1.1,4.6-2.2,6-3.2c5-3.4,8.8-6.4,11.5-9c3.5-3.2,6.8-6.8,10-10.8c1.1-1.4,2.4-3.4,3.8-6
        c1.9-3.7,3.1-5.9,3.5-6.7c1.7-2.6,3-4.6,3.9-6c1.6-2.5,2.7-4.6,3.5-6.5c2.1-5,3.8-9.6,5-13.8c1.4-5.1,2.5-9.9,3.2-14.3
        c1-5.9,1.6-10.8,1.8-14.5c0.2-3.1,0.3-7.9,0.1-14.6c0-0.5-0.2-2.2-0.8-5.3c-0.6-3.3-0.9-6.4-1-9.2c0-1.2,0.1-3.4,0.4-6.8
        c0.3-3.2,0.4-5.8,0.3-7.8c-0.1-1.4-0.5-6.2-1.2-14.5c-0.1-1.6-0.4-3.9-0.9-7c-0.5-3.4-0.8-5.8-1-7.5c-0.2-1.6-0.5-3.9-1-7
        c-0.5-3.3-0.9-5.8-1-7.4c-0.9-6.3-1.6-11.1-2.1-14.4c-0.2-1.5-0.3-3.9-0.3-7.2c0-3.2-0.2-5.7-0.5-7.4c-1.1-6.3-1.9-11.1-2.5-14.4
        c-0.3-1.6-0.9-3.9-1.8-7c-0.9-3.2-1.5-5.5-1.8-7.1c-0.3-1.5-0.6-3.9-1-7.1c-0.4-3.2-0.8-5.6-1.2-7.3c-0.3-1.6-0.9-3.9-1.8-6.9
        c-0.9-3.2-1.6-5.6-2-7.1c-1.2-6.3-2.2-11.1-3-14.3c-0.3-1.4-0.7-3.8-1.2-7.2c-0.5-3.1-0.9-5.5-1.3-7.2c-0.4-1.6-1.2-3.8-2.2-6.8
        c-1.1-3.1-1.9-5.5-2.4-7c-1.8-6.2-3.1-10.8-4-14c-0.4-1.4-1-3.7-1.8-7c-0.8-3.1-1.4-5.4-1.9-7.1c-0.5-1.7-1.2-4-2.2-6.9
        c-1.2-3.4-2-5.8-2.3-7c-1.8-6.2-3.2-10.9-4.2-14c-0.5-1.6-1.4-3.9-2.7-6.8c-1.4-3.1-2.3-5.4-2.8-6.8c-2-6.1-3.5-10.7-4.7-13.8
        c-0.4-1.2-1.2-3.5-2.2-6.9c-1-2.9-1.8-5.2-2.4-7c0-0.1-0.1-0.2-0.4-0.4c-0.2-0.1-0.3-0.2-0.4-0.3c-0.7-3.7-2.1-8.4-4-14.1
        c-0.3-0.8-1.1-3-2.4-6.4c-1.1-2.9-2-5.4-2.6-7.4c-0.4-1.2-1.2-3.4-2.5-6.6c-1.2-2.9-2.1-5.3-2.6-7.1c-0.4-1.5-0.8-3.9-1.1-7.1
        c-0.4-3.4-0.8-5.8-1.1-7.4c-0.3-1.4-1.1-3.7-2.4-6.9c-1.2-3-2-5.4-2.4-7.1c-0.3-1.6-0.5-4-0.6-7.2c-0.1-3.4-0.2-5.9-0.5-7.4
        c-0.2-1.5-0.9-3.7-1.9-6.6c-1-2.8-1.5-4.9-1.8-6.4c-0.2-1.8-0.4-4-0.4-6.8c-0.1-3.5-0.2-5.7-0.2-6.6c-0.1-1-0.3-3.2-0.7-6.9
        c-0.3-2.7-0.5-4.9-0.5-6.5c-0.1-5,0-9.5,0.4-13.5c0.1-1.8,0.6-4.1,1.5-6.8c1.1-3.3,1.8-5.4,2-6.2c0.1-0.5,0.4-2.8,1-7
        c0.4-2.6,0.9-4.7,1.5-6.2c2.1-4.8,4.6-8.6,7.5-11.3l13.9-6.4c1.6-0.7,3.8-1.6,6.7-2.6c4-1.4,6.6-2.2,7.6-2.6
        c1.2-0.4,3.4-1.5,6.8-3.1c2.9-1.4,5.3-2.4,7.2-2.9c5.4-1.5,10.4-2.5,15-3.2c2-0.3,4.6-0.5,7.6-0.4c1.7,0,4.3,0.1,7.7,0.1
        c7.3,0,12.6,0.5,16,1.4c1.5,0.4,3.2,1.1,5,2.2c1.4,0.8,3.3,2,5.8,3.6c1,0.7,2.6,1.7,4.9,3c2,1.4,3.7,2.8,5,4.3c1,1.1,2,2.7,3.2,4.9
        c0.7,1.2,1.7,3.1,3.1,5.8c0.2,0.8,0.7,2.4,1.5,4.9c0.8,2.7,1.4,5.4,1.8,8.2c0.4,2.6,0.9,7.1,1.5,13.6c0.1,1,0.5,3.1,1.1,6.5
        c0.5,2.8,0.8,5.2,0.9,7.1c0.3,4.9,0.5,9.5,0.5,13.7c0,1.7,0,4-0.1,6.7c-0.1,1.6-0.2,4-0.3,7.2c-0.1,2.9-0.4,7.6-1,13.9
        c-0.2,3-0.7,7.6-1.5,14c-0.1,1.4-0.2,3.6-0.1,6.8c0,3.1,0,5.5-0.2,7.2c-0.2,1.5-0.7,3.8-1.4,6.8c-0.8,3.1-1.3,5.5-1.5,7
        c-0.2,1.4-0.4,3.7-0.5,6.9c-0.1,3.1-0.3,5.4-0.5,7.1c-0.5,3-1.5,7.5-2.9,13.7c-0.3,1.6-1.3,6.1-3,13.6c-0.4,1.7-0.9,3.9-1.7,6.7
        c-1,3.3-1.6,5.6-1.9,6.9c-0.2,0.7-0.7,3-1.5,6.8c-0.6,2.8-1.2,5-1.7,6.9c-0.3,1.4-0.8,3.6-1.3,6.8c-0.5,3-1,5.3-1.5,6.9
        c-0.4,1.5-1.2,3.7-2.3,6.5c-1.2,3-2,5.2-2.4,6.6c-0.4,1.4-1,3.7-1.7,6.8c-0.7,3-1.3,5.3-1.8,6.9c0,0.1-0.1,0.3-0.2,0.4
        c-0.1,0.1-0.2,0.2-0.2,0.4c-0.1,0.2-0.4,1.7-0.9,4.5c-0.6,3.5-1.3,6.8-1.9,10c-0.3,1.4-0.8,3.6-1.5,6.7c-0.6,2.9-1.1,5.5-1.5,7.8
        c-0.1,1-0.5,3.3-1.2,7c-0.6,3-1,5.6-1.2,7.6c-0.1,1.2-0.5,3.6-1.1,7.2c-0.6,3.1-1,5.6-1,7.5c-0.2,3.2-0.2,8.1,0,14.8
        c0,3.8,0.1,8.7,0.4,14.8c0.1,1.7,0.4,4.1,1,7.2c0.6,3.5,1,5.9,1.2,7.4c0.2,1.5,0.2,3.9,0,7.4c-0.2,3.2-0.1,5.7,0.1,7.5
        c0.3,1.9,0.8,4.4,1.5,7.2c0.4,1.6,0.9,4,1.7,7.2c0.4,1.7,1.1,4.1,2.2,7.1c1.3,3.3,2.1,5.6,2.5,7c0.7,2.4,2.2,7,4.6,14
        c0.5,1.5,1.3,3.8,2.3,6.9c0.9,2.8,1.8,5.1,2.6,7c0.8,1.8,1.8,4,3.1,6.6c0.7,1.5,1.9,3.7,3.4,6.6c0.6,1.2,1.5,3.5,2.7,6.9
        c1,3,2,5.3,2.9,6.8c0.9,1.5,2.3,3.4,4.3,5.6c2.2,2.5,3.7,4.3,4.4,5.4c0.7,1,1.9,3,3.7,6c1.5,2.5,2.8,4.5,3.9,5.8
        c1.9,2.4,5.1,5.8,9.5,10.2c1,1.1,2.6,2.9,4.6,5.2c1.9,2.1,3.5,3.8,4.8,5c1.3,1.2,3.1,2.7,5.4,4.5c2.8,2.1,4.7,3.5,5.6,4.2
        c1,0.8,2.7,2.5,5,4.9c2.1,2.1,3.8,3.7,5.2,4.8c1.3,1,3.4,2.1,6,3.4c3,1.5,5.1,2.6,6.2,3.3c1.2,0.8,3,2.2,5.5,4.3
        c2.3,1.9,4.2,3.3,5.7,4.1c2.7,1.5,6.9,3.6,12.5,6.2c1.6,0.8,3.7,1.7,6.4,2.8c3.5,1.4,5.6,2.2,6.5,2.6c3.8,1.7,8.1,3.4,13,5.2
        c1.7,0.7,3.9,1.4,6.6,2.2c1.5,0.4,3.7,1.1,6.7,2.1c1.3,0.4,3.5,1.4,6.4,2.8c2.7,1.3,4.9,2.2,6.5,2.7c1.7,0.5,3.9,1,6.8,1.5
        c3.4,0.6,5.7,1.1,6.9,1.4c1.1,0.3,3.3,1,6.7,2c2.8,0.9,5.1,1.5,6.8,1.8c0.3,0.1,0.7,0,1.1-0.3c0.4-0.3,0.8-0.4,1.1-0.3
        c0.6,0.1,4.9,0.5,12.9,1.2c2.8,0.2,7.1,0.5,12.9,0.7c1.1,0.1,3.2,0.4,6.2,0.9c2.8,0.5,5,0.8,6.7,0.8c1.3,0,3.2-0.3,5.6-0.8
        c2.6-0.6,4.4-0.9,5.6-1c1.1,0,2.9,0,5.6,0c2.4,0,4.2,0,5.6-0.1c3.1-0.2,7.7-0.9,13.8-1.9c1.4-0.2,3.7-0.3,7-0.3c3,0,5.4-0.2,7-0.5
        c2.5-0.5,7-1.6,13.5-3.3c1.8-0.5,4-1.2,6.7-2.3c3.4-1.3,5.5-2.1,6.5-2.4c3-1,7.3-2.7,13-5.1c1.2-0.5,3.4-1.2,6.7-2.1
        c2.9-0.8,5-1.7,6.5-2.5c1.8-0.9,3.8-2.1,6.1-3.5c1.3-0.8,3.3-2.1,5.9-3.8c1.6-1,3.5-2.4,5.6-4.2c3.4-2.8,5.2-4.2,5.4-4.4
        c0.4-0.3,2.3-1.7,5.7-4.2c2.3-1.7,4.1-3.1,5.4-4.4c1.3-1.2,2.8-3,4.5-5.3c2.3-3.1,3.7-4.9,4.2-5.5c0.7-0.8,2.3-2.5,4.9-5
        c2-2.1,3.5-3.8,4.5-5.3c1-1.5,2.2-3.5,3.5-6c1.9-3.8,2.9-5.8,3.1-6.2c0.9-1.6,1.8-3.7,2.8-6.4c1.3-3.6,2.1-5.8,2.4-6.5
        c1.8-4.3,3.3-8.6,4.7-13c0.4-1.3,1.4-3.7,2.9-7.2c1.3-3,2.2-5.5,2.6-7.4c0.4-1.8,0.6-4.4,0.7-7.7c0.1-3.9,0.2-6.5,0.4-7.9
        c0.1-1.3,0.6-3.8,1.3-7.6c0.6-3.2,0.9-5.9,1-7.9c0.1-1.8-0.2-4.3-0.8-7.6c-0.7-3.7-1-6.3-1.1-7.9c-0.1-3.4-0.2-6-0.3-7.7
        c-0.2-3-0.4-5.6-0.6-7.8c0-0.4,0.1-2.6,0.4-6.4c0.3-3.2,0.2-6-0.1-8.5c-0.2-1.6-0.7-3.8-1.5-6.7c-1-3.7-1.6-6.3-1.9-7.6
        c-0.2-1-0.6-3.3-1.2-6.9c-0.5-3.1-1-5.6-1.5-7.6c-0.4-1.5-1.3-3.8-2.6-6.6c-1.4-3.2-2.4-5.5-2.9-7c-1.1-3.2-2.8-7.7-5.2-13.7
        c-0.5-1.2-1.2-3.5-2.2-6.9c-0.9-3-1.7-5.4-2.5-7.1c-0.7-1.5-1.9-3.6-3.6-6.2c-1.9-2.8-3.2-5-4-6.4c-2.6-5.9-4.8-10.3-6.3-13.2
        c-0.7-1.2-1.7-3.4-3-6.6c-1.2-3-2.3-5.2-3.2-6.8c-0.8-1.5-2.2-3.5-4.2-6c-2.1-2.7-3.6-4.8-4.4-6c-0.7-1.1-1.9-3.2-3.7-6.2
        c-1.6-2.7-2.9-4.8-3.9-6.4c-3.5-5.4-6.3-9.5-8.2-12.2c-1-1.4-2.5-3.3-4.6-5.7c-2.3-2.7-3.9-4.6-4.8-5.7c-1.1-1.4-2.6-3.3-4.6-5.6
        c-2.4-2.8-4-4.7-4.8-5.7c-1.2-1.5-2.7-3.3-4.7-5.5c-2.7-3-4.3-4.9-4.9-5.5c-0.9-1.1-2.4-3.1-4.4-5.9c-1.9-2.6-3.4-4.5-4.5-5.9
        c-0.1-0.1-0.2-0.2-0.5-0.2c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.4-0.4-0.7-0.5c-0.3-0.1-0.5-0.3-0.8-0.5c-1.3-1.4-2.8-3.1-4.2-5.1
        c-0.6-0.7-1.8-2.5-3.8-5.4c-1.1-1.6-2.2-3.6-3.4-6c-1.2-2.6-2-4.5-2.6-5.7c-2.1-4.3-3.3-6.8-3.7-7.7c-1-2.3-1.4-3.9-1.2-4.6
        c0,0,0.9-0.9,2.5-2.6c2.4-2.1,5.4-4.1,9.2-6c4.8-2.4,9.1-4.3,13.1-5.7c4.7-1.6,9.3-2.9,13.7-4c4.5-1.1,9.1-2.2,13.8-3.1
        c1.5-0.3,3.8-0.5,6.8-0.6c3.3-0.2,5.7-0.4,7.3-0.7c0,0,0.8,0.1,2.2,0.2c0.5,0,0.8-0.3,0.9-1c0.2-2.9,0-5.5-0.6-7.6
        c-1-3.3-1.7-5.8-1.9-7.5c-0.4-2.5-0.6-5.1-0.7-7.6c0-2.6-0.2-5.1-0.6-7.6c-0.4-2.5-0.9-5-1.7-7.5c-0.8-2.5-1.4-5-1.8-7.5
        c-0.4-2.5-0.6-5.1-0.7-7.7c-0.1-2.6-0.3-5.1-0.7-7.6c-0.4-2.5-0.7-5-0.9-7.6c-0.2-2.5-0.5-5.1-0.9-7.6c-0.2-1.1-0.3-3.7-0.5-7.8
        c-0.1-2.2-0.7-4.6-1.8-7.4c-0.2-0.6-0.7-0.8-1.4-0.6c-1.4,0.6-2.2,0.8-2.2,0.8c-1.7,0.3-4,0.7-6.8,1.4c-3.2,0.7-5.4,1.2-6.6,1.4
        c-1.3,0.2-3.6,0.6-6.8,0.9c-2.9,0.3-5.1,0.7-6.7,1c-1.6,0.4-3.8,1.1-6.5,2.1c-3,1.2-5.1,1.9-6.3,2.2c-4.6,1.2-8.9,2.5-13.1,3.8
        c-1.1,0.4-3.3,1-6.6,1.8c-2.7,0.7-4.9,1.3-6.5,1.9C846.1,189.9,842,191.6,840.2,192.4 M851.7,195.6c3.8-1.2,6.2-1.9,7.2-2.3
        c1.1-0.4,3.4-1.4,6.7-3c2.8-1.4,5.2-2.3,7-2.9c3.3-1,8.1-2.2,14.4-3.6c1.7-0.4,4.1-0.8,7.2-1.2c3.6-0.5,6-0.8,7.5-1.1
        c0.7-0.1,3.1-0.6,7-1.5c2.9-0.6,5.3-1.1,7.2-1.3c1.3,2.6,1.9,5.1,1.7,7.4c-0.3,3.5-0.4,6.2-0.1,8c0.4,2.6,0.9,5.1,1.5,7.6
        c0.6,2.5,1.1,5.1,1.5,7.7c0.4,2.5,0.8,5.1,1.4,7.7c0.5,2.5,0.9,5.1,1.3,7.7c0.4,2.6,0.6,5.1,0.8,7.8c0.1,2.6,0.4,5.2,0.8,7.8
        c0.2,1.2,0.9,3.7,2,7.6c0.6,2.1,0.6,4.6,0.1,7.6c-1.4,0.2-3.9,0.6-7.5,1c-2.9,0.4-5.2,0.7-6.9,1c-2.2,0.5-4.7,1.1-7.6,2
        c-3.1,0.9-5.4,1.6-6.9,2c-2.1,0.6-4.6,1.5-7.5,2.8c-3.9,1.7-6.1,2.6-6.5,2.8c-6.9,2.6-11.5,4.6-13.8,5.9c-6.1,3.6-9.8,6.8-11,9.4
        l-74.1-23.9c0,0,0,0,0,0c1-3.1,1.8-5.4,2.3-7c0.9-2.6,1.9-4.8,2.9-6.6c2.3-4.4,5-8.5,7.9-12.2c2.9-3.8,6.1-7.4,9.6-10.9
        c1.3-1.3,3.2-2.7,5.7-4.3c3.3-2.2,5.4-3.5,6.1-4.1c0.4-0.3,2.2-1.7,5.6-4.4c2.3-1.8,4.3-3.2,6-4.2s3.9-2.1,6.5-3.3
        c1.5-0.7,3.8-1.7,6.9-3.1C846.5,197.3,848.8,196.4,851.7,195.6 M650.2,87.8c0.3,0.3,1.9,2,4.8,5.1c0,0,0.1,0.1,0.1,0.1L597,145.9
        c-3.1-3.4-5.8-5.8-7.9-7.2c-2.9-1.9-5.2-3.3-6.8-4.2c-2.3-1.3-4.2-2.1-6-2.6c-2.2-0.6-5.1-0.9-8.6-0.8c-4.1,0.2-7.3,0.3-9.5,0.3
        c-0.3,0-0.8,0-1.3-0.1l-8-79.1c0.6,0,1.3,0.1,2,0.1c3.6,0.2,6,0.4,7.1,0.4c0.5,0,2.7-0.1,6.6-0.2c2.6-0.1,4.8,0,6.5,0.1
        c1.5,0.1,3.7,0.3,6.6,0.5c2.6,0.2,4.7,0.5,6.5,0.8c3.5,0.6,7.8,1.6,12.8,3c1.8,0.5,4,1.3,6.5,2.4c3.9,1.7,6,2.6,6.4,2.7
        c1.7,0.7,3.8,1.7,6.1,3.1c3.6,2.1,5.5,3.3,6,3.5c1,0.5,3.1,1.4,6.4,2.8c2.7,1.1,4.8,2.1,6.2,3c1.5,1.1,3.3,2.5,5.4,4.4
        c1.2,1,2.9,2.5,5.2,4.6C646.8,84.4,648.4,86,650.2,87.8 M671.8,114.7c0.8,1.3,2.1,3.2,3.8,5.8c1.5,2.3,2.7,4.3,3.5,5.9
        c0.1,0.3,0.4,0.5,0.7,0.8c0.3,0.2,0.5,0.5,0.6,0.8c0.1,0.3,0.2,0.6,0.2,1s0.1,0.6,0.2,0.9c1.1,2.6,1.7,4.2,1.9,4.6
        c1.1,2.8,2,5.7,2.8,8.7c0.3,1.3,0.5,3.4,0.6,6.5c0.1,3.3,0.3,5.9,0.7,7.7c0.2,1.2,0.9,3.3,2,6.4c1,2.9,1.6,5.3,1.9,7.1
        c0.8,6.1,1.4,10.8,1.7,14c0.3,3.1,0.6,6.8,0.9,11.2l-78.2,7.1c0-0.2,0-0.4,0-0.5c-0.1-1.9-0.4-4.4-1-7.4c-0.6-3.4-1-5.6-1.1-6.8
        c-0.5-6.8-1-11.5-1.5-14.2c-0.5-2.7-1.2-5.5-2.2-8.3c-1-2.7-1.6-4.5-1.9-5.4c0-0.1,0.2-0.2,0.6-0.4c0.4-0.2,0.6-0.4,0.6-0.4
        c0-0.1-0.2-0.1-0.5,0c-0.3,0.1-0.5,0.1-0.5,0.1c-1.2-2.1-2.6-4.2-4.2-6.3c-0.5-0.6-1.2-1.5-2.1-2.5L660,98.1c1.7,1.9,3.2,3.5,4.3,5
        c1.2,1.5,2.5,3.4,3.9,5.7C669,110,670.2,112,671.8,114.7 M783,265.5c0-0.1,0.1-0.2,0.1-0.4l76.1,24.5c0.6,2.4,1.6,5.3,3,8.5
        c2.2,5,4.7,9.6,7.5,13.9c4.1,5.9,7.3,10.1,9.7,12.5c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0.1,0.2,0.3,0.2,0.4
        c0,0.2,0,0.4,0.2,0.5c0.8,0.8,2,2.2,3.7,4l-62,45.8c-0.9-0.9-1.8-1.7-2.5-2.4c-2.3-2.2-4.3-4.3-6-6.4c-1.5-1.9-4.4-5.9-8.5-11.9
        c-2.4-3.5-4.9-7.6-7.7-12.4c-0.4-0.8-1.7-2.8-3.8-6.2c-1.6-2.6-2.8-4.7-3.6-6.5c-0.8-1.7-1.5-4-2.2-6.9c-1.1-4.2-1.7-6.6-1.9-7.2
        c-0.9-2.7-1.9-7.5-3-14.2c-0.6-3.2-1-5.5-1.2-7.1c-0.4-2.8-0.6-5.2-0.7-7.3c-0.1-3.2-0.2-5.7-0.3-7.3c-0.1-2.9,0.1-5.4,0.4-7.4
        S782.2,268.1,783,265.5 M693.5,203.2c0,0.8-0.1,1.7-0.2,2.7c-0.3,3.2-0.4,5.6-0.4,7.2c0,1.4,0.3,3.7,0.8,6.9
        c0.5,3.1,0.7,5.5,0.7,7.2c0,1.5-0.2,3.8-0.7,6.9c-0.4,3.2-0.7,5.6-0.8,7.1c-0.1,1.4,0,3.7,0.2,6.9c0.1,3.1,0.1,5.5,0,7.2
        c-0.1,1.6-0.5,3.9-1.1,6.9c-0.7,3.2-1.1,5.5-1.2,7c-0.2,1.6-0.5,3.9-1,6.9c-0.6,3.3-1,5.6-1.2,7s-0.2,3.8-0.2,7c0,1.1,0,2.1,0,3
        l-77.8-9.8c0.7-4.3,1.2-7.6,1.4-10c0.2-1.5,0.6-3.9,1.3-7.1c0.6-3,1-5.2,1.1-6.9c0.2-1.9,0.3-4.3,0.5-7.2c0.2-4.3,0.3-6.6,0.3-6.9
        c0.1-1.9,0.1-4.3,0.1-7.3c-0.1-3.5-0.1-5.8-0.1-6.9c0-1.5,0.2-3.9,0.5-7.3c0.3-3,0.4-5.2,0.4-6.8c0-1.9-0.1-4.2-0.4-6.9L693.5,203.2
         M687.8,300.2c-0.1,1.1-0.3,2.5-0.4,4.1c-0.4,2.9-0.7,5.3-1,7.1c-0.4,2.3-1.2,6.9-2.6,13.9c-0.3,1.5-1,3.8-2.1,6.7
        c-1.1,3-1.9,5.3-2.2,6.8c0,0.2-1.1,4.8-3.2,13.7c-0.3,1.4-0.6,3.7-0.9,6.9c-0.3,3.1-0.6,5.4-1,7.1c-0.4,1.5-1.2,3.7-2.3,6.6
        c-1.2,3-2,5.2-2.4,6.8c-0.2,0.9-0.6,2.4-1.1,4.5l-74.4-18.6c0.6-2.2,1.3-5.1,2.2-8.7c0.4-1.6,0.8-4,1.1-7.1c0.3-3.2,0.7-5.5,1-7
        c1.5-6.2,2.6-10.8,3.2-13.8c0.3-1.4,1-3.8,1.9-7c0.8-2.9,1.4-5.1,1.7-6.8c0.4-1.8,0.8-4.2,1.2-7.1c0.5-3.5,0.9-5.8,1.1-6.9
        c0.7-4.6,1.3-8.3,1.7-11.1L687.8,300.2 M667.1,391.1c-0.2,0.9-0.4,1.7-0.6,2.4c-0.4,1.5-1,3.7-1.7,6.8c-0.7,3-1.3,5.3-1.8,6.9
        c-0.5,1.5-1.3,3.7-2.5,6.5c-1.2,2.9-2.1,5.1-2.5,6.6c1,0.4,1.5,0.6,1.5,0.6c-0.1,0.6-0.8,2.1-2,4.6c-1.2,2.9-2.1,5.7-2.6,8.4
        c-0.3,1.5-0.5,3.6-0.7,6.4c-0.2,3.6-0.4,6-0.5,7.3c-0.2,1.6-0.3,3.8-0.2,6.6c0,3.5,0,5.8,0,7c-18-1-33.6-1.8-47-2.4
        c-14.9-0.6-25.1-0.8-30.7-0.6c0.2-1.3,0.3-2.3,0.3-2.9c0.1-1.4,0.1-3.8,0.1-7.4c0-3,0-5.3,0.2-7c0.1-1.2,0.3-3.7,0.5-7.5
        c0.2-2.9,0.4-5.2,0.6-6.9c0.9-6.8,1.6-11.6,2.1-14.2c0.7-3.4,1.5-6.6,2.5-9.6c0.9-2.5,1.4-4,1.5-4.2c0-0.1,0.2-0.2,0.4-0.2
        c0.3-0.1,0.5-0.2,0.5-0.3c0.5-1.6,1.1-4,1.8-7c0.7-3.2,1.2-5.5,1.6-6.8c0.5-1.5,1.3-3.8,2.5-6.8c0.8-1.9,1.4-3.6,1.9-5L667.1,391.1
         M889.5,335.2c0.5,0.6,0.9,1.1,1.3,1.5c1,1.1,2.6,2.9,5,5.4c2.2,2.3,3.8,4,4.8,5.4c0.9,1.1,2.5,2.9,4.8,5.5c2,2.3,3.5,4.2,4.6,5.5
        c1,1.3,2.2,3.5,3.6,6.4c1.5,3,2.7,5.1,3.5,6.4c0.9,1.3,2.6,3.1,4.9,5.5c2.2,2.3,3.8,4.1,4.8,5.4c1,1.4,2.2,3.6,3.6,6.4
        c1.5,3,2.6,5.1,3.4,6.4c0.7,1.1,2.1,3.1,4.2,6c0,0.1,0.1,0.1,0.1,0.1l-66.6,42c-1.5-2.6-2.8-4.8-3.9-6.4c-3-4.7-5.6-8.8-8-12.2
        c-0.7-1-2-3-3.9-6c-1.7-2.6-3-4.7-4.2-6.2c-1-1.3-2.5-3.2-4.7-5.5c-2.3-2.5-3.9-4.4-4.9-5.6c-1.1-1.4-4.2-5.1-9.2-11.2
        c-0.9-1.1-2.4-3-4.4-5.8c-0.6-0.9-1.2-1.7-1.8-2.4L889.5,335.2 M942.3,407.7c0.9,1.5,1.9,3.4,3,5.6c1.6,3.2,2.7,5.3,3.2,6.4
        c0.2,0.4,1.4,2.6,3.5,6.4c1.4,2.5,2.5,4.6,3.4,6.3c3.7,7.6,5.8,11.9,6.3,13c0.8,1.7,1.6,4,2.6,6.8c1.3,3.7,2.1,6,2.4,6.8
        c0.7,1.8,1.5,4.1,2.3,6.9c1,3.5,1.7,5.7,2,6.6c0.4,1.2,1.2,3.5,2.5,6.9c1,2.7,1.7,4.9,2.2,6.5c0.5,1.8,1,3.9,1.5,6.4l-75.6,20.1
        c-0.8-3.2-1.8-6.8-3-10.6c-0.3-0.9-0.8-3.1-1.6-6.6c-0.6-3-1.3-5.4-2-7.2c-0.3-0.8-1.1-2.9-2.3-6.5c-1-2.9-1.9-5.2-2.8-7.1
        c-0.7-1.5-1.8-3.5-3.4-6.2c-1.8-3-3.1-5.2-3.8-6.6c-0.8-1.4-2-3.4-3.8-6c-1.6-2.4-2.8-4.3-3.7-5.6L942.3,407.7 M904.7,531.5
        c0-0.3,0.2-0.6,0.7-0.8c0.5-0.3,0.7-0.5,0.8-0.8c0.1-0.2,0.2-0.3,0.2-0.4c0-0.3-0.5-1.8-1.3-4.5c-0.6-1.9-1.2-3.8-1.7-5.6l75.5-20.1
        c0.1,0.2,0.1,0.4,0.1,0.6c0.3,1.6,1,4.1,2.1,7.4c0.9,2.8,1.4,5,1.6,6.4c0.9,6.5,1.4,11.2,1.5,14.2c0,0.1-0.4,0.2-1.4,0.4
        c0.7,6.3,1.1,11.3,1.3,15c0.1,1.4,0.3,3.9,0.8,7.6c0.4,3.1,0.6,5.6,0.5,7.4c-0.1,1.9-0.4,4.4-1,7.5c-0.8,3.7-1.2,6.1-1.3,7.3
        c-0.2,1.7-0.4,4.2-0.7,7.5c-0.3,2.9-0.6,5.4-1,7.4c-0.4,2-1.1,4.4-2.1,7.2c-1.5,4.3-2.3,6.7-2.4,7c-0.3,1.1-0.7,2.9-1,5.3
        l-70.2-36.3c0.1-0.4,0.2-0.7,0.2-0.9c0.7-2.6,1.1-4.9,1.3-6.9c0.2-2.1,0.3-4.6,0.3-7.4c0-0.3,0-2.6-0.1-6.8
        c-0.1-2.4-0.3-5.1-0.8-8.1c-0.4-2.9-0.7-4.9-0.9-6c-0.1-0.6-0.2-1.2-0.5-1.8C904.8,532.7,904.7,532.1,904.7,531.5 M898.2,590.3
        c2.5-4.4,4.3-8.5,5.3-12.2l70.8,36.7c-0.1,0.2-0.1,0.3-0.2,0.5c-0.6,1.5-1.7,3.5-3.1,5.8c-1.8,2.9-3,4.8-3.5,5.7
        c-2.2,4-4.4,7.8-6.8,11.2c-3.3,4.9-5.9,8.4-7.8,10.6c-1.1,1.4-2.7,2.9-4.6,4.7c-2.2,2-3.8,3.5-4.9,4.5c-2.4,2.3-4.2,4.1-5.4,5.2
        c-2.1,2-4,3.6-5.8,4.9c-4.6,3.5-8.7,6.3-12.5,8.5c-1.7,1-3.9,2.2-6.6,3.4c-4.6,2-6.9,3.1-7,3.1c-3.6,1.8-8.3,3.7-13.9,5.8
        c-0.9,0.3-2.3,0.9-4.1,1.8l-24.9-73c0.9-0.3,1.9-0.7,2.9-1c1.9-0.7,4-1.7,6.3-3c1.4-0.7,3.4-1.9,6-3.5c3-1.8,6.6-4.7,10.8-8.7
        C893.2,597.6,896.1,594,898.2,590.3 M652.8,475c0,2.9,0.4,7.5,1.2,13.6c0.4,4.6,1,9.1,1.7,13.5c0.2,1.1,0.4,3.4,0.6,6.8
        c0.2,2.9,0.5,5.2,0.9,6.8c0.4,1.6,1.2,3.8,2.3,6.4c1.4,3.2,2.3,5.3,2.7,6.3c0.9,2.7,2.2,5.9,3.8,9.7L596,574.8
        c-0.1-0.2-0.1-0.4-0.2-0.5c-1.2-2.9-2.1-5.1-2.7-6.6c-1-2.4-2.7-6.9-5-13.5c-0.8-2.4-2.2-7-4-13.8c-0.3-1.2-1.1-3.5-2.3-6.9
        c-1-2.9-1.7-5.2-2-6.8c-0.7-3.5-1.6-8.2-2.5-14.2c-0.3-1.8-0.5-4.2-0.6-7.2c-0.1-3.6-0.3-6-0.4-7.1c-0.6-6.5-1-11.3-1.1-14.3
        c-0.1-1.3-0.2-3.7-0.5-7.2c-0.3-3-0.4-5.4-0.4-7.1c0-1.2,0.1-2.6,0.3-4.4c3.8-0.2,13.9,0,30.4,0.6c14.7,0.6,30.7,1.4,48,2.4
        C652.9,470.8,652.8,473.1,652.8,475 M669.1,544.6c1.6,3.3,3.2,6.1,4.7,8.6c0.8,1.3,2,3.3,3.5,5.9c1.4,2.2,2.7,4.1,3.9,5.7
        c0.5,0.7,1.9,2.6,4,5.6c1.6,2.3,3,4.1,4.2,5.4c1.2,1.2,3,2.7,5.3,4.3c2.9,2.1,4.8,3.4,5.6,4.1c1.2,1,2.9,2.4,5.2,4.4
        c2,1.7,3.9,3.1,5.5,4.2c1.1,0.7,2.6,1.8,4.6,3.2l-49.1,60.2c-0.2-0.2-0.5-0.3-0.7-0.5c-1.1-0.8-3.3-2-6.4-3.7
        c-2.8-1.4-4.8-2.7-6.2-3.8c-1.5-1.1-3.2-2.8-5.2-5c-2.5-2.7-4.2-4.5-5-5.3c-1.5-1.3-3.2-3.1-5.2-5.2c-2.2-2.4-3.8-4.1-5-5.3
        c-0.8-0.8-2.5-2.5-5.1-5.1c-2.2-2.1-3.8-3.9-5-5.3c-1.3-1.6-2.7-3.5-4.3-5.8c-1.8-2.7-3.2-4.7-4.1-6c-0.7-1-2.2-2.9-4.5-5.8
        c-1.9-2.4-3.3-4.3-4.3-5.9c-1.2-2-3.4-6.2-6.5-12.4L669.1,544.6 M773.6,620.1c4.3,1.1,7.9,2,10.9,2.7L767,698
        c-2.3-0.5-5.1-1.2-8.5-2c-6.3-1.5-11-2.6-14.1-3.5c-1.9-0.5-4.2-1.3-6.9-2.3c-4-1.4-6.2-2.2-6.8-2.5c-1.3-0.4-3.7-1-7.1-1.8
        c-3-0.7-5.4-1.4-7-2c-4-1.6-8.5-3.5-13.4-5.8c-5-2.3-9.4-4.5-13.1-6.4c-3.2-1.7-7.4-4.1-12.6-7.3c-1.5-0.9-3.3-2.2-5.5-4l49.4-60.5
        c0.3,0.2,0.6,0.4,0.9,0.5c4,2.2,8.1,4.3,12.2,6.2c1.5,0.7,3.6,1.4,6.5,2c3.2,0.8,5.5,1.4,6.8,1.9c1.1,0.4,3.2,1.4,6.2,2.8
        c2.6,1.2,4.7,2.1,6.4,2.7C766,618,770.4,619.3,773.6,620.1 M791.6,622.9c2.7,0.3,5.2,0.6,7.6,0.7c0.3,0,2.2,0.1,5.9,0.4
        c2.4,0.2,4.4,0.2,6,0.2c4.7,0,9.4-0.1,14-0.4c5.7-0.4,10.3-0.8,13.9-1.3c0.9-0.1,3.2-0.3,7-0.6c2.9-0.2,5.2-0.5,6.9-1
        c1.2-0.3,2.5-0.6,3.9-1.1l25.1,73.9c-1.3,0.6-2.4,1-3.3,1.2c-1.8,0.5-4.3,1-7.3,1.5c-4,0.7-6.5,1.1-7.5,1.3c-1.9,0.4-4.3,0.8-7.4,1
        c-4.1,0.4-6.6,0.7-7.6,0.8c-1.4,0.2-3.8,0.6-7.4,1.4c-3.2,0.7-5.7,1.1-7.5,1.2c-1.2,0.1-3,0-5.5-0.4c-2.5-0.4-4.4-0.5-5.5-0.5
        c-3.6,0.1-7.2,0.1-10.9,0.1c-0.2,0-2.3,0-6.5,0.1c-2.5,0-4.5,0-6-0.1c-1.6-0.1-3.8,0.1-6.8,0.4c-2.7,0.3-4.7,0.4-5.8,0.3
        c-2.9-0.2-5.8-0.7-8.6-1.3c-2.3-0.6-3.5-0.9-3.8-1c-0.2,0-0.4-0.1-0.5-0.2L791.6,622.9 M516.2,56.5c1.6-0.4,3.9-0.5,7-0.5
        c3.3,0,5.7-0.1,7.1-0.4c1.3-0.2,3.6-0.8,6.8-1.8c1.9-0.6,3.5-1,4.9-1.3l7.8,78c-2-0.2-3.7-0.2-5-0.1c-1.7,0.2-3.9,0.7-6.5,1.5
        c-3.7,1.1-5.9,1.7-6.5,1.9c-5,1.1-9.3,2.3-12.9,3.4c-1.7,0.5-3.8,1.4-6.3,2.6c-3.1,1.4-5.1,2.3-6,2.6c-1.2,0.5-3.4,1.2-6.5,2.2
        c-0.4,0.1-0.8,0.2-1.2,0.4c-30.5-31.5-50.1-50.7-58.6-57.7c0.7-0.4,1.7-0.8,2.9-1.4c3.3-1.6,6-2.9,8.2-4.1
        c6.1-3.3,10.2-5.4,12.4-6.4c4.8-2.2,9-4,12.9-5.5c1-0.4,3.1-1.3,6.3-2.8c2.7-1.2,4.9-2.2,6.6-2.8c6.7-2.3,11.1-3.7,13.4-4.4
        C509,58.2,513.5,57,516.2,56.5 M491.9,147.9c-1.3,0.7-2.7,1.6-4.2,2.6c-3.2,2.1-5,3.2-5.2,3.3c0,0-0.1-0.1-0.4-0.2
        c-0.2-0.2-0.3-0.3-0.4-0.2c0,0,0,0.1,0,0.2s0,0.2-0.1,0.2c-4.3,4-7.4,7.8-9.1,11.4c-0.8,1.8-1.6,4-2.4,6.6c-0.5,1.6-1.1,4.1-1.8,7.4
        c-0.2,0.8-0.4,1.8-0.5,2.9l-76.8-6.9c0.9-6.2,1.7-10.7,2.3-13.4c0.7-3.1,1.2-5.4,1.6-6.9c0.6-2.6,1.2-4.9,1.9-6.7
        c1-3,1.7-5.3,2.1-6.8c0.8-2.6,1.6-4.8,2.4-6.5c0.8-1.7,1.9-3.8,3.5-6.2c2.2-3.4,3.4-5.4,3.7-5.9c0.8-1.4,2-3.4,3.5-6.1
        c1.4-2.4,2.7-4.3,3.9-5.9c0.2-0.2,1.5-2.2,4.1-5.8c1.6-2.3,3.1-4.2,4.4-5.5c2.1-2.1,5.3-4.9,9.5-8.2c2.9,1.9,10.9,9.4,24.1,22.4
        C468.6,124.2,480,135.6,491.9,147.9 M388.2,197.4c0.7-3.5,1.1-5.9,1.2-7.3c0.2-2.9,0.4-5.6,0.7-8.1l77,6.9c-0.1,1.3-0.2,2.7-0.3,4.4
        c-0.1,1-0.4,3.3-1,7c-0.5,3-0.8,5.5-0.8,7.5c0,6.8,0.1,11.6,0.3,14.5c0.1,1.6,0.6,4,1.3,7c0.8,3.3,1.3,5.7,1.5,7.3
        c0.2,1.3,0.4,3.7,0.6,7.1c0.1,2.1,0.3,3.8,0.4,5.3l-75.4,18.8c-0.2-1.7-0.4-3.1-0.5-4c-0.3-1.6-0.9-4-1.8-7.3
        c-0.8-3.1-1.4-5.5-1.6-7.2c-0.2-1.8-0.3-4.3-0.3-7.5c0-3.6,0-6-0.1-7.4c-0.8-6.6-1.3-11.6-1.5-14.8c0-1-0.2-3.5-0.5-7.5
        c-0.2-3-0.3-5.5-0.3-7.4C387.3,203.1,387.6,200.6,388.2,197.4 M470.2,256c0.1,0.7,0.3,1.6,0.4,2.5c0.5,3,0.9,5.4,1.3,7.3
        c1.3,6.4,2.4,11.2,3.2,14.5c0.4,1.8,1.2,4.2,2.2,7.2c1.2,3.3,1.9,5.6,2.3,6.9c0.5,1.9,1.4,4.4,2.5,7.3c1.3,3.4,2.1,5.7,2.4,6.8
        c1,3.3,2.5,8,4.6,14.1c0.5,1.4,0.9,2.8,1.3,4.1l-75.2,25c0-0.1,0-0.1,0-0.2c-0.4-1.3-0.9-3.6-1.5-6.9c-0.6-3.4-1.3-6-1.9-7.9
        c-0.4-1.3-1.3-3.6-2.7-6.8c-1.3-3-2.3-5.5-2.8-7.3c-0.5-1.7-1.1-4.1-1.8-7.1c-0.8-3.5-1.4-6.1-1.8-7.6c-0.5-1.8-1-4.2-1.7-7.2
        c-0.8-3.8-1.3-6.3-1.6-7.5c-0.3-1.5-1-3.9-2.1-7.1c-1-3.1-1.7-5.6-2.1-7.4c-0.2-1-0.4-2.4-0.6-4L470.2,256 M421.9,365.2
        c-0.8-1.5-1.7-3-2.5-4.5c-0.4-0.8-0.9-1.6-1.3-2.5l74-24.7c0.3,1.5,0.4,2.7,0.5,3.6c0.1,0.1,0.2,0.2,0.4,0.3
        c0.2,0.1,0.4,0.2,0.4,0.3c0.6,1.5,2.2,6,4.9,13.6c0.5,1.5,1.5,3.7,2.8,6.8c1.2,2.9,2.1,5.1,2.7,6.6c0.6,1.6,1.2,3.9,2,7
        c0.8,3.2,1.4,5.5,1.9,6.9c0.5,1.3,1.3,3.6,2.4,6.9c1,2.9,1.8,5.1,2.4,6.8c0.5,1.5,1.4,3.8,2.8,6.8c1.1,2.6,1.9,4.6,2.4,6.1
        l-75.7,20.2c-0.7-2.8-1.3-5.1-1.9-6.7c-0.5-1.6-1.2-3.8-2.2-6.6c-1.2-3.3-2-5.5-2.4-6.8c-0.5-1.5-1.4-3.7-2.6-6.5
        c-1.3-2.9-2.2-5.1-2.8-6.6c-0.4-1.3-1.1-3.5-2.1-6.7c-0.8-2.9-1.5-5.2-2.1-6.8c-0.5-1.4-1.1-3.7-1.9-6.8
        C423.1,369,422.4,366.7,421.9,365.2 M243.8,94.1c2.9,0.8,5.2,1.6,7,2.4c1.6,0.7,3.7,2,6.3,3.7c3.4,2.2,5.6,3.6,6.6,4.2
        c1.4,0.8,3.5,2,6.5,3.6c2.6,1.5,4.7,2.8,6.4,4.1c1.7,1.3,3.6,2.8,5.8,4.8c0.6,0.5,2.5,2.2,5.6,5.2c1.2,1.1,3.1,2.8,5.6,4.9
        c2.3,2,4.1,3.8,5.4,5.4c1.3,1.5,2.6,3.6,4.1,6.3c2.3,4.3,3.5,6.6,3.6,6.7c0.4,0.7,1.8,2.7,4,6c1.7,2.4,2.8,4.4,3.5,6.1
        c0.7,1.7,1.3,4,1.7,6.9c0.6,4.1,1,6.5,1.1,7.1c1.4,6.1,2.2,10.8,2.4,13.9c0.1,1.6,0.2,3.9,0.4,7.1c0.1,2.7,0.1,5.1-0.1,7.2
        c-0.2,2.1-0.5,4.2-0.8,6.1c-43.7-6-69.7-9.5-77.9-10.6c0.6-2.4,0.7-4.5,0.5-6.2c-0.2-1.3-0.7-2.7-1.5-4.1
        c-2.1-3.7-5.5-7.2-10.2-10.3c-4.7-3.2-8.9-5.7-12.6-7.4c-0.5-0.2-1-0.4-1.4-0.6L243.8,94.1 M168.6,72.6c2.2,0.6,4.5,1,6.9,1.2
        c2.3,0.2,4.6,0.6,6.9,1.2c2.2,0.6,4.4,1.2,6.7,1.7c2.2,0.5,4.5,1.1,6.7,1.7c2.3,0.6,4.5,1.3,6.6,2.1c2.2,0.7,4.4,1.4,6.6,2
        c2.3,0.6,4.6,1.2,6.8,1.7c2.3,0.5,4.6,1.1,6.7,1.7c0.7,0.2,2.5,1,5.4,2.4c3.2,1.6,6.1,2.9,8.5,3.8c0.2,0.1,0.4,0.1,0.6,0.2
        l-27.8,71.4c-2.3-0.9-4.2-1.6-5.8-1.9c-0.2,0-0.4,0.1-0.7,0.4c-0.3,0.3-0.5,0.5-0.7,0.4c-2.2-0.6-4.4-1.4-6.6-2.3
        c-2.1-0.9-4.3-1.7-6.6-2.3c-2.2-0.6-4.5-1-6.9-1.2c-2.4-0.2-4.7-0.7-6.9-1.3c-2.2-0.6-4.5-1.3-6.7-2c-2.2-0.7-4.4-1.4-6.6-2
        c-4.4-1.3-8.9-2.6-13.4-3.8c-2.2-0.6-4.4-1.3-6.6-2.1c-2.2-0.8-4.4-1.5-6.6-2.1c-2.2-0.6-4.5-1.2-6.7-1.8c-2.3-0.5-4.5-1.1-6.7-1.8
        c-2.2-0.6-4.5-1.1-6.8-1.4c-2.3-0.3-4.6-0.8-6.8-1.4c-2.2-0.6-4.4-1.4-6.6-2.2c-2.2-0.9-4.4-1.6-6.6-2.2c-1.3-0.4-4.1-0.4-8.2,0
        c-2.5,0.2-4.4-0.9-5.6-3.2c-1.3-2.7-1.3-5.2,0.1-7.4c2.4-3.9,3.8-6.5,4.2-7.8c0.7-2.5,1.3-5.1,1.8-7.6c0.5-2.6,1-5.1,1.7-7.6
        c0.7-2.5,1.5-5,2.2-7.5c0.8-2.5,1.5-5,2.2-7.5c0.7-2.5,1.5-4.9,2.4-7.4c0.8-2.4,1.6-4.9,2.3-7.4c0.4-1.5,0.7-3.1,0.7-4.8
        c-0.1-1.7-0.1-2.8-0.1-3.5c0.1-2.3,1.5-4.2,4.1-5.9c2.3-1.5,4.3-1.6,6-0.4c3.3,2.2,5.5,3.4,6.7,3.8c4.4,1.2,8.9,2.4,13.4,3.5
        c2.2,0.6,4.5,1.1,6.8,1.3c2.3,0.3,4.6,0.7,6.9,1.3c2.2,0.6,4.4,1.5,6.4,2.6c2.1,1.1,4.2,2,6.4,2.7c2.2,0.6,4.5,1.2,6.8,1.7
        C164.2,71.5,166.4,72,168.6,72.6 M146.6,244.5c1.8-0.4,4.1-0.8,6.8-1.1c3.8-0.5,5.9-0.7,6.4-0.8c1.5-0.2,3.8-0.8,6.8-1.7
        c2.7-0.8,4.8-1.2,6.2-1.4c4.5-0.4,8.9-0.6,13.3-0.6c0.1,0.7,0.2,1.1,0.2,1.1c2-0.1,4.2-0.4,6.8-0.9c1.4-0.3,3.5-0.7,6.3-1.3
        c1.6-0.3,3.9-0.6,6.9-1.1c0.9-0.2,1.7-0.3,2.4-0.5L239,308c-0.5,0.2-0.9,0.4-1.3,0.6c-2.6,1.1-4.8,1.9-6.7,2.4
        c-1.6,0.5-3.9,0.9-6.8,1.2c-3.5,0.3-5.8,0.6-7.1,0.9c-6.2,1.3-10.7,2.2-13.7,2.6c-1,0.1-3.3,0.5-6.8,1.1c-2.9,0.5-5.2,0.8-7,0.9
        c-0.3,0-0.6,0.1-1,0.2c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.5-0.2-0.8-0.8c-0.2-0.5-0.5-0.8-0.7-0.8c-2.9,0-7.8,0.6-14.7,1.7
        c-2.9,0.5-7.6,1.9-14.1,4.2c-0.3,0.1-0.7,0.2-1,0.4l-37.9-69c0.5-0.3,1-0.5,1.5-0.8c5.1-2.3,9.6-4.2,13.7-5.5
        C136.6,246.6,140.9,245.6,146.6,244.5 M107.8,261.5c0.6-0.4,2.3-1.6,4.9-3.6l37.2,67.5c-1.7,0.8-3,1.5-3.9,2.2
        c-1.9,1.6-3.1,3.5-3.8,5.7c-0.3,1.1-0.5,3-0.7,5.8c-0.1,2-0.5,3.9-1.1,5.9c-0.6,1.9-0.9,3.9-1.1,5.9c-0.2,2-0.2,4-0.1,6
        c0.1,1.4,0.1,2.7,0,4l-77.8,3.3c0-0.1,0-0.1,0-0.2c0-0.3-0.2-0.6-0.6-0.9c-0.3-0.3-0.5-0.6-0.5-1c0.2-2.4,0.6-4.8,1.2-7.1
        c0.7-2.4,1.1-4.7,1.3-7.1c0.2-2.4,0.1-4.8-0.2-7.2c-0.3-2.4-0.4-4.9-0.2-7.2c0.1-1.9,0.6-4.4,1.6-7.3c1.2-3.7,1.9-6.1,2.1-7
        c0.2-1,0.6-3.4,1.1-7.4c0.4-3,0.9-5.4,1.6-7.2c0.8-1.9,1.9-4.1,3.4-6.6c1.7-2.8,3-4.9,3.8-6.4c2.6-4.2,3.8-6.3,3.8-6.4
        c1.5-2.4,3-4.4,4.4-6c3.2-3.7,6.7-7.2,10.5-10.5c1.4-1.2,3.5-2.5,6.3-3.9C104.6,263.2,106.8,262.1,107.8,261.5 M66.7,393.1
        c-0.7-2.1-1.3-4.6-1.8-7.6c-0.4-3.2-0.8-5.4-1.1-6.8c-0.6-2.8-1-5.3-1.4-7.4l79.6-3.3c0.6,1.4,1.4,2.6,2.2,3.7
        c3.7,4.6,7.7,7.3,11.9,8.3c1.9,0.4,4.2,0.6,7.1,0.5c0.3,7.3-1,21.9-4,43.7c-1.5,11.6-3.2,22.7-5,33.4c-5.1-0.6-9.2-1.2-12.2-1.8
        c-2.1-0.4-4.5-1.1-7.1-1.9c-3-1-5.2-1.8-6.7-2.2c-6.3-2.1-10.8-3.9-13.5-5.2c-3.1-1.5-7.2-4.1-12.3-7.6c-2.9-1.9-5-3.4-6.3-4.2
        c-2.3-1.6-4.2-3-5.4-4.2c-2.7-2.6-6-6.4-9.7-11.2c-1.4-1.8-2.8-3.9-4.2-6.4c-0.5-0.9-1.7-3-3.5-6.3
        C69.8,400.3,67.7,395.9,66.7,393.1 M317.5,212.4c-0.1,0.3-0.2,0.7-0.2,1c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.2,0.1,0.1,0.2
        c-0.2,1.2-0.7,3.1-1.6,5.6c-1.2,3.2-2,5.5-2.4,7.1c-0.3,1.3-0.8,3.4-1.5,6.2c-0.7,2.5-1.4,4.7-2.1,6.6c-0.6,1.5-1.5,3.5-2.8,5.8
        c-1.5,2.6-2.6,4.6-3.4,5.9c-0.3,0.6-1.2,2.6-2.7,5.9c-1.1,2.5-2.2,4.5-3.2,6c-1.9,2.9-3.2,4.7-3.9,5.6c-1.6,2.2-3.1,4-4.5,5.6
        c-3.6,4.1-6.9,7.4-9.8,10c-1.3,1.1-3.1,2.4-5.6,3.9c-3.2,1.9-5.2,3.1-6.1,3.8s-2.6,2.1-5.2,4.4c-2.2,1.9-4.1,3.4-5.8,4.2
        c-1.6,0.9-3.7,1.8-6.3,2.9c-2.1,0.8-3.9,1.5-5.2,2l-30.1-71.6c1.1-0.6,2.1-1.2,3.2-2c2.4-1.8,4.1-3.1,5.2-3.9c3-2.2,4.8-3.6,5.4-4.1
        c1.9-1.6,3.4-3.2,4.6-4.8c1.9-2.8,3.4-6,4.6-9.6c0.8-2.4,1.2-4.1,1.2-5.2c0-0.8,0.1-1.4,0.2-1.9c0-0.1,0-0.3,0.1-0.4
        C284.1,207.8,309.9,211.4,317.5,212.4 M173.2,381.4c2.4,0,4.8-0.4,7.1-1c2.4-0.6,4.8-1,7.2-1c2.4,0,4.8,0,7.1,0.1
        c2.4,0.1,4.8,0.1,7.2,0c2.4,0,4.8,0.2,7.1,0.7c2.4,0.5,4.8,0.8,7.1,0.8c2.4,0,4.8-0.2,7.2-0.5c2.4-0.3,4.8-0.5,7.1-0.5
        c2.4,0,4.8,0.1,7.2,0.4c2.4,0.2,4.8,0.3,7.2,0.3c1,0,1.9,0,2.8-0.1l1.7,76.2c-0.6,0-1.3,0-1.9,0c-4.8,0.1-9.7,0.2-14.5,0.3
        c-2.4,0-4.8,0.2-7.2,0.5c-2.4,0.3-4.9,0.5-7.2,0.6c-2.5,0-4.9-0.1-7.2-0.2c-2.5-0.2-4.9-0.2-7.2-0.2c-2.4,0-4.8,0.2-7.2,0.4
        s-4.8,0.4-7.2,0.5c-2.4,0-4.8,0-7.2-0.1c-2.4-0.1-4.8-0.1-7.2-0.1c-0.5,0-1.2-0.1-2.1-0.5c-0.9-0.3-1.6-0.5-2.1-0.5
        c-1,0-3.5,0.1-7.4,0.3c-0.7,0-1.4,0-2.1,0c1.9-11.2,3.5-22.5,5.1-33.9c2.9-21.5,4.1-36.1,3.8-43.9c0.2,0,0.5,0,0.7,0
        c0.3,0,0.7,0.2,1.3,0.6C172.6,381.2,173,381.4,173.2,381.4 M254.6,379.5c1.5-0.2,3-0.3,4.5-0.3c0.1,0,0.1-0.1,0.2-0.1
        c1.1-0.1,2.7,0,4.7,0.3c2.3,0.3,3.9,0.5,4.9,0.5c0.6,0,3-0.2,7.1-0.6c3.3-0.3,6-0.3,8.3,0c3.4,0.4,8.5,1.6,15.1,3.4
        c1.9,0.5,4.2,1.5,7,2.8c1.5,0.8,3.9,1.9,7,3.5c1.5,0.7,3.8,1.7,7,3c2.8,1.2,5,2.5,6.8,3.8c3,2.1,6.7,5.6,11.2,10.5
        c2.4,2.5,5,6.1,7.9,10.6c0.8,1.2,2,3,3.5,5.4c1.4,2.2,2.5,4.2,3.2,6c1.1,2.9,1.9,4.9,2.4,6.1c0.9,2.4,1.5,4.6,1.9,6.6
        c0.6,2.9,1.1,5.4,1.4,7.6l-77.3,10.1c0-0.1-0.1-0.2-0.1-0.3c-0.4-0.5-0.9-0.7-1.5-0.7c-1.1,0-1.7,0-1.9,0c-3-0.6-7.1-0.7-12.2-0.3
        c-0.4,0-0.8,0.1-1.1,0.4c-0.4,0.2-0.8,0.3-1.2,0.4l-1.5,0.1c-1.8,0-3.7-0.2-5.6-0.5L254.6,379.5 M280.8,466.2c0-0.1,0-0.3,0-0.4
        l78.7-10.3c0,1.5-0.1,3.2-0.4,5.2c-0.5,4.1-0.7,6.3-0.8,6.8c-0.4,6.1-0.9,10.6-1.4,13.3c-0.4,2.3-0.9,4.7-1.2,7.2
        c-0.4,2.3-0.8,4.7-1.3,7.2c-0.5,2.4-1,4.8-1.6,7.2c-0.6,2.4-1.1,4.8-1.6,7.1c-0.5,2.4-1.1,4.8-1.8,7.1c-0.7,2.3-1.4,4.7-1.9,7.1
        c-0.5,2.4-0.7,4.8-0.8,7.3c-0.1,1.4-0.2,2.8-0.4,4.2l-77-12c0.9-4.5,1.8-9,2.8-13.6c1-4.8,2-9.7,3-14.5c1.1-4.8,2.1-9.7,3-14.6
        C278.9,475.9,279.8,471.1,280.8,466.2 M265.4,538.8c0.5-2.4,1.1-4.8,1.9-7.2c0.1-0.4,0.3-0.9,0.4-1.3l77.4,12
        c-0.7,3.5-1.4,7.1-2.1,10.6c-0.5,2.4-0.9,4.8-1.3,7.2c-0.4,2.4-0.9,4.8-1.4,7.2l-2.8,14.5v0.2c-0.1,0.8-0.4,3-1,6.4
        c-0.5,3.7-0.7,7.3-0.5,10.8c0.1,2.2,0.5,4.9,1.1,8.1c0,0.1,0,0.2,0,0.3l-77.4,14.1c0-0.1,0-0.2-0.1-0.4c-0.6-2.9-1-5.3-1.1-7.2
        c-0.4-3.8-0.7-8.8-0.8-14.9c-0.1-3.6-0.1-8.6,0.2-14.9c0.1-3.4,0.6-6.7,1.3-9.9c0.7-2.7,1.1-4.3,1.2-4.7c0-0.3,0.1-0.6,0.2-0.8
        c0.1-0.3,0.2-0.6,0.3-0.8c1.7-8.9,2.6-13.8,2.8-14.6c0.5-2.4,0.7-4.9,0.8-7.4C264.6,543.7,264.9,541.2,265.4,538.8 M263,635.5
        c-0.9-2.7-1.5-4.9-1.9-6.8c0-0.1,0-0.1,0-0.2l77.4-14.1c0.1,0.5,0.2,1.1,0.4,1.6c0.9,4.5,2.7,9.6,5.3,15.4c1.8,4,2.9,6.5,3.5,7.7
        c1.4,2.7,2.8,4.9,4.3,6.6c1.6,1.8,3.7,3.5,6.3,5.1c0.5,0.3,1.3,0.8,2.5,1.4L326.2,723c-0.1-0.1-0.3-0.1-0.4-0.2
        c-2.4-1.2-4.4-2.4-6-3.4c-1.6-1-3.4-2.4-5.6-4.2l-5.2-4.5c-0.3-0.2-2.1-1.6-5.5-4.2c-2.2-1.7-3.9-3.1-5.2-4.4
        c-2.2-2.2-3.8-3.8-4.9-5c-1.9-1.9-3.5-3.7-4.6-5.2c-2.1-2.6-4.7-6.4-7.8-11.5c-3.2-5.2-5.5-9.2-6.9-12.1c-0.8-1.6-1.6-3.7-2.4-6.5
        c-1-3.5-1.7-5.7-2.1-6.7c-2-5.2-3.4-9.6-4.4-13.1C264.9,641.5,264.2,639.2,263,635.5 M519,412.2c0,0.3,0.1,0.6,0.1,0.9
        c0.4,3.3,0.8,5.7,1.2,7.1c0.4,1.2,1.1,3.5,2.2,6.9c0.9,2.9,1.6,5.2,2,6.9c0.9,3.1,2,7.8,3.5,14c0.4,1.6,1.2,3.9,2.3,7
        c1.1,3,1.9,5.2,2.2,6.8c0.4,1.6,0.8,4,1.2,7.2c0.4,3.3,0.8,5.6,1.1,7.1c0.3,1.5,1,3.8,2,7c0.6,2.1,1.1,3.8,1.4,5.2l-76.9,16.4
        c-0.4-1.3-0.8-2.4-0.9-3.3c-0.3-1.4-0.6-3.7-0.9-7c-0.2-3.1-0.6-5.5-1-7.1c-0.1-0.5-1.2-5.1-3.3-13.8c-1.3-6.1-2.4-10.7-3.2-13.8
        c-1.7-6.7-2.9-11.3-3.6-13.7c-0.4-1.6-1.2-3.8-2.3-6.6c-1.2-3.1-2-5.3-2.5-6.8c0-0.1-0.1-0.2-0.1-0.2L519,412.2 M539.4,495.2
        c0.1,0.6,0.2,1.3,0.2,2c0.3,3.3,0.6,5.6,0.9,7.1c0.3,1.6,1,4,2.1,7.1c1.1,3.1,1.8,5.4,2,6.9c0.3,1.7,0.5,4.2,0.5,7.4
        c0.1,3.3,0.3,5.6,0.5,7.1c0.5,3.3,1.1,8.1,2,14.4c0.2,1.5,0.7,4,1.3,7.2c0.6,3,1,5.3,1.2,6.9c0.2,1.8,0.5,4.3,0.7,7.4
        c0.2,3.4,0.4,5.7,0.6,7c0,0.5,0.1,1,0.2,1.6c-40.1,4.2-65.7,7-77,8.2c-0.1-1.4-0.1-3.4-0.2-5.8c-0.1-3.2-0.3-5.8-0.5-7.8
        c-0.2-1.8-0.6-4.2-1.2-7.4c-0.7-3.6-1.1-6.2-1.4-7.6c-0.7-6.1-1.3-10.8-1.8-14.1c-0.3-1.7-0.7-3.9-1.2-6.8c-0.7-3.5-1.1-5.8-1.4-7.1
        c-0.3-1.4-0.6-3.7-1-6.9c-0.4-3.1-0.7-5.5-1-7.1c-0.2-0.9-0.5-2.1-1.1-3.6L539.4,495.2 M553.1,584.2c0.6,2.6,1,4.5,1.1,5.8
        c0.2,1.9,0.2,4.4,0.1,7.5c-0.1,3.3,0,5.7,0,7c0.2,4.4,0.5,9.2,0.7,14.4c0.2,5.2,0.2,10,0.1,14.4l-0.7,0.2c0.1,7,0,11.6-0.1,13.6
        c0,0.1-0.1,2.5-0.2,7c-0.1,2.7-0.3,5-0.6,6.7c-0.3,1.6-0.7,3.9-1.2,6.9c-0.5,2.6-1,4.8-1.5,6.5c-1.4,5-2.6,8.9-3.7,11.8
        c-6.6-3.6-17.6-9.3-33-17c-18.5-9.4-31.2-15.4-38.2-18.1c1.1-5.2,1.6-10.7,1.5-16.4c0-0.2-0.1-0.4-0.5-0.6c-0.3-0.2-0.5-0.3-0.5-0.5
        c0-0.1,0.2-0.3,0.6-0.4c0.3-0.1,0.5-0.3,0.5-0.5c-0.2-1.1-0.4-2.5-0.6-4.2c-0.4-3.4-0.7-7-0.9-10.8c-0.1-2.6-0.5-7.6-1-15.2
        c-0.1-1.2-0.1-3.6-0.1-7.2c0-0.9,0-1.7,0-2.5C486.1,591.3,512.1,588.5,553.1,584.2 M410.5,668.7c1.9,0.4,4.4,0.6,7.3,0.8
        c4,0.3,6.3,0.5,7,0.5c0.3,0,1.4,0.1,3.2,0.4c-0.3,8.7-2,34.8-5,78.2c-1.3,0-3.3-0.1-6-0.2c-3.1-0.1-5.6-0.3-7.5-0.5
        c-1.7-0.2-4.1-0.8-7.1-1.6c-3.4-0.9-5.9-1.5-7.4-1.8c-2.1-0.4-4.7-1-7.8-1.8c-4.9-1.3-7.4-1.9-7.5-2c-1.6-0.4-4.2-0.8-8-1.4
        c-3.3-0.5-5.8-1-7.5-1.5c-8.5-2.4-13.6-3.9-15.1-4.4c-3.7-1.2-7.1-2.5-10.5-3.8c-2.6-1.1-4-1.7-4.2-1.8c-0.2-0.1-0.4-0.3-0.6-0.6
        c-0.2-0.3-0.4-0.5-0.6-0.6c-0.2-0.1-0.5-0.2-0.6-0.4c-0.1-0.1-0.1-0.1-0.2-0.2l34.2-70c1,0.4,2.4,1,4.4,1.8c3.1,1.2,6.2,2.3,9.1,3.2
        c4.6,1.4,9.6,2.8,15,4.1C401.1,666.8,406.2,667.9,410.5,668.7 M435,671.2c1.6,0.2,3,0.2,4.1,0.2c2.5,0,5.2-0.3,8.1-0.9
        c1.6-0.3,3.8-0.8,6.6-1.4c5.9-1.1,10.4-2.7,13.6-5c2.6-1.8,4.6-4.1,6.1-6.8c6.6,2.6,19.4,8.7,38.4,18.2c11,5.6,21.7,11.1,32,16.5
        c-0.3,0.4-0.5,0.8-0.8,1.2c-2.4,3.7-3.7,5.6-3.7,5.6c-0.8,1.4-2,3.4-3.5,6c-1.3,2.2-2.6,4.1-3.8,5.5c-1.2,1.5-2.8,3.2-4.9,5
        c-1.2,1-2.9,2.5-5.1,4.4c-3.1,2.9-4.8,4.5-5.1,4.8c-1.9,1.7-3.6,3.1-5.1,4.1c-5.4,3.8-9.8,6.4-13.1,8c-4.2,2.1-9,4-14.2,5.7
        c-3.2,1.1-5.6,1.9-7.2,2.5c-2.9,1-5.4,1.6-7.5,2c-7,1.4-12.1,2.2-15.2,2.5c-1.9,0.2-4.4,0.1-7.7-0.2c-3.8-0.4-6.4-0.6-7.8-0.6
        c-0.7,0-3.1,0.1-7.4,0.2c-0.6,0-1.2,0-1.8,0C433,706.7,434.7,680.8,435,671.2z"
        />
      </svg>
      <svg
        version="1.1"
        id="Layer_3"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1024 768"
        enable-background="new 0 0 1024 768"
        xml:space="preserve"
        style="position: absolute; top: 0; left: 0;"
      >
        <g alt="Finish" id="end">
          <path
            id="FinishFill"
            :fill="curriculumComplete ? '#3F8334' : '#FFFFFF'"
            d="M984.9,199.2c-3.8-13.9-11.9-24.4-24.4-31.5c-12.5-7.1-25.6-8.8-39.5-5.1l-39.3,10.7
          c-2.6,0.9-5,2.6-7.2,5.1c-4.4,5.2-5.6,12-3.7,20.4c7.2,27.7,12.7,47.7,16.5,60.1c2.1,6.9,6.2,11.5,12.4,13.8
          c3.1,1.1,5.9,1.5,8.5,1.2l40.1-10.9c13.9-3.8,24.4-11.9,31.5-24.3C987,226.2,988.7,213,984.9,199.2z"
          />
          <path
            id="FinishOutlined"
            fill="#231F20"
            d="M990.3,203.1c-0.1-0.6-0.4-1.4-0.9-2.4c-0.6-1.1-0.9-2-1.1-2.5
          c-0.1-0.5-0.2-1.4-0.2-2.6c-0.1-1.1-0.2-2-0.4-2.6c-0.2-0.6-0.6-1.4-1.2-2.3c-0.7-1.2-1.1-2-1.3-2.3c-1.3-2.7-2.1-4.2-2.3-4.7
          c-1.3-2.2-2.3-3.7-2.8-4.4c-1.1-1.5-2.2-2.9-3.2-4.1c-0.4-0.5-1.1-1-2.1-1.6c-1.1-0.7-1.8-1.2-2.1-1.5c-0.3-0.3-0.9-0.9-1.8-1.9
          c-0.7-0.8-1.4-1.4-1.9-1.8c-2.3-1.7-3.7-2.7-4.2-3.1c-1-0.6-2.5-1.4-4.6-2.4c-0.3-0.2-1.1-0.6-2.2-1.4c-0.9-0.6-1.7-1-2.3-1.2
          s-1.4-0.5-2.5-0.8c-1.3-0.3-2.2-0.5-2.5-0.6c-2.2-0.7-3.9-1.1-5-1.3c-2.3-0.6-4-1-5.1-1.1c-0.7-0.1-1.5-0.1-2.6,0.1
          c-1.4,0.1-2.2,0.1-2.7,0.1c-2-0.1-3.7,0-5.1,0.1c-0.7,0-1.5,0.1-2.5,0.3c-1.1,0.2-2,0.4-2.6,0.5c-0.4,0.1-1.3,0.2-2.6,0.3
          c-1.1,0.1-1.9,0.2-2.5,0.4c-0.8,0.2-1.7,0.5-2.5,0.9c-0.8,0.3-1.6,0.6-2.4,0.9c-1.7,0.4-3.3,0.8-5,1.2l-4.9,1.3
          c-0.9,0.2-1.7,0.5-2.4,0.9c-0.8,0.4-1.6,0.7-2.5,0.9c-0.8,0.2-1.6,0.4-2.5,0.4c-0.8,0.1-1.7,0.3-2.5,0.5c-1.6,0.4-3.3,0.8-5,1.2
          c-0.8,0.2-1.6,0.4-2.5,0.4c-0.9,0-1.7,0.1-2.5,0.3c-0.8,0.2-1.6,0.6-2.3,1.2c-0.8,0.5-1.5,0.9-2.4,1.1c0-0.3-0.1-0.5-0.2-0.4
          c-1.8,0.6-3.3,1.3-4.8,2.2c-0.5,0.4-1.1,0.9-1.8,1.8c-0.4,0.4-1,1.1-1.8,2.1c-0.1,0.1-0.7,0.7-1.8,1.8c-0.8,0.8-1.3,1.5-1.7,2.1
          c-0.9,1.7-1.6,3.3-2,4.8c-0.3,0.9-0.5,2.7-0.7,5.3c-0.1,1.1,0,2.8,0.3,5.2c0.1,0.9,0.5,2.6,1,5c0,0-0.2,0.1-0.8,0.2
          c0.1,0.3,0.7,2.6,1.8,6.9c0.1,0.5,0.4,1.4,0.8,2.6c0.4,1.2,0.7,2.1,0.8,2.8c0.1,0.5,0.5,1.4,1,2.6c0.6,1.1,0.9,2,1.1,2.7
          c0.2,0.6,0.4,1.5,0.6,2.7c0.2,1.3,0.4,2.2,0.6,2.9c0.1,0.4,0.4,1.2,0.8,2.2c0.4,1,0.6,1.8,0.8,2.3c0.2,0.5,0.3,1.3,0.3,2.4
          s0.1,1.9,0.2,2.4c0.3,1,0.8,2.6,1.6,4.6c0.3,1,0.7,2.6,1,4.7c0.2,0.5,0.5,1.3,1,2.2c0.5,1,0.8,1.8,0.9,2.2l1.2,4.6
          c0.2,0.5,0.3,1.4,0.3,2.5c0.1,1.1,0.2,1.9,0.3,2.4c0.3,1.1,0.7,2.6,1.2,4.6c0.2,0.6,0.6,1.3,1.2,2.2c0.7,1.1,1.1,1.8,1.3,2.1
          c0.8,1.6,1.6,2.9,2.5,4c0.3,0.5,0.8,1.1,1.4,2.1c0.5,0.8,1,1.4,1.5,1.8c0.5,0.4,1.2,0.8,2.2,1.1c1.2,0.4,2,0.7,2.2,0.9
          c0.3,0.2,1,0.6,2.1,1.4c0.8,0.6,1.4,1,2,1.1c1.8,0.6,3.3,1,4.6,1.2c1.2,0.1,2.8,0.1,4.9-0.1c0.1,0,0.1-0.1,0.1-0.3
          c0-0.2,0.1-0.2,0.1-0.2c0.9-0.2,1.7-0.4,2.6-0.4c0.9-0.1,1.8-0.2,2.6-0.4c0.8-0.2,1.7-0.4,2.6-0.5c0.9-0.1,1.7-0.3,2.5-0.5
          c1.7-0.5,3.4-1,5-1.5c1.7-0.5,3.3-1,5-1.5c0.8-0.2,1.7-0.6,2.5-1c0.8-0.4,1.6-0.8,2.5-1c0.8-0.2,1.7-0.4,2.5-0.5
          c0.9-0.1,1.7-0.3,2.5-0.6c1.7-0.5,3.4-1,5-1.5l5-1.4c0.4-0.1,1.2-0.3,2.5-0.6c1.1-0.2,1.9-0.4,2.6-0.6c0.6-0.2,1.4-0.6,2.3-1
          l2.3-1.2c0.4-0.2,1.3-0.5,2.5-0.9c1.1-0.3,1.9-0.7,2.4-1s1.2-0.9,2-1.6c0.9-0.9,1.5-1.5,2-1.8c0.4-0.3,1.1-0.7,2.2-1.4
          c1-0.6,1.7-1.1,2.1-1.5c0.9-0.8,2-2.1,3.5-3.9c0.2-0.2,0.8-0.8,1.9-1.9c0.8-0.7,1.4-1.4,1.8-1.9c0.4-0.5,0.8-1.2,1.3-2.2
          c0.6-1.1,1-1.9,1.2-2.3c0.6-1,1.5-2.5,2.7-4.4c0.3-0.6,0.6-1.4,0.9-2.4c0.4-1.2,0.6-2.1,0.8-2.5c1-2.6,1.7-4.2,1.8-4.8
          c0.8-2.2,1.4-3.8,1.6-4.9c0.3-1.7,0.6-3.4,0.8-5.1c0.4-2.3,0.6-4,0.6-5.2c0-0.6,0-1.5-0.2-2.6c-0.2-1.3-0.4-2.2-0.4-2.6
          C990.6,206,990.5,204.3,990.3,203.1 M968.2,179.1c0.3,0.3,1,0.8,2,1.5c0.9,0.6,1.6,1.2,2,1.6c0.7,0.8,1.5,2.3,2.5,4.4
          c0.6,0.9,1.5,2.3,2.5,4.4c1.1,2.1,1.8,3.6,2.2,4.5c0.2,0.6,0.4,1.4,0.6,2.4c0.2,1.2,0.4,2.1,0.5,2.5c0.1,0.3,0.3,1.1,0.8,2.4
          c0.3,1,0.5,1.8,0.7,2.4c0.2,1.5,0.4,3.1,0.5,4.9c0.1,1.1,0,2.8-0.3,5c0,0.5,0,1.3,0,2.6c0.1,1.1,0,1.9,0,2.5
          c-0.2,1.1-0.6,2.7-1.2,4.8c-0.6,2.4-1,4.1-1.3,4.8c-0.4,1.1-1.2,2.6-2.4,4.5c-0.8,2.1-1.5,3.6-2.2,4.5c-0.5,0.7-1.5,2-3,4
          c-1,1.3-2.1,2.6-3.3,3.8c-1.4,1.8-2.6,3-3.5,3.8c-0.5,0.4-1.2,0.9-2.1,1.4c-1.1,0.6-1.8,1.1-2.2,1.3c-0.6,0.4-2.1,1.2-4.4,2.4
          c-0.5,0.3-1.3,0.5-2.3,0.8c-1.2,0.3-2,0.5-2.5,0.7c-0.4,0.2-1.1,0.6-2.1,1.3c-0.9,0.6-1.7,1-2.3,1.2c-0.7,0.2-1.5,0.5-2.4,0.8
          c-0.8,0.3-1.6,0.5-2.5,0.7c-0.4,0.1-1.2,0.2-2.6,0.4c-0.7,0.1-1.5,0.3-2.5,0.6c-0.8,0.2-1.6,0.5-2.4,0.8c-0.8,0.3-1.6,0.6-2.5,0.8
          c-0.8,0.2-1.7,0.3-2.5,0.3c-0.9,0-1.8,0.1-2.6,0.3c-0.8,0.2-1.6,0.5-2.5,0.8c-0.8,0.3-1.6,0.6-2.4,0.9c-0.8,0.2-1.6,0.4-2.5,0.6
          c-0.8,0.1-1.6,0.3-2.5,0.5c-0.8,0.2-1.6,0.5-2.4,1c-0.8,0.4-1.6,0.7-2.5,0.9c-0.7,0.2-2.4,0.6-5,1.2c-0.4,0-1-0.1-2-0.4
          c-1.4-0.4-2.5-0.7-3.3-1c-1.6-0.5-3.2-1.3-4.7-2.5c-1-0.6-1.7-1.1-2.1-1.4c-0.9-0.6-1.5-1.3-2-2.1c-0.9-1.3-1.6-3-2.2-5
          c-0.2-0.5-0.3-1.3-0.5-2.4c-0.2-1.2-0.3-2-0.5-2.6c-0.1-0.5-0.5-1.2-1.2-2.2s-1-1.8-1.2-2.4c-0.2-0.5-0.3-1.4-0.3-2.5
          c-0.1-1.2-0.2-2.1-0.4-2.6l-1.2-4.9c-0.8-2.2-1.3-3.8-1.6-4.9c-0.1-0.5-0.5-1.3-1-2.4c-0.5-1-0.8-1.8-1-2.4
          c-0.1-0.5-0.2-1.4-0.3-2.6c-0.1-1.1-0.2-2-0.4-2.5c-0.1-0.6-0.3-1.4-0.4-2.6c-0.2-1.1-0.3-2-0.5-2.5c-0.7-2.2-1.2-3.9-1.5-4.9
          l-1.4-5c-0.2-0.6-0.5-1.5-1-2.5c-0.5-1-0.8-1.8-0.9-2.2c-0.3-1-0.5-2-0.6-3.1c-0.2-1.3-0.4-1.9-0.4-1.9c-0.1-0.2-0.2-0.4-0.3-0.6
          c-0.4-1.9-0.7-3.6-0.8-4.8c0-0.8,0-1.6,0.2-2.6c0.2-1,0.4-1.8,0.5-2.3c0.4-2.1,0.8-3.7,1.3-4.7c0.3-0.7,0.9-1.3,1.7-1.9
          c0.9-0.6,1.5-1.1,1.8-1.4c2.2-1.9,3.4-2.9,3.7-3.1c0.8-0.2,1.7-0.4,2.5-0.4c0.9-0.1,1.7-0.2,2.5-0.4c0.8-0.2,1.6-0.5,2.4-0.8
          c0.8-0.3,1.6-0.6,2.4-0.8s1.7-0.4,2.5-0.5c0.9-0.1,1.7-0.3,2.5-0.5c0.8-0.2,1.6-0.5,2.4-0.8c0.8-0.4,1.6-0.7,2.4-0.9
          c1.6-0.5,3.3-0.9,5-1.2c0.8-0.2,1.6-0.5,2.4-0.9c0.8-0.4,1.5-0.7,2.3-1c1.6-0.4,3.3-0.8,5-1.2c0.8-0.2,1.7-0.3,2.5-0.4
          c0.9-0.1,1.7-0.3,2.5-0.5c1.5-0.4,3.1-0.8,4.8-1.1c1.1-0.2,2.8-0.2,5-0.2c0.4,0,1.3-0.1,2.5-0.3c1-0.2,1.9-0.2,2.5-0.2
          c0.6,0,2.2,0.3,5,0.8c0.5,0.1,1.3,0.1,2.5,0.1c1.1,0,1.9,0,2.5,0.1c0.6,0.2,1.4,0.6,2.3,1.2c1,0.7,1.7,1.1,2.2,1.3
          c0.4,0.1,1.2,0.4,2.4,0.8c1,0.3,1.8,0.6,2.3,0.9c0.6,0.3,2,1.2,4.2,2.6c0.7,0.5,2,1.5,4,3.1C965.7,176.7,966.9,177.8,968.2,179.1z"
          />
          <text class="finish-text text" x="885" y="222">Finish</text>
        </g>
      </svg>
      <button
        @click="closeModal"
        @keydown.enter="closeModal"
        v-html="buttonClose"
        aria-label="Close modal"
        class="modal-close-button progress pure-button"
        style="padding: 0px"
        ref="test"
      ></button>
    </div>
  </focus-trap>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { uniqBy } from 'lodash';

// icons
import iconWildAboutAnimals from 'images/theme-icons/icon-animals.png';
import iconBonesBodies from 'images/theme-icons/icon-bonesbodies.png';
import iconLetsEat from 'images/theme-icons/icon-food.png';
import iconGoGeography from 'images/theme-icons/icon-geography.png';
import iconGreatGrammar from 'images/theme-icons/icon-grammar.png';
import iconGreekLatin from 'images/theme-icons/icon-greeklatin.png';
import iconOffToWork from 'images/theme-icons/icon-jobs.png';
import iconJump from 'images/theme-icons/icon-jump.png';
import iconMathMix from 'images/theme-icons/icon-mathmix.png';
import iconStartMusic from 'images/theme-icons/icon-music.png';
import iconOhLook from 'images/theme-icons/icon-ohlook.png';
import iconPeoplePower from 'images/theme-icons/icon-peoplepower.png';
import iconSingPlay from 'images/theme-icons/icon-singplay.png';
import iconLetsPlay from 'images/theme-icons/icon-sports.png';
import iconSuperWords from 'images/theme-icons/icon-superwords.png';
import iconOnGo from 'images/theme-icons/icon-travel.png';
import iconWaterWater from 'images/theme-icons/icon-waterwater.png';
import iconWordsWriters from 'images/theme-icons/icon-wordswriters.png';

import iconAwardMedal from 'images/awards-icons/medal.png';
import iconAwardCup from 'images/awards-icons/cup.png';
import iconAwardRibbon from 'images/awards-icons/ribbon.png';
import iconAwardStar from 'images/awards-icons/star.png';
import iconAwardShield from 'images/awards-icons/shield.png';
import iconAwardPlaque from 'images/awards-icons/plaque.png';

import iconStop from 'images/candyland/stop.png';
import iconSpotCheck from 'images/candyland/spotCheck.png';
import iconSpotCheckDone from 'images/candyland/spotCheckDone.png';

import { TweenMax } from 'gsap';
import { getAwardName, getThemeColor } from 'utils/themeUtils';

import btnClose from 'assets/svg/btn-close.svg';

import { FocusTrap } from 'focus-trap-vue';

export default {
  components: {
    FocusTrap
  },
  data() {
    return {
      // colors by grade
      bgColors: ['#FFAA5C', '#FFF19A', '#77D0CB', '#F79A86', '#95AEDF', '#C2B2D4'],
      pathbg: null,
      buttonClose: btnClose,
      pathBg: '',
      productId: '',
      lastCompleteASN: '',
      drawToWeek: '',
      asnProgress: '',
      finalASN: '',
      asnStarts: '',
      weekThemes: '',
      themeObjs: '',
      themeColorsPrimA: '',
      iconTest: iconWildAboutAnimals,
      stopX: 0,
      stopY: 0,
      stopIcon: iconStop,
      showStopIcon: false,
      spotCheckIcon: iconSpotCheck,
      spotCheckIconDone: iconSpotCheckDone,
      spotCheckList: [],
      spotCheckNums: '',
      spotCheckPoints: [
        [239, 91],
        [322, 210],
        [245, 307],
        [154, 323],
        [143, 362],
        [169, 375],
        [251, 375],
        [362, 451],
        [349, 539],
        [340, 612],
        [366, 650],
        [431, 670],
        [472, 651],
        [473, 589],
        [459, 508],
        [441, 429],
        [414, 355],
        [391, 271],
        [384, 178],
        [436, 83],
        [545, 47],
        [660, 93],
        [699, 197],
        [694, 298],
        [673, 390],
        [654, 462],
        [671, 539],
        [721, 593],
        [790, 618],
        [859, 613],
        [900, 573],
        [899, 515],
        [872, 448],
        [822, 381],
        [778, 259],
        [872, 183]
      ],
      stopPoints: [
        [201, 101],
        [251, 174],
        [197, 240],
        [110, 260],
        [77, 339],
        [138, 391],
        [226, 391],
        [292, 430],
        [280, 503],
        [274, 590],
        [320, 662],
        [404, 687],
        [486, 639],
        [488, 557],
        [478, 471],
        [455, 390],
        [429, 314],
        [409, 229],
        [405, 154],
        [442, 88],
        [524, 66],
        [606, 93],
        [628, 174],
        [618, 261],
        [606, 350],
        [590, 434],
        [602, 532],
        [667, 600],
        [756, 632],
        [848, 631],
        [914, 566],
        [916, 477],
        [887, 394],
        [832, 326],
        [798, 247],
        [854, 200]
      ]
    };
  },

  computed: {
    ...mapState('application', ['kwtMode']),
    ...mapState('student', {
      student: ({ curriculum, grade, position, stopAndReviewWeek }) => ({
        curriculum,
        grade: typeof grade === 'string' ? 0 : grade,
        position,
        stopAndReviewWeek
      })
    }),

    curriculumComplete() {
      const {
        student: {
          position: { last: { progress: { curriculum: { position, total } = {} } = {} } = {} } = {}
        }
      } = this;

      return position && total && position === total;
    },

    stopAndReviewPoint() {
      const {
        student: { stopAndReviewWeek = 0 }
      } = this;

      // no sense in displaying the last stop sign
      if (stopAndReviewWeek) {
        return {
          week: stopAndReviewWeek,
          x: this.stopPoints[stopAndReviewWeek - 1][0],
          y: this.stopPoints[stopAndReviewWeek - 1][1]
        };
      }

      return null;
    }
  },

  mounted() {
    if (this.kwtMode === 'tester') return;

    const {
      grade,
      curriculum,
      position: { next: nextPosition }
    } = this.student;

    // set vars
    this.spotCheckNums = curriculum.filter(activity => activity.spotCheck).map(({ week }) => week);
    this.productId = grade;
    this.pathBg = this.$refs.pathbg;

    const { asnStarts, weekThemes } = this.calculateWeekData();

    this.asnStarts = asnStarts;
    this.weekThemes = weekThemes;
    this.pathBg.style.fill = this.bgColors[this.productId];
    this.finalASN = asnStarts[asnStarts.length - 1];
    this.lastCompleteASN = nextPosition.progress.curriculum.position;

    const { nextWeek: completeWeek, percentage } = this.determineProgressDistance();

    this.calcSpotChecks();

    for (let j = 0; j < 36; j++) {
      const isWeekCompleted = j + 1 < completeWeek;
      const isWeekPartiallyCompleted = j + 1 === completeWeek && percentage > 0;

      // animate path
      if (isWeekCompleted) {
        this.animatePath(j + 1, 1);
      }

      // animate partial path if there is progress, nothing happens if first activity of the week
      if (isWeekPartiallyCompleted) {
        this.animatePath(completeWeek, percentage);
      }

      this.spotCheckList.forEach(spotCheck => {
        if (j + 1 === spotCheck.week) {
          this.insertSpotCheckIntoWeeklyMapItem(spotCheck, j);
        }
      });

      // set icon for week
      const isWeekComplete = j + 1 < completeWeek;
      this.setIcon(this.weekThemes[j], j, isWeekComplete);
    }

    this.setStopAndReview();
  },

  methods: {
    ...mapMutations('application', ['setModal']),

    animatePath(weekNumber, amount) {
      const path = document.querySelector(`.week${weekNumber.toString()}`);

      // get week color
      const weekColor = getThemeColor(this.weekThemes[weekNumber - 1]);
      TweenMax.set(path, { css: { stroke: weekColor } });
      const length = path.getTotalLength() || 0;

      const strokeThisMuch = amount === undefined ? length : length * amount;
      path.style.strokeDasharray = `${length} ${length}`;
      path.style.strokeDashoffset = length;
      path.getBoundingClientRect();
      path.style.transition = 'stroke-dashoffset 0s linear';
      path.style.WebkitTransition = 'stroke-dashoffset 0s linear';

      // Animate to here
      path.style.strokeDashoffset = length - strokeThisMuch;
    },

    calcSpotChecks() {
      const {
        student: {
          position: { next: { week: nextWeek, asn: nextASN } = {} } = {},
          curriculum
        } = {},
        spotCheckPoints,
        curriculumComplete
      } = this;

      this.spotCheckList = this.spotCheckNums.map(weekNumber => {
        const icon = spotCheckPoints[weekNumber - 1];
        let completed = false;

        if (nextWeek > weekNumber) completed = true || curriculumComplete;

        if (nextWeek === weekNumber) {
          const foundSpotCheck = curriculum
            .filter(activity => activity.week === nextWeek)
            .filter(activity => activity.spotCheck);
          const spotCheckASN = foundSpotCheck ? foundSpotCheck[0].asn : 0;
          completed = nextASN > spotCheckASN || curriculumComplete;
        }

        return { icon, completed, week: weekNumber };
      });
    },

    calculateWeekData() {
      const {
        student: { curriculum }
      } = this;
      const weekData = uniqBy(curriculum, 'week').map(({ asn, theme: { id: themeId }, week }) => ({
        asn,
        themeId,
        week
      }));
      const asnStarts = weekData.map(({ asn }) => asn);
      const weekThemes = weekData.map(({ themeId }) => themeId);
      return { asnStarts, weekThemes };
    },

    closeModal() {
      this.setModal(undefined);
    },

    determineProgressDistance() {
      const { student: { position: { next: nextPosition } = {} } = {} } = this;

      const {
        progress: {
          curriculum: { position: nextASN, total: finalASN },
          week: { position: weekCompleted, total: weekTotal } = {}
        },
        week: nextWeek
      } = nextPosition;

      if (!weekCompleted && !weekTotal && nextASN === finalASN && nextWeek === 36) {
        return { nextWeek: 37, percentage: 1 };
      }

      if (nextASN === 0) return { nextWeek: 0, percentage: 0 };

      // divide activities complete for week by total activities for week
      const percentage = Number(((weekCompleted - 1) / weekTotal).toFixed(2));

      return { nextWeek, percentage };
    },

    getAwardIcon(awardName) {
      let returnIcon = '';
      switch (awardName) {
        case 'medal':
          returnIcon = iconAwardMedal;
          break;

        case 'cup':
          returnIcon = iconAwardCup;
          break;

        case 'ribbon':
          returnIcon = iconAwardRibbon;
          break;

        case 'star':
          returnIcon = iconAwardStar;
          break;

        case 'plaque':
          returnIcon = iconAwardPlaque;
          break;

        case 'shield':
          returnIcon = iconAwardShield;
          break;
        default:
          break;
      }

      return returnIcon;
    },

    insertSpotCheckIntoWeeklyMapItem(spotCheck, week) {
      const parentSpotCheckNode = document.createElement('div');
      parentSpotCheckNode.setAttribute('role', 'listitem');
      parentSpotCheckNode.style.position = 'relative';

      const childSpotCheckNode = document.createElement('div');
      const childSpanSpotCheckNode = document.createElement('span');
      childSpanSpotCheckNode.innerText = `Week ${spotCheck.week} spot check - ${
        spotCheck.completed ? 'Completed' : 'Not Complete'
      }`;
      childSpanSpotCheckNode.style.opacity = '0';

      childSpotCheckNode.setAttribute('class', 'spotCheckIcon');
      childSpotCheckNode.style.backgroundImage = `url('${
        spotCheck.completed ? this.spotCheckIconDone : this.spotCheckIcon
      }'), none`;
      childSpotCheckNode.style.backgroundPosition = 'center center';
      childSpotCheckNode.style.backgroundRepeat = 'no-repeat';
      childSpotCheckNode.style.backgroundSize = 'contain';
      childSpotCheckNode.style.height = '48px';
      childSpotCheckNode.style.left = `${spotCheck.icon[0] - 30}px`;
      childSpotCheckNode.style.position = 'absolute';
      childSpotCheckNode.style.top = `${spotCheck.icon[1] - 30}px`;
      childSpotCheckNode.style.width = '48px';
      childSpotCheckNode.style.zIndex = 199;
      childSpotCheckNode.appendChild(childSpanSpotCheckNode);

      parentSpotCheckNode.insertBefore(childSpotCheckNode, null);

      const weeklyMapNode = document.getElementById(`weeklyMap`);
      const weeklyMapItemNode = document.getElementsByClassName(`weekIcon${week + 2}`)?.item(0);

      weeklyMapNode.insertBefore(parentSpotCheckNode, weeklyMapItemNode);
    },

    getDescription(weekNumber) {
      const { nextWeek: completeWeek, percentage } = this.determineProgressDistance();

      const isWeekCompleted = weekNumber < completeWeek;
      const isWeekPartiallyCompleted = weekNumber === completeWeek && percentage > 0;

      if (isWeekCompleted) return `Week ${weekNumber} activities - Completed`;

      if (isWeekPartiallyCompleted) return `Week ${weekNumber} activities - In Progress`;

      if (!isWeekCompleted && !isWeekPartiallyCompleted)
        return `Week ${weekNumber} activities - Not Completed`;
    },

    setIcon(theme, weekNumber, weekComplete) {
      // set icons
      let icon = '';
      switch (theme) {
        case 'JumpIntoKeyboarding':
          icon = iconJump;
          break;

        case 'LetsEat':
          icon = iconLetsEat;
          break;

        case 'OffToWork':
          icon = iconOffToWork;
          break;

        case 'OnTheGo':
          icon = iconOnGo;
          break;

        case 'WildAboutAnimals':
          icon = iconWildAboutAnimals;
          break;

        case 'LetsPlay':
          icon = iconLetsPlay;
          break;

        case 'StartMusic':
          icon = iconStartMusic;
          break;

        case 'MathMix':
          icon = iconMathMix;
          break;

        case 'SingPlay':
          icon = iconSingPlay;
          break;

        case 'FamousFaces':
          icon = iconPeoplePower;
          break;

        case 'GreekLatin':
          icon = iconGreekLatin;
          break;

        case 'BonesBodies':
          icon = iconBonesBodies;
          break;

        case 'GreatGrammar':
          icon = iconGreatGrammar;
          break;

        case 'OhLook':
          icon = iconOhLook;
          break;

        case 'GoGeography':
          icon = iconGoGeography;
          break;

        case 'WordsWriters':
          icon = iconWordsWriters;
          break;

        case 'SuperWords':
          icon = iconSuperWords;
          break;

        case 'PeoplePower':
          icon = iconPeoplePower;
          break;

        case 'WaterWater':
          icon = iconWaterWater;
          break;

        case 'ArtStart':
          icon = iconOhLook;
          break;
        default:
          break;
      }

      if (icon !== '') {
        const themeIcon = document.getElementsByClassName(`weekIcon${weekNumber + 1}`)[0];
        if (weekComplete === true) {
          const awardName = getAwardName(theme);
          const iconAward = this.getAwardIcon(awardName);
          // set to award icon
          themeIcon.style.backgroundImage = `url(${iconAward})`;
        } else {
          // set to theme icon
          themeIcon.style.backgroundImage = `url(${icon})`;
        }
      }
    },

    setStopAndReview() {
      const { stopAndReviewPoint } = this;

      this.showStopIcon = !!stopAndReviewPoint;

      if (stopAndReviewPoint) {
        const parentStartNode = document.createElement('div');
        parentStartNode.style.position = 'relative';

        const childStartNode = document.createElement('div');

        if (this.showStopIcon) childStartNode.style.display = 'inline';
        childStartNode.style.backgroundImage = `url(${this.stopIcon}), none`;
        childStartNode.style.backgroundPosition = 'center center';
        childStartNode.style.backgroundRepeat = 'no-repeat';
        childStartNode.style.backgroundSize = 'contain';
        childStartNode.style.height = '58px';
        childStartNode.style.left = `${stopAndReviewPoint.x}px`;
        childStartNode.style.position = 'absolute';
        childStartNode.style.top = `${stopAndReviewPoint.y}px`;
        childStartNode.style.width = '52px';
        childStartNode.style.zIndex = 99;

        const childStartContentNode = document.createElement('span');
        childStartContentNode.innerText = 'STOP';
        (childStartContentNode.style.backgroundColor = '#e4212d'),
          (childStartContentNode.style.color = 'white');
        childStartContentNode.style.fontSize = '15px';
        childStartContentNode.style.fontWeight = 'bold';
        childStartContentNode.style.left = '6px';
        childStartContentNode.style.position = 'absolute';
        childStartContentNode.style.top = '18px';
        childStartContentNode.style.textTransform = 'uppercase';

        childStartNode.insertBefore(childStartContentNode, null);
        parentStartNode.insertBefore(childStartNode, null);

        const weeklyMapNode = document.getElementById(`weeklyMap`);
        const weeklyMapItemNode =
          stopAndReviewPoint.week === 36
            ? null
            : document.getElementsByClassName(`weekIcon${stopAndReviewPoint.week}`)?.item(0);

        weeklyMapNode.insertBefore(parentStartNode, weeklyMapItemNode);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.weekIcons {
  position: relative;
}
.weekIcon {
  position: absolute;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 64px;
  height: 64px;
  z-index: 99;
}
.stop.show {
  display: inline;
}
.progressScreenContents svg {
  height: 768px;
}

.finish-text {
  fill: black;
}
.start-text {
  fill: white;
}
.text {
  font-weight: bold;
  font-size: 30px;
}
</style>
